import React from "react";

const IconEmptyPackageWithRocket = () => {
  return (
    <svg
      width="243"
      height="220"
      viewBox="0 0 243 220"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path
        opacity="0.45"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M80.5129 76.3672C79.8769 78.1333 79.4529 79.6115 79.1831 80.7058C78.6821 82.6831 78.6628 83.2398 78.7399 83.7197C78.9904 85.4859 80.3009 86.6953 81.0525 87.2712C80.8597 85.6586 80.7056 83.9501 80.6092 82.1264C80.4936 80.0914 80.4743 78.1525 80.5129 76.3672Z"
        fill="url(#pattern0_438_5922)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M80.2241 76.4069C79.6074 78.6529 78.798 80.9758 78.3933 83.2603C78.2776 83.913 78.5089 84.3545 78.875 84.892C79.4532 85.7943 80.1277 86.639 80.86 87.4453C81.0527 87.6564 81.3611 87.3493 81.1684 87.1381C80.4746 86.3702 79.8194 85.5447 79.2605 84.6809C78.6823 83.7786 78.9136 83.0107 79.1834 82.0317C79.6652 80.1887 80.1662 78.3458 80.6673 76.5221C80.7251 76.2533 80.3011 76.1381 80.2241 76.4069Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M121.292 66.268C121.292 67.0935 121.099 67.8805 120.694 68.61C120.559 68.8596 120.926 69.0708 121.061 68.8212C121.504 68.0341 121.716 67.1702 121.716 66.268C121.735 65.9992 121.292 65.9992 121.292 66.268Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M120.598 68.7844C122.487 70.9921 122.468 74.8507 121.639 77.4807C120.81 80.0723 118.864 82.2416 116.204 83.0095C115.935 83.0863 116.05 83.5086 116.32 83.4319C119.114 82.6064 121.196 80.3411 122.063 77.5959C122.949 74.7931 122.93 70.8193 120.926 68.4772C120.733 68.2661 120.425 68.5732 120.598 68.7844Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.84 82.9115C116.108 84.7737 115.221 86.559 114.2 88.2868C113.333 89.7457 112.195 91.1087 111.791 92.7981C111.733 93.0669 112.138 93.182 112.215 92.9133C112.658 91.0704 114.007 89.5346 114.932 87.9028C115.819 86.3478 116.589 84.7161 117.264 83.0459C117.36 82.7772 116.936 82.662 116.84 82.9115Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.1725 95.4104C93.2132 96.543 94.62 97.0997 96.0461 97.5796C97.7227 98.1556 99.4572 98.5971 101.211 98.8275C104.506 99.269 107.86 98.981 110.924 97.5988C111.174 97.4837 110.962 97.1189 110.712 97.2341C107.744 98.5779 104.468 98.8467 101.269 98.4051C99.7463 98.194 98.2431 97.8484 96.7784 97.3685C95.2174 96.8693 93.5986 96.3318 92.4616 95.084C92.3074 94.892 91.9991 95.1992 92.1725 95.4104Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.965 92.475C112.003 94.222 111.599 95.8537 110.732 97.3703C110.597 97.6199 110.963 97.831 111.098 97.5815C112.003 96.0073 112.427 94.2795 112.389 92.475C112.389 92.2062 111.965 92.2062 111.965 92.475Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.98 83.4491C104.102 84.0634 107.32 82.9692 109.401 80.5695C109.575 80.3584 109.286 80.0512 109.093 80.2624C107.127 82.5469 104.063 83.6027 101.095 83.0268C100.826 82.9692 100.71 83.3915 100.98 83.4491Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.931 55.0564C86.3528 54.3077 88.2607 54.0006 88.5305 54.0006C88.8774 54.0006 89.2436 54.0773 89.5712 54.1733C90.3613 54.4037 91.0744 54.9028 91.6525 55.4787C92.751 56.5538 93.4448 57.9552 93.8495 59.4334C94.3313 61.1611 94.3891 62.9657 94.312 64.751C94.2542 66.21 94.2542 68.0529 92.8859 68.9744C92.6547 69.128 92.8666 69.5119 93.0979 69.3391C94.6974 68.2449 94.6974 66.114 94.736 64.3862C94.7938 62.0442 94.5818 59.6253 93.5412 57.4944C92.7125 55.7859 91.2864 54.1541 89.3785 53.6934C88.6269 53.5014 87.7597 53.5206 87.0659 53.9046C86.5648 54.1733 86.1023 54.7492 86.507 55.2676C86.719 55.4979 87.0852 55.2868 86.931 55.0564Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M87.6822 54.1171C88.4723 53.714 89.301 53.426 90.1683 53.2725C90.4381 53.2341 90.3224 52.8117 90.0526 52.8501C89.1469 53.0037 88.2796 53.2917 87.451 53.7332C87.2197 53.8676 87.4317 54.2323 87.6822 54.1171Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.9669 97.3114C97.8962 98.4633 100.98 99.0392 104.121 99.02C104.391 99.02 104.41 98.5784 104.121 98.5784C101.018 98.5976 97.9733 98.0217 95.0825 96.8891C94.832 96.7931 94.7164 97.2154 94.9669 97.3114Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.8175 98.0604C99.1879 98.9435 101.655 99.4618 104.199 99.5962C104.468 99.6154 104.468 99.1739 104.199 99.1547C101.712 99.0203 99.2843 98.502 96.9331 97.6189C96.6826 97.5613 96.567 97.9644 96.8175 98.0604Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.192 99.1335C102.174 99.2103 103.138 99.3063 104.121 99.3831C104.391 99.4023 104.391 98.98 104.121 98.9416C103.138 98.8648 102.174 98.7688 101.192 98.692C100.922 98.6728 100.922 99.1144 101.192 99.1335Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M102.792 95.3349C105.22 94.8357 107.455 93.8183 109.44 92.3593C109.652 92.1865 109.44 91.8218 109.228 91.9945C107.263 93.4343 105.066 94.4326 102.676 94.9317C102.406 94.9701 102.522 95.3733 102.792 95.3349Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M157.793 217.85C157.889 218.445 157.908 219.04 157.87 219.636C157.85 219.904 158.274 219.904 158.313 219.636C158.371 219.002 158.332 218.369 158.236 217.735C158.159 217.466 157.735 217.581 157.793 217.85Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M158.409 219.848C158.679 219.848 158.698 219.406 158.409 219.406C158.12 219.406 158.12 219.848 158.409 219.848Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.318 57.073C107.493 58.0905 109.016 58.4744 110.538 58.0905C110.808 58.0137 110.693 57.6106 110.423 57.6682C109.074 58.0137 107.686 57.6874 106.626 56.7659C106.433 56.5931 106.125 56.9003 106.318 57.073Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.874 58.6493C107.146 59.7435 108.823 60.0699 110.422 59.5132C110.692 59.4172 110.576 58.9948 110.306 59.0908C108.861 59.59 107.339 59.3212 106.182 58.3421C105.97 58.1694 105.662 58.4573 105.874 58.6493Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M110.5 58.0914C110.712 58.4562 110.634 58.8977 110.326 59.1665C110.114 59.3584 110.422 59.6656 110.634 59.4736C111.097 59.0705 111.193 58.3794 110.866 57.861C110.731 57.6307 110.365 57.861 110.5 58.0914Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.925 217.37C156.925 217.792 156.925 218.233 156.925 218.656C156.925 218.925 157.368 218.944 157.368 218.656C157.368 218.233 157.368 217.792 157.368 217.37C157.368 217.101 156.925 217.101 156.925 217.37Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M143.917 122.843C144.283 122.535 144.668 122.247 145.034 121.94C145.246 121.767 144.938 121.46 144.726 121.633C144.36 121.94 143.975 122.228 143.608 122.535C143.396 122.708 143.705 123.015 143.917 122.843Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.565 57.6106C104.95 57.9369 105.335 58.2633 105.721 58.5896C106.01 58.8392 106.415 58.4169 106.126 58.1865C105.74 57.8601 105.355 57.5338 104.969 57.2074C104.699 56.9579 104.295 57.361 104.565 57.6106Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.7356 68.0369C95.1017 68.0369 95.1017 67.4609 94.7356 67.4609C94.3694 67.4609 94.3694 68.0369 94.7356 68.0369Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.0078 66.7283C96.374 66.7283 96.374 66.1523 96.0078 66.1523C95.6224 66.1523 95.6224 66.7283 96.0078 66.7283Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.5234 70.7048C94.5427 70.7048 94.562 70.7048 94.5813 70.7048C94.7354 70.7048 94.8703 70.5704 94.8703 70.4169C94.8703 70.2633 94.7354 70.1289 94.5813 70.1289C94.562 70.1289 94.5427 70.1289 94.5234 70.1289C94.3693 70.1289 94.2344 70.2633 94.2344 70.4169C94.2344 70.5704 94.35 70.7048 94.5234 70.7048Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.3098 72.1228C93.6759 72.1228 93.6759 71.5469 93.3098 71.5469C92.9436 71.5469 92.9436 72.1228 93.3098 72.1228Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.7356 73.6033C95.1017 73.6033 95.1017 73.0273 94.7356 73.0273C94.3694 73.0273 94.3694 73.6033 94.7356 73.6033Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.3098 74.8103C93.6759 74.8103 93.6759 74.2344 93.3098 74.2344C92.9436 74.2344 92.9436 74.8103 93.3098 74.8103Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M95.0244 76.119C95.0244 76.0998 95.0244 76.0806 95.0244 76.0614C95.0244 75.9078 94.8895 75.7734 94.7354 75.7734C94.5812 75.7734 94.4463 75.9078 94.4463 76.0614C94.4463 76.0806 94.4463 76.0998 94.4463 76.119C94.4463 76.2726 94.5812 76.4069 94.7354 76.4069C94.8895 76.3877 95.0244 76.2726 95.0244 76.119Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.1037 74.8689C96.4699 74.8689 96.4699 74.293 96.1037 74.293C95.7376 74.293 95.7376 74.8689 96.1037 74.8689Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.3098 77.5954C93.6759 77.5954 93.6759 77.0195 93.3098 77.0195C92.9436 77.0195 92.9436 77.5954 93.3098 77.5954Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.6779 78.9587C95.0441 78.9587 95.0441 78.3828 94.6779 78.3828C94.3118 78.3828 94.3118 78.9587 94.6779 78.9587Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.2522 80.3767C93.6183 80.3767 93.6183 79.8008 93.2522 79.8008C92.886 79.8008 92.886 80.3767 93.2522 80.3767Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.1037 77.5954C96.4699 77.5954 96.4699 77.0195 96.1037 77.0195C95.7376 77.0195 95.7376 77.5954 96.1037 77.5954Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.549 75.5977C97.5298 75.5977 97.5105 75.5977 97.4912 75.5977C97.337 75.5977 97.2021 75.732 97.2021 75.8856C97.2021 76.0392 97.337 76.1736 97.4912 76.1736C97.5105 76.1736 97.5298 76.1736 97.549 76.1736C97.7032 76.1736 97.8381 76.0392 97.8381 75.8856C97.8188 75.732 97.7032 75.5977 97.549 75.5977Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.0332 74.5251C99.3994 74.5251 99.3994 73.9492 99.0332 73.9492C98.6478 73.9492 98.6478 74.5251 99.0332 74.5251Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.6838 73.5823C97.7031 73.5631 97.7224 73.5439 97.7416 73.5247C97.8573 73.4095 97.8573 73.2367 97.7416 73.1215C97.626 73.0064 97.4525 73.0064 97.3369 73.1215C97.3176 73.1407 97.2984 73.1599 97.2791 73.1791C97.1635 73.2943 97.1635 73.4671 97.2791 73.5823C97.3947 73.6975 97.5682 73.6975 97.6838 73.5823Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.1613 71.6641C96.1421 71.6641 96.1228 71.6641 96.1035 71.6641C95.9494 71.6641 95.8145 71.7984 95.8145 71.952C95.8145 72.1056 95.9494 72.24 96.1035 72.24C96.1228 72.24 96.1421 72.24 96.1613 72.24C96.3155 72.24 96.4504 72.1056 96.4504 71.952C96.4504 71.7984 96.3348 71.6641 96.1613 71.6641Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.1445 70.3583C97.1445 70.3775 97.1445 70.3967 97.1445 70.4159C97.1445 70.5694 97.2794 70.7038 97.4336 70.7038C97.5878 70.7038 97.7227 70.5694 97.7227 70.4159C97.7227 70.3967 97.7227 70.3775 97.7227 70.3583C97.7227 70.2047 97.5878 70.0703 97.4336 70.0703C97.2602 70.0895 97.1445 70.2047 97.1445 70.3583Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.917 72.24C99.2832 72.24 99.2832 71.6641 98.917 71.6641C98.5316 71.6641 98.5316 72.24 98.917 72.24Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.171 73.4861C100.19 73.4861 100.209 73.4861 100.229 73.4861C100.383 73.4861 100.518 73.3517 100.518 73.1981C100.518 73.0445 100.383 72.9102 100.229 72.9102C100.209 72.9102 100.19 72.9102 100.171 72.9102C100.017 72.9102 99.8818 73.0445 99.8818 73.1981C99.8818 73.3709 99.9975 73.4861 100.171 73.4861Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.712 72.0681C102.078 72.0681 102.078 71.4922 101.712 71.4922C101.346 71.4922 101.346 72.0681 101.712 72.0681Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.286 70.7595C100.652 70.7595 100.652 70.1836 100.286 70.1836C99.9007 70.1836 99.9007 70.7595 100.286 70.7595Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.0078 69.3962C96.374 69.3962 96.374 68.8203 96.0078 68.8203C95.6224 68.8203 95.6224 69.3962 96.0078 69.3962Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.6074 67.7478C97.9736 67.7478 97.9736 67.1719 97.6074 67.1719C97.222 67.1719 97.222 67.7478 97.6074 67.7478Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.917 69.3415C99.2832 69.3415 99.2832 68.7656 98.917 68.7656C98.5316 68.7656 98.5316 69.3415 98.917 69.3415Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.917 66.7283C99.2832 66.7283 99.2832 66.1523 98.917 66.1523C98.5316 66.1523 98.5316 66.7283 98.917 66.7283Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.113 67.8611C100.479 67.8611 100.479 67.2852 100.113 67.2852C99.7464 67.2852 99.7464 67.8611 100.113 67.8611Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.75 69.3792C101.769 69.36 101.789 69.3408 101.808 69.3216C101.924 69.2064 101.924 69.0336 101.808 68.9184C101.692 68.8032 101.519 68.8032 101.403 68.9184C101.384 68.9376 101.365 68.9568 101.346 68.976C101.23 69.0912 101.23 69.264 101.346 69.3792C101.442 69.4751 101.635 69.4751 101.75 69.3792Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.022 67.8611C103.388 67.8611 103.388 67.2852 103.022 67.2852C102.656 67.2852 102.656 67.8611 103.022 67.8611Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M102.001 66.326C102.001 66.3068 102.001 66.2876 102.001 66.2684C102.001 66.1148 101.866 65.9805 101.712 65.9805C101.558 65.9805 101.423 66.1148 101.423 66.2684C101.423 66.2876 101.423 66.3068 101.423 66.326C101.423 66.4796 101.558 66.614 101.712 66.614C101.866 66.614 102.001 66.4796 102.001 66.326Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.275 66.5564C104.641 66.5564 104.641 65.9805 104.275 65.9805C103.908 65.9805 103.908 66.5564 104.275 66.5564Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M102.906 65.1931C103.273 65.1931 103.273 64.6172 102.906 64.6172C102.54 64.6172 102.54 65.1931 102.906 65.1931Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.77 63.2539C101.75 63.2539 101.731 63.2539 101.712 63.2539C101.558 63.2539 101.423 63.3883 101.423 63.5419C101.423 63.6954 101.558 63.8298 101.712 63.8298C101.731 63.8298 101.75 63.8298 101.77 63.8298C101.924 63.8298 102.059 63.6954 102.059 63.5419C102.04 63.3883 101.924 63.2539 101.77 63.2539Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.286 65.1931C100.652 65.1931 100.652 64.6172 100.286 64.6172C99.9007 64.6172 99.9007 65.1931 100.286 65.1931Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.7803 64.9627C97.7803 64.9435 97.7803 64.9243 97.7803 64.9051C97.7803 64.7516 97.6454 64.6172 97.4912 64.6172C97.337 64.6172 97.2021 64.7516 97.2021 64.9051C97.2021 64.9243 97.2021 64.9435 97.2021 64.9627C97.2021 65.1163 97.337 65.2507 97.4912 65.2507C97.6454 65.2315 97.7803 65.1163 97.7803 64.9627Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M95.8154 63.37C95.8154 63.3892 95.8154 63.4084 95.8154 63.4276C95.8154 63.5812 95.9503 63.7155 96.1045 63.7155C96.2587 63.7155 96.3936 63.5812 96.3936 63.4276C96.3936 63.4084 96.3936 63.3892 96.3936 63.37C96.3936 63.2164 96.2587 63.082 96.1045 63.082C95.9503 63.082 95.8154 63.1972 95.8154 63.37Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.7354 64.6775C94.7546 64.6775 94.7739 64.6775 94.7932 64.6775C94.9474 64.6775 95.0823 64.5431 95.0823 64.3895C95.0823 64.2359 94.9474 64.1016 94.7932 64.1016C94.7739 64.1016 94.7546 64.1016 94.7354 64.1016C94.5812 64.1016 94.4463 64.2359 94.4463 64.3895C94.4656 64.5431 94.5812 64.6775 94.7354 64.6775Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.8518 62.4119C95.2179 62.4119 95.2179 61.8359 94.8518 61.8359C94.4856 61.8359 94.4856 62.4119 94.8518 62.4119Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.0078 60.99C96.0271 60.99 96.0464 60.99 96.0656 60.99C96.2198 60.99 96.3547 60.8556 96.3547 60.702C96.3547 60.5484 96.2198 60.4141 96.0656 60.4141C96.0464 60.4141 96.0271 60.4141 96.0078 60.4141C95.8537 60.4141 95.7188 60.5484 95.7188 60.702C95.7188 60.8556 95.8344 60.99 96.0078 60.99Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.5498 59.7244C97.916 59.7244 97.916 59.1484 97.5498 59.1484C97.1644 59.1484 97.1644 59.7244 97.5498 59.7244Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.9746 60.99C99.3408 60.99 99.3408 60.4141 98.9746 60.4141C98.5892 60.4141 98.5892 60.99 98.9746 60.99Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.4912 62.4119C97.8574 62.4119 97.8574 61.8359 97.4912 61.8359C97.1058 61.8359 97.1058 62.4119 97.4912 62.4119Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.571 63.5031C98.5903 63.4263 98.6288 63.3303 98.6481 63.2343C98.6866 63.2151 98.7252 63.1767 98.783 63.1575C98.8215 63.1575 98.8601 63.1575 98.8986 63.1575C98.9371 63.1767 98.9757 63.2151 99.0335 63.2343C99.0528 63.3303 99.0913 63.4263 99.1106 63.5223C99.1106 63.5223 99.1106 63.5223 99.1106 63.5031C99.1491 63.3495 99.0721 63.1767 98.9179 63.1575C98.7637 63.1191 98.6095 63.1959 98.571 63.3495C98.5324 63.5415 98.6673 63.7334 98.8793 63.7334C99.0913 63.7334 99.2262 63.5415 99.1877 63.3495C99.1491 63.1959 98.9757 63.0999 98.8408 63.1575C98.6095 63.1959 98.5324 63.3495 98.571 63.5031Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.17 62.5251C100.536 62.5251 100.536 61.9492 100.17 61.9492C99.804 61.9492 99.804 62.5251 100.17 62.5251Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.712 61.0837C102.078 61.0837 102.078 60.5078 101.712 60.5078C101.346 60.5078 101.346 61.0837 101.712 61.0837Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M102.906 62.2947C103.273 62.2947 103.273 61.7188 102.906 61.7188C102.54 61.7188 102.54 62.2947 102.906 62.2947Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.043 63.7165C104.409 63.7165 104.409 63.1406 104.043 63.1406C103.677 63.1406 103.677 63.7165 104.043 63.7165Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.68 60.8534C104.68 60.8342 104.68 60.815 104.68 60.7958C104.68 60.6422 104.545 60.5078 104.391 60.5078C104.236 60.5078 104.102 60.6422 104.102 60.7958C104.102 60.815 104.102 60.8342 104.102 60.8534C104.102 61.0069 104.236 61.1413 104.391 61.1413C104.545 61.1413 104.68 61.0261 104.68 60.8534Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.874 62.5251C106.24 62.5251 106.24 61.9492 105.874 61.9492C105.508 61.9492 105.508 62.5251 105.874 62.5251Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.069 63.7165C107.089 63.7165 107.108 63.7165 107.127 63.7165C107.281 63.7165 107.416 63.5822 107.416 63.4286C107.416 63.275 107.281 63.1406 107.127 63.1406C107.108 63.1406 107.089 63.1406 107.069 63.1406C106.915 63.1406 106.78 63.275 106.78 63.4286C106.8 63.5822 106.915 63.7165 107.069 63.7165Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.399 65.1931C108.766 65.1931 108.766 64.6172 108.399 64.6172C108.014 64.6172 108.014 65.1931 108.399 65.1931Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.106 64.9627C106.106 64.9435 106.106 64.9243 106.106 64.9051C106.106 64.7516 105.972 64.6172 105.817 64.6172C105.663 64.6172 105.528 64.7516 105.528 64.9051C105.528 64.9243 105.528 64.9435 105.528 64.9627C105.528 65.1163 105.663 65.2507 105.817 65.2507C105.972 65.2315 106.106 65.1163 106.106 64.9627Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.275 63.7712C104.295 63.7712 104.314 63.7712 104.333 63.7712C104.487 63.7712 104.622 63.6368 104.622 63.4833C104.622 63.3297 104.487 63.1953 104.333 63.1953C104.314 63.1953 104.295 63.1953 104.275 63.1953C104.121 63.1953 103.986 63.3297 103.986 63.4833C104.006 63.6368 104.121 63.7712 104.275 63.7712Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.993 66.4981C107.012 66.4981 107.031 66.4981 107.05 66.4981C107.205 66.5173 107.378 66.4597 107.397 66.3061C107.436 66.1718 107.359 65.9798 107.205 65.9606C107.185 65.9606 107.166 65.9606 107.147 65.9606C106.993 65.9414 106.819 65.999 106.8 66.1526C106.761 66.2677 106.838 66.4597 106.993 66.4981Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.881 67.5346C108.862 67.5154 108.843 67.4962 108.823 67.477C108.708 67.3618 108.534 67.3618 108.419 67.477C108.303 67.5922 108.303 67.765 108.419 67.8802C108.438 67.8994 108.457 67.9185 108.477 67.9377C108.592 68.0529 108.766 68.0529 108.881 67.9377C108.997 67.8418 108.997 67.6498 108.881 67.5346Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M110.288 66.3846C110.288 66.3654 110.288 66.3462 110.288 66.327C110.288 66.1734 110.153 66.0391 109.999 66.0391C109.845 66.0391 109.71 66.1734 109.71 66.327C109.71 66.3462 109.71 66.3654 109.71 66.3846C109.71 66.5382 109.845 66.6726 109.999 66.6726C110.153 66.6534 110.288 66.5382 110.288 66.3846Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.309 65.2517C111.675 65.2517 111.675 64.6758 111.309 64.6758C110.923 64.6758 110.923 65.2517 111.309 65.2517Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M112.735 63.8884C113.102 63.8884 113.102 63.3125 112.735 63.3125C112.35 63.3125 112.35 63.8884 112.735 63.8884Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.883 63.7712C110.249 63.7712 110.249 63.1953 109.883 63.1953C109.497 63.1953 109.497 63.7712 109.883 63.7712Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.611 62.3533C108.977 62.3533 108.977 61.7773 108.611 61.7773C108.244 61.7773 108.244 62.3533 108.611 62.3533Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.729 60.6059C109.709 60.6251 109.69 60.6443 109.671 60.6635C109.555 60.7787 109.555 60.9515 109.671 61.0667C109.786 61.1818 109.96 61.1818 110.075 61.0667C110.095 61.0475 110.114 61.0283 110.133 61.0091C110.249 60.8939 110.249 60.7211 110.133 60.6059C110.018 60.4907 109.844 60.4907 109.729 60.6059Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.012 60.99C107.378 60.99 107.378 60.4141 107.012 60.4141C106.646 60.4141 106.646 60.99 107.012 60.99Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.817 59.0898C105.797 59.0898 105.778 59.0898 105.759 59.0898C105.605 59.0898 105.47 59.2242 105.47 59.3778C105.47 59.5314 105.605 59.6658 105.759 59.6658C105.778 59.6658 105.797 59.6658 105.817 59.6658C105.971 59.6658 106.106 59.5314 106.106 59.3778C106.106 59.2242 105.99 59.0898 105.817 59.0898Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.6585 59.0498C94.5043 59.0882 94.408 59.2417 94.4272 59.3953C94.4465 59.5681 94.5814 59.6449 94.7356 59.6641C94.8898 59.6833 95.0247 59.5105 95.0247 59.3761C95.0247 59.2034 94.8898 59.1074 94.7356 59.0882C94.7356 59.0882 94.7356 59.0882 94.7163 59.0882C94.7934 59.1074 94.8512 59.1458 94.9283 59.165C94.9476 59.2034 94.9861 59.2417 95.0054 59.2993C95.0054 59.2993 95.0054 59.2993 95.0054 59.2801C95.0054 59.3377 95.0054 59.3761 95.0054 59.4337C95.0054 59.4529 94.9861 59.4721 94.9861 59.4721C94.9283 59.5105 94.8705 59.5681 94.8127 59.6065C94.8127 59.6065 94.8127 59.6065 94.832 59.6065C94.9861 59.5681 95.0825 59.3953 95.0247 59.2609C94.9669 59.1074 94.8127 59.0306 94.6585 59.0498Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.1613 58.5329C96.5275 58.5329 96.5275 57.957 96.1613 57.957C95.7952 57.957 95.7952 58.5329 96.1613 58.5329Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.6201 57.1111C94.6394 57.1111 94.6587 57.1111 94.6779 57.1111C94.8321 57.1111 94.967 56.9767 94.967 56.8231C94.967 56.6695 94.8321 56.5352 94.6779 56.5352C94.6587 56.5352 94.6394 56.5352 94.6201 56.5352C94.466 56.5352 94.3311 56.6695 94.3311 56.8231C94.3503 56.9767 94.466 57.1111 94.6201 57.1111Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.4826 55.865C93.8488 55.865 93.8488 55.2891 93.4826 55.2891C93.1165 55.2891 93.1165 55.865 93.4826 55.865Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.9092 81.6268C94.9092 81.6076 94.9092 81.5884 94.9092 81.5692C94.9092 81.4156 94.7743 81.2812 94.6201 81.2812C94.466 81.2812 94.3311 81.4156 94.3311 81.5692C94.3311 81.5884 94.3311 81.6076 94.3311 81.6268C94.3311 81.7804 94.466 81.9148 94.6201 81.9148C94.7936 81.9148 94.9092 81.7804 94.9092 81.6268Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.0654 80.3767C96.4316 80.3767 96.4316 79.8008 96.0654 79.8008C95.68 79.8008 95.68 80.3767 96.0654 80.3767Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.4912 78.9587C97.8574 78.9587 97.8574 78.3828 97.4912 78.3828C97.1058 78.3828 97.1058 78.9587 97.4912 78.9587Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.917 77.5954C99.2832 77.5954 99.2832 77.0195 98.917 77.0195C98.5316 77.0195 98.5316 77.5954 98.917 77.5954Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.575 76.0604C100.575 76.0412 100.575 76.022 100.575 76.0028C100.575 75.8492 100.44 75.7148 100.286 75.7148C100.132 75.7148 99.9971 75.8492 99.9971 76.0028C99.9971 76.022 99.9971 76.0412 99.9971 76.0604C99.9971 76.214 100.132 76.3484 100.286 76.3484C100.44 76.3292 100.575 76.214 100.575 76.0604Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.711 74.1211C101.673 74.1211 101.634 74.1211 101.596 74.1211C101.442 74.1211 101.307 74.2555 101.307 74.4091C101.307 74.5626 101.442 74.697 101.596 74.697C101.634 74.697 101.673 74.697 101.711 74.697C101.866 74.697 102 74.5626 102 74.4091C102 74.2555 101.866 74.1211 101.711 74.1211Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M102.849 73.4861C103.215 73.4861 103.215 72.9102 102.849 72.9102C102.483 72.9102 102.483 73.4861 102.849 73.4861Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.023 70.0117C103.003 70.0117 102.984 70.0117 102.965 70.0117C102.811 70.0117 102.676 70.1461 102.676 70.2997C102.676 70.4533 102.811 70.5876 102.965 70.5876C102.984 70.5876 103.003 70.5876 103.023 70.5876C103.177 70.5876 103.312 70.4533 103.312 70.2997C103.312 70.1461 103.177 70.0117 103.023 70.0117Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.603 72.0471C104.622 72.0279 104.641 72.0087 104.661 71.9895C104.776 71.8743 104.776 71.7016 104.661 71.5864C104.545 71.4712 104.371 71.4712 104.256 71.5864C104.237 71.6056 104.217 71.6248 104.198 71.644C104.082 71.7592 104.082 71.9319 104.198 72.0471C104.294 72.1623 104.487 72.1623 104.603 72.0471Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.933 70.5876C106.299 70.5876 106.299 70.0117 105.933 70.0117C105.567 70.0117 105.567 70.5876 105.933 70.5876Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.275 69.3415C104.641 69.3415 104.641 68.7656 104.275 68.7656C103.908 68.7656 103.908 69.3415 104.275 69.3415Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.759 67.9783C106.125 67.9783 106.125 67.4023 105.759 67.4023C105.393 67.4023 105.393 67.9783 105.759 67.9783Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.531 69.1112C107.531 69.092 107.531 69.0728 107.531 69.0536C107.531 68.9 107.396 68.7656 107.242 68.7656C107.088 68.7656 106.953 68.9 106.953 69.0536C106.953 69.0728 106.953 69.092 106.953 69.1112C106.953 69.2648 107.088 69.3991 107.242 69.3991C107.396 69.3991 107.531 69.2648 107.531 69.1112Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.941 69.2829C110.308 69.2829 110.308 68.707 109.941 68.707C109.556 68.707 109.556 69.2829 109.941 69.2829Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.457 70.0703C108.438 70.0703 108.419 70.0703 108.399 70.0703C108.245 70.0703 108.11 70.2047 108.11 70.3583C108.11 70.5118 108.245 70.6462 108.399 70.6462C108.419 70.6462 108.438 70.6462 108.457 70.6462C108.611 70.6462 108.746 70.5118 108.746 70.3583C108.727 70.2047 108.611 70.0703 108.457 70.0703Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.136 68.0915C111.502 68.0915 111.502 67.5156 111.136 67.5156C110.75 67.5156 110.75 68.0915 111.136 68.0915Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.082 66.2127C113.082 66.1935 113.082 66.1743 113.082 66.1551C113.082 66.0016 112.947 65.8672 112.793 65.8672C112.639 65.8672 112.504 66.0016 112.504 66.1551C112.504 66.1743 112.504 66.1935 112.504 66.2127C112.504 66.3663 112.639 66.5007 112.793 66.5007C112.947 66.5007 113.082 66.3663 113.082 66.2127Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M114.161 64.9626C114.528 64.9626 114.528 64.3867 114.161 64.3867C113.795 64.3867 113.795 64.9626 114.161 64.9626Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.251 62.3533C111.617 62.3533 111.617 61.7773 111.251 61.7773C110.866 61.7773 110.866 62.3533 111.251 62.3533Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.413 66.6736C115.779 66.6736 115.779 66.0977 115.413 66.0977C115.047 66.0977 115.047 66.6736 115.413 66.6736Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.956 65.3103C116.975 65.3103 116.995 65.3103 117.014 65.3103C117.168 65.3103 117.303 65.1759 117.303 65.0223C117.303 64.8688 117.168 64.7344 117.014 64.7344C116.995 64.7344 116.975 64.7344 116.956 64.7344C116.802 64.7344 116.667 64.8688 116.667 65.0223C116.667 65.1759 116.802 65.3103 116.956 65.3103Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M118.266 66.5564C118.632 66.5564 118.632 65.9805 118.266 65.9805C117.9 65.9805 117.9 66.5564 118.266 66.5564Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M119.789 67.844C119.809 67.8248 119.828 67.8056 119.847 67.7864C119.963 67.6712 119.963 67.4984 119.847 67.3833C119.731 67.2681 119.558 67.2681 119.442 67.3833C119.423 67.4025 119.404 67.4217 119.385 67.4409C119.269 67.556 119.269 67.7288 119.385 67.844C119.481 67.94 119.674 67.94 119.789 67.844Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M120.945 66.8454C120.965 66.8454 120.984 66.8454 121.003 66.8454C121.157 66.8454 121.292 66.7111 121.292 66.5575C121.292 66.4039 121.157 66.2695 121.003 66.2695C120.984 66.2695 120.965 66.2695 120.945 66.2695C120.791 66.2695 120.656 66.4039 120.656 66.5575C120.676 66.7111 120.791 66.8454 120.945 66.8454Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M120.906 69.3962C121.272 69.3962 121.272 68.8203 120.906 68.8203C120.521 68.8203 120.521 69.3962 120.906 69.3962Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M121.003 72.1228C121.022 72.1228 121.041 72.1228 121.061 72.1228C121.215 72.1228 121.35 71.9884 121.35 71.8348C121.35 71.6813 121.215 71.5469 121.061 71.5469C121.041 71.5469 121.022 71.5469 121.003 71.5469C120.849 71.5469 120.714 71.6813 120.714 71.8348C120.733 71.9884 120.849 72.1228 121.003 72.1228Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M121.061 74.8689C121.08 74.8689 121.099 74.8689 121.118 74.8689C121.273 74.8689 121.407 74.7345 121.407 74.5809C121.407 74.4273 121.273 74.293 121.118 74.293C121.099 74.293 121.08 74.293 121.061 74.293C120.906 74.293 120.771 74.4273 120.771 74.5809C120.791 74.7345 120.906 74.8689 121.061 74.8689Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M121.273 77.6135C121.292 77.5943 121.311 77.5751 121.33 77.5559C121.446 77.4408 121.446 77.268 121.33 77.1528C121.215 77.0376 121.041 77.0376 120.926 77.1528C120.907 77.172 120.887 77.1912 120.868 77.2104C120.752 77.3256 120.752 77.4983 120.868 77.6135C120.984 77.7287 121.157 77.7287 121.273 77.6135Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M122.159 73.4861C122.525 73.4861 122.525 72.9102 122.159 72.9102C121.774 72.9102 121.774 73.4861 122.159 73.4861Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M119.693 79.072C120.059 79.072 120.059 78.4961 119.693 78.4961C119.326 78.4961 119.326 79.072 119.693 79.072Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M118.266 80.4353C118.632 80.4353 118.632 79.8594 118.266 79.8594C117.9 79.8594 117.9 80.4353 118.266 80.4353Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.898 78.9001C117.264 78.9001 117.264 78.3242 116.898 78.3242C116.532 78.3242 116.532 78.9001 116.898 78.9001Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M118.324 77.0195C118.305 77.0195 118.286 77.0195 118.267 77.0195C118.112 77.0195 117.978 77.1539 117.978 77.3075C117.978 77.4611 118.112 77.5954 118.267 77.5954C118.286 77.5954 118.305 77.5954 118.324 77.5954C118.479 77.5954 118.614 77.4611 118.614 77.3075C118.614 77.1539 118.498 77.0195 118.324 77.0195Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M119.981 75.9432C119.981 75.924 119.981 75.9048 119.981 75.8856C119.981 75.732 119.847 75.5977 119.692 75.5977C119.538 75.5977 119.403 75.732 119.403 75.8856C119.403 75.9048 119.403 75.924 119.403 75.9432C119.403 76.0968 119.538 76.2312 119.692 76.2312C119.847 76.212 119.981 76.0968 119.981 75.9432Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.898 76.1189C117.264 76.1189 117.264 75.543 116.898 75.543C116.532 75.543 116.532 76.1189 116.898 76.1189Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M118.324 74.1797C118.305 74.1797 118.286 74.1797 118.267 74.1797C118.112 74.1797 117.978 74.3141 117.978 74.4676C117.978 74.6212 118.112 74.7556 118.267 74.7556C118.286 74.7556 118.305 74.7556 118.324 74.7556C118.479 74.7556 118.614 74.6212 118.614 74.4676C118.614 74.2949 118.498 74.1797 118.324 74.1797Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M119.808 73.4314C120.174 73.4314 120.174 72.8555 119.808 72.8555C119.442 72.8555 119.442 73.4314 119.808 73.4314Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.898 73.4861C117.264 73.4861 117.264 72.9102 116.898 72.9102C116.532 72.9102 116.532 73.4861 116.898 73.4861Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M118.324 72.1228C118.691 72.1228 118.691 71.5469 118.324 71.5469C117.958 71.5469 117.958 72.1228 118.324 72.1228Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M119.75 70.7595C120.116 70.7595 120.116 70.1836 119.75 70.1836C119.384 70.1836 119.384 70.7595 119.75 70.7595Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M118.208 69.3415C118.574 69.3415 118.574 68.7656 118.208 68.7656C117.842 68.7656 117.842 69.3415 118.208 69.3415Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.956 70.0703C116.937 70.0703 116.918 70.0703 116.898 70.0703C116.744 70.0703 116.609 70.2047 116.609 70.3583C116.609 70.5118 116.744 70.6462 116.898 70.6462C116.918 70.6462 116.937 70.6462 116.956 70.6462C117.11 70.6462 117.245 70.5118 117.245 70.3583C117.245 70.2047 117.11 70.0703 116.956 70.0703Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.472 72.1228C115.491 72.1228 115.51 72.1228 115.53 72.1228C115.684 72.1228 115.819 71.9884 115.819 71.8348C115.819 71.6813 115.684 71.5469 115.53 71.5469C115.51 71.5469 115.491 71.5469 115.472 71.5469C115.318 71.5469 115.183 71.6813 115.183 71.8348C115.183 71.9884 115.318 72.1228 115.472 72.1228Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.872 70.3385C113.872 70.3577 113.872 70.3769 113.853 70.3961C113.834 70.5496 113.892 70.7224 114.046 70.7416C114.181 70.78 114.374 70.7032 114.393 70.5496C114.393 70.5304 114.393 70.5112 114.412 70.4921C114.431 70.3385 114.374 70.1657 114.219 70.1465C114.084 70.1081 113.911 70.1849 113.872 70.3385Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.53 69.3415C115.896 69.3415 115.896 68.7656 115.53 68.7656C115.163 68.7656 115.163 69.3415 115.53 69.3415Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.782 68.0915C117.149 68.0915 117.149 67.5156 116.782 67.5156C116.416 67.5156 116.416 68.0915 116.782 68.0915Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M114.161 67.3438C114.142 67.3438 114.123 67.3438 114.104 67.3438C113.949 67.3438 113.814 67.4781 113.814 67.6317C113.814 67.7853 113.949 67.9197 114.104 67.9197C114.123 67.9197 114.142 67.9197 114.161 67.9197C114.316 67.9197 114.45 67.7853 114.45 67.6317C114.431 67.4781 114.316 67.3438 114.161 67.3438Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M112.563 69.3415C112.582 69.3415 112.601 69.3415 112.62 69.3415C112.774 69.3415 112.909 69.2072 112.909 69.0536C112.909 68.9 112.774 68.7656 112.62 68.7656C112.601 68.7656 112.582 68.7656 112.563 68.7656C112.408 68.7656 112.273 68.9 112.273 69.0536C112.273 69.2072 112.389 69.3415 112.563 69.3415Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.02 70.4169C111.02 70.4361 111.02 70.4553 111.02 70.4745C111.02 70.628 111.154 70.7624 111.309 70.7624C111.463 70.7624 111.598 70.628 111.598 70.4745C111.598 70.4553 111.598 70.4361 111.598 70.4169C111.598 70.2633 111.463 70.1289 111.309 70.1289C111.154 70.1481 111.02 70.2633 111.02 70.4169Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.024 71.8924C113.024 71.8732 113.024 71.854 113.024 71.8348C113.024 71.6813 112.89 71.5469 112.735 71.5469C112.581 71.5469 112.446 71.6813 112.446 71.8348C112.446 71.854 112.446 71.8732 112.446 71.8924C112.446 72.046 112.581 72.1804 112.735 72.1804C112.89 72.1804 113.024 72.0652 113.024 71.8924Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M114.104 73.6033C114.47 73.6033 114.47 73.0273 114.104 73.0273C113.738 73.0273 113.738 73.6033 114.104 73.6033Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.472 74.9275C115.838 74.9275 115.838 74.3516 115.472 74.3516C115.106 74.3516 115.106 74.9275 115.472 74.9275Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.26 77.0395C115.241 77.0587 115.221 77.0779 115.202 77.0971C115.086 77.2123 115.086 77.3851 115.202 77.5002C115.318 77.6154 115.491 77.6154 115.607 77.5002C115.626 77.481 115.645 77.4618 115.664 77.4427C115.78 77.3275 115.78 77.1547 115.664 77.0395C115.568 76.9243 115.375 76.9243 115.26 77.0395Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M114.393 76.0604C114.393 76.0412 114.393 76.022 114.393 76.0028C114.393 75.8492 114.258 75.7148 114.104 75.7148C113.949 75.7148 113.814 75.8492 113.814 76.0028C113.814 76.022 113.814 76.0412 113.814 76.0604C113.814 76.214 113.949 76.3484 114.104 76.3484C114.258 76.3292 114.393 76.214 114.393 76.0604Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M112.389 74.6786C112.389 74.6978 112.389 74.717 112.389 74.7362C112.389 74.8898 112.524 75.0241 112.678 75.0241C112.832 75.0241 112.967 74.8898 112.967 74.7362C112.967 74.717 112.967 74.6978 112.967 74.6786C112.967 74.525 112.832 74.3906 112.678 74.3906C112.524 74.4098 112.389 74.525 112.389 74.6786Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.598 73.3143C111.598 73.2951 111.598 73.2759 111.598 73.2567C111.598 73.1031 111.463 72.9688 111.309 72.9688C111.154 72.9688 111.02 73.1031 111.02 73.2567C111.02 73.2759 111.02 73.2951 111.02 73.3143C111.02 73.4679 111.154 73.6023 111.309 73.6023C111.463 73.6023 111.598 73.4871 111.598 73.3143Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.941 72.1814C110.308 72.1814 110.308 71.6055 109.941 71.6055C109.556 71.6055 109.556 72.1814 109.941 72.1814Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.07 72.1228C107.436 72.1228 107.436 71.5469 107.07 71.5469C106.703 71.5469 106.703 72.1228 107.07 72.1228Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.495 73.0273C108.476 73.0273 108.457 73.0273 108.438 73.0273C108.283 73.0273 108.148 73.1617 108.148 73.3153C108.148 73.4689 108.283 73.6033 108.438 73.6033C108.457 73.6033 108.476 73.6033 108.495 73.6033C108.65 73.6033 108.784 73.4689 108.784 73.3153C108.784 73.1617 108.669 73.0273 108.495 73.0273Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M110.037 74.9275C110.403 74.9275 110.403 74.3516 110.037 74.3516C109.671 74.3516 109.671 74.9275 110.037 74.9275Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.232 75.7345C111.27 75.7345 111.328 75.7345 111.367 75.7345C111.424 75.7729 111.482 75.8305 111.54 75.8689C111.559 75.9265 111.559 75.9649 111.579 76.0225C111.579 75.9649 111.559 76.0033 111.559 76.1185C111.521 76.1569 111.482 76.1952 111.463 76.2144C111.386 76.2336 111.309 76.2336 111.232 76.2528C111.232 76.2528 111.232 76.2528 111.251 76.2528C111.212 76.2336 111.174 76.1952 111.116 76.1761L111.097 76.1569C111.077 76.0993 111.077 76.0609 111.058 76.0033C111.058 75.9841 111.077 75.9649 111.077 75.9457C111.155 75.9073 111.251 75.8497 111.328 75.8113H111.309C111.367 75.8305 111.405 75.8305 111.463 75.8497C111.501 75.9265 111.521 76.0033 111.559 76.0993C111.54 76.1377 111.501 76.176 111.482 76.2336C111.463 76.2336 111.463 76.2528 111.444 76.2528C111.386 76.272 111.347 76.272 111.289 76.2912C111.251 76.2912 111.232 76.272 111.193 76.272C111.155 76.2336 111.116 76.1952 111.097 76.1761C111.097 76.1569 111.097 76.1569 111.077 76.1377C111.077 76.0801 111.077 76.0417 111.077 75.9841V76.0033C111.135 75.9457 111.212 75.8689 111.27 75.8113C111.482 75.8113 111.559 75.9073 111.501 76.0993C111.386 76.1377 111.289 76.1952 111.174 76.2336C111.077 76.1952 111.058 76.1185 111.058 76.0033C111.174 75.9457 111.289 75.8689 111.405 75.8113C111.424 75.8305 111.463 75.8497 111.482 75.8689C111.501 75.9265 111.501 75.9649 111.521 76.0225C111.521 76.0417 111.521 76.0417 111.521 76.0609C111.501 76.0993 111.463 76.1377 111.444 76.1952C111.328 76.1952 111.232 76.1952 111.116 76.1952C111.097 76.1569 111.058 76.1185 111.039 76.0609C111.039 76.0609 111.039 76.0609 111.039 76.0801C111.039 76.0225 111.039 75.9841 111.039 75.9265C111.039 75.9265 111.039 75.9265 111.039 75.9457C110.981 76.0801 111.097 76.272 111.232 76.2912C111.386 76.3296 111.54 76.2336 111.579 76.0993C111.675 75.8113 111.328 75.6001 111.077 75.7345C110.943 75.8113 110.904 75.9649 110.923 76.0993C110.962 76.2336 111.097 76.3296 111.232 76.368C111.367 76.4064 111.559 76.3296 111.579 76.1761C111.617 75.9649 111.521 75.7345 111.289 75.6961C111.155 75.6769 111.039 75.7153 110.962 75.8305C110.885 75.9649 110.885 76.1185 110.981 76.2336C111.077 76.368 111.232 76.4256 111.405 76.3872C111.501 76.368 111.598 76.272 111.598 76.1952C111.617 76.0417 111.579 75.8881 111.444 75.8113C111.309 75.7345 111.097 75.7729 111 75.9073C110.904 76.0417 110.904 76.1952 111 76.3296C111.116 76.464 111.347 76.5216 111.482 76.3872C111.598 76.272 111.617 76.0993 111.559 75.9649C111.482 75.8113 111.289 75.7345 111.135 75.8305C111.02 75.9073 110.962 76.0225 110.981 76.1569C111 76.3296 111.193 76.464 111.367 76.4064C111.501 76.3488 111.617 76.2144 111.559 76.0609C111.559 75.7921 111.386 75.6769 111.232 75.7345Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M112.87 77.2691C112.87 77.2499 112.87 77.2499 112.87 77.2691C112.889 77.3266 112.909 77.4034 112.947 77.461V77.4418C112.928 77.4994 112.928 77.5378 112.909 77.5954C112.909 77.6146 112.889 77.6146 112.889 77.6338C112.812 77.653 112.754 77.6914 112.677 77.7106C112.677 77.7106 112.677 77.7106 112.697 77.7106C112.62 77.6914 112.562 77.653 112.485 77.6338C112.485 77.6338 112.485 77.6338 112.504 77.653C112.485 77.5762 112.446 77.5186 112.427 77.4418C112.427 77.4226 112.427 77.4034 112.427 77.4034C112.446 77.365 112.485 77.3266 112.504 77.2691C112.504 77.2691 112.504 77.2691 112.485 77.2691C112.562 77.2499 112.62 77.2115 112.697 77.1923C112.697 77.1923 112.697 77.1923 112.677 77.1923C112.754 77.2115 112.812 77.2307 112.87 77.2691C112.909 77.3075 112.928 77.365 112.909 77.4226C112.889 77.5186 112.812 77.557 112.716 77.5762C112.658 77.557 112.62 77.557 112.562 77.5378C112.581 77.4034 112.6 77.2691 112.62 77.1347C112.735 77.1731 112.832 77.2307 112.947 77.2691C112.947 77.2883 112.966 77.2883 112.966 77.3075C112.966 77.365 112.966 77.4034 112.966 77.461C112.966 77.4802 112.947 77.4802 112.947 77.4994C112.909 77.5378 112.87 77.5762 112.851 77.5954C112.832 77.5954 112.832 77.6146 112.812 77.6146C112.754 77.6146 112.716 77.6146 112.658 77.6146H112.677C112.639 77.5954 112.6 77.557 112.542 77.5378C112.542 77.5378 112.542 77.5378 112.562 77.557C112.542 77.5186 112.504 77.4802 112.485 77.4226C112.485 77.3842 112.485 77.3458 112.485 77.3266C112.504 77.2883 112.542 77.2499 112.562 77.1923C112.562 77.1923 112.562 77.1923 112.542 77.2115C112.427 77.3266 112.427 77.4994 112.542 77.6146C112.658 77.7298 112.832 77.7298 112.947 77.6146C113.14 77.4226 113.044 77.0771 112.754 77.0387C112.504 77.0003 112.273 77.3266 112.427 77.5378C112.504 77.653 112.62 77.6914 112.754 77.6722C113.082 77.6146 113.101 77.1155 112.812 77.0003C112.504 76.8851 112.253 77.2115 112.33 77.4994C112.369 77.653 112.523 77.7682 112.697 77.749C112.889 77.7298 112.986 77.5378 112.947 77.3458C112.889 77.1155 112.6 77.0579 112.446 77.2115C112.311 77.3458 112.311 77.5378 112.446 77.6722C112.542 77.7874 112.754 77.7682 112.851 77.6722C113.005 77.557 112.986 77.3842 112.87 77.2691Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M114.276 78.7855V78.8047C114.276 78.7855 114.276 78.7663 114.276 78.7855C114.257 78.8047 114.257 78.8239 114.238 78.8431C114.084 78.7663 113.949 78.6703 113.795 78.5935C113.795 78.6319 113.795 78.6895 113.814 78.7279C113.833 78.8815 113.93 79.0159 114.103 79.0159C114.238 79.0159 114.411 78.8815 114.392 78.7279C114.392 78.6895 114.392 78.6319 114.373 78.5935C114.353 78.4976 114.315 78.4016 114.238 78.344C114.161 78.2864 114.026 78.2864 113.949 78.344C113.795 78.4592 113.698 78.5935 113.698 78.7855C113.698 78.9391 113.833 79.0735 113.987 79.0735C114.141 79.0543 114.276 78.9391 114.276 78.7855Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.549 79.9001C115.568 79.9193 115.607 79.9384 115.626 79.9384C115.646 79.9768 115.684 80.0152 115.703 80.0728C115.703 80.1112 115.703 80.1304 115.703 80.1688C115.684 80.2072 115.646 80.2456 115.626 80.3032C115.626 80.3032 115.626 80.3032 115.646 80.284C115.607 80.3032 115.568 80.3416 115.511 80.3608C115.453 80.3608 115.414 80.3416 115.356 80.3416C115.318 80.3032 115.279 80.2648 115.26 80.2456C115.26 80.2456 115.26 80.2648 115.279 80.2648C115.376 80.3992 115.53 80.4568 115.684 80.3608C115.819 80.284 115.877 80.092 115.78 79.9576C115.646 79.7657 115.356 79.7081 115.202 79.9193C115.067 80.1112 115.164 80.4184 115.395 80.4568C115.549 80.476 115.723 80.4184 115.742 80.2648C115.78 80.1112 115.703 79.9193 115.549 79.9001Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M117.207 81.4347C117.072 81.2043 116.725 81.2235 116.609 81.4731C116.551 81.6074 116.59 81.761 116.706 81.8378C116.821 81.9338 116.956 81.9338 117.072 81.857C117.264 81.761 117.245 81.4539 117.072 81.3579C117.168 81.4347 117.187 81.5115 117.149 81.6074C117.014 81.6458 116.879 81.6842 116.744 81.7034C116.744 81.7034 116.744 81.7034 116.763 81.7226C116.725 81.6842 116.686 81.6458 116.667 81.6266V81.6458C116.648 81.5882 116.648 81.5499 116.628 81.4923C116.628 81.4731 116.628 81.4731 116.628 81.4539C116.648 81.4155 116.686 81.3771 116.706 81.3195C116.706 81.3195 116.706 81.3195 116.686 81.3387C116.725 81.3195 116.763 81.2811 116.821 81.2619H116.802C116.86 81.2619 116.898 81.2619 116.956 81.2619H116.937C116.975 81.2811 117.014 81.3195 117.072 81.3387L117.052 81.3195C117.072 81.3579 117.11 81.3963 117.13 81.4539V81.4347C117.091 81.2811 116.918 81.1851 116.783 81.2427C116.628 81.2811 116.551 81.4347 116.59 81.5882C116.628 81.8378 116.956 81.9146 117.13 81.761C117.303 81.6074 117.245 81.3579 117.072 81.2427C116.937 81.1467 116.763 81.2235 116.667 81.3387C116.551 81.5115 116.628 81.761 116.802 81.8762C116.802 81.7034 116.802 81.5499 116.802 81.3771H116.783C116.84 81.3579 116.879 81.3579 116.937 81.3387H116.918C116.975 81.3579 117.014 81.3579 117.072 81.3771C117.072 81.3771 117.052 81.3771 117.052 81.3579C117.091 81.3963 117.13 81.4347 117.149 81.4539C117.149 81.4539 117.149 81.4347 117.13 81.4347C117.149 81.4923 117.149 81.5307 117.168 81.5882V81.569C117.149 81.6266 117.149 81.665 117.13 81.7226C117.13 81.7226 117.13 81.7226 117.13 81.7034C117.091 81.7418 117.052 81.7802 117.033 81.7994C117.014 81.7994 117.014 81.8186 116.995 81.8186C116.937 81.8186 116.898 81.8186 116.84 81.8186C116.821 81.8186 116.821 81.7994 116.802 81.7994C116.763 81.761 116.725 81.7226 116.706 81.7034C116.706 81.7034 116.706 81.7034 116.706 81.7226C116.783 81.857 116.975 81.8954 117.11 81.8186C117.245 81.7418 117.284 81.569 117.207 81.4347Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.317 82.7397C115.356 82.7205 115.394 82.7013 115.433 82.6821C115.529 82.7397 115.606 82.7781 115.702 82.8357C115.702 82.8933 115.702 82.9317 115.702 82.9893C115.702 82.9509 115.722 82.9125 115.722 82.8933C115.702 82.9509 115.702 82.9893 115.683 83.0469C115.625 83.0852 115.568 83.1428 115.51 83.1812C115.433 83.162 115.356 83.1428 115.278 83.1236C115.259 83.0852 115.221 83.0469 115.201 82.9893C115.221 82.9125 115.221 82.8357 115.24 82.7589C115.24 82.7589 115.24 82.7589 115.24 82.7781C115.163 82.9125 115.221 83.1044 115.336 83.1812C115.471 83.258 115.645 83.2004 115.741 83.0852C115.837 82.9317 115.76 82.7397 115.625 82.6629C115.471 82.5669 115.24 82.6437 115.182 82.8165C115.163 82.8357 115.144 82.9893 115.163 82.8741C115.163 82.9317 115.144 82.9701 115.163 83.0277C115.182 83.1044 115.221 83.162 115.298 83.2196C115.433 83.3348 115.625 83.3156 115.76 83.2004C115.876 83.0852 115.876 82.8933 115.76 82.7973C115.625 82.6245 115.433 82.6245 115.317 82.7397Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.607 85.9283C115.646 85.8899 115.665 85.8515 115.704 85.8131C115.53 85.7939 115.357 85.7747 115.183 85.7363C115.203 85.8323 115.183 85.7555 115.183 85.7555C115.299 85.6979 115.414 85.6211 115.53 85.5635H115.511C115.569 85.5827 115.607 85.6019 115.626 85.6595C115.646 85.6979 115.665 85.7171 115.646 85.6979C115.646 85.6787 115.646 85.6787 115.646 85.7363C115.646 85.7555 115.626 85.7939 115.646 85.7555C115.626 85.8323 115.569 85.8707 115.453 85.8899C115.607 85.8707 115.742 85.7747 115.742 85.6019C115.742 85.4675 115.607 85.2948 115.453 85.314C115.241 85.3332 115.068 85.4867 115.068 85.7171C115.068 85.9091 115.183 86.1011 115.376 86.1395C115.53 86.1778 115.684 86.1011 115.723 85.9475C115.761 85.8323 115.761 85.7363 115.723 85.6211C115.684 85.5059 115.607 85.4292 115.492 85.41C115.376 85.3908 115.28 85.4484 115.203 85.5443C115.164 85.5827 115.145 85.6211 115.106 85.6595C115.01 85.7747 115.087 85.9859 115.203 86.0627C115.376 86.1203 115.53 86.0627 115.607 85.9283Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M114.239 84.0844C114.201 84.0652 114.201 84.0652 114.239 84.0844C114.278 84.1228 114.316 84.1612 114.335 84.1804C114.335 84.238 114.335 84.3148 114.335 84.3723C114.297 84.4107 114.258 84.4491 114.239 84.4683C114.239 84.4683 114.258 84.4683 114.258 84.4491C114.393 84.3531 114.451 84.1996 114.355 84.046C114.278 83.9116 114.085 83.854 113.95 83.95C113.815 84.046 113.738 84.1804 113.777 84.334C113.815 84.4875 113.931 84.5451 114.066 84.6027C114.2 84.6603 114.393 84.5451 114.412 84.4107C114.47 84.2764 114.393 84.1228 114.239 84.0844Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M112.928 88.4808C112.909 88.4424 112.89 88.404 112.87 88.3656C112.793 88.2312 112.601 88.1928 112.466 88.2696C112.331 88.3464 112.292 88.5192 112.369 88.6727C112.389 88.7111 112.408 88.7495 112.427 88.7879C112.504 88.9223 112.697 88.9607 112.832 88.8839C112.967 88.7879 113.005 88.6152 112.928 88.4808Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M114.161 87.2319C114.18 87.2127 114.18 87.2127 114.161 87.2319C114.142 87.2511 114.103 87.2895 114.065 87.3279C113.968 87.4047 114.026 86.944 113.949 86.9248C114.026 86.944 114.084 86.9824 114.161 87.0016C114.18 87.0207 114.18 87.0207 114.2 87.0399C114.219 87.0975 114.219 87.1359 114.238 87.1935C114.238 87.1551 114.238 87.1743 114.238 87.2319C114.219 87.2703 114.18 87.3087 114.161 87.3663C114.142 87.3855 114.142 87.3855 114.123 87.4047C114.046 87.4239 113.968 87.4239 113.891 87.4431C113.891 87.4431 113.891 87.4431 113.911 87.4431C114.065 87.4623 114.238 87.4047 114.258 87.2511C114.296 87.1167 114.219 86.9248 114.065 86.9056C113.949 86.8864 113.834 86.9056 113.756 86.9824C113.679 87.0591 113.641 87.1935 113.679 87.3087C113.737 87.5391 114.046 87.5967 114.219 87.4623C114.392 87.3279 114.412 87.0591 114.258 86.9056C114.161 86.8288 114.046 86.7904 113.911 86.8096C113.795 86.8288 113.737 86.8864 113.679 86.9824C113.583 87.0975 113.66 87.3087 113.776 87.3855C113.93 87.4239 114.084 87.3471 114.161 87.2319Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M112.89 85.6767C113.025 85.8302 112.466 85.5807 112.485 85.7919C112.505 85.7151 112.505 85.6383 112.524 85.5615C112.736 85.4655 112.871 85.4847 112.89 85.6191C112.89 85.6383 112.89 85.6383 112.89 85.5999C112.832 85.6575 112.755 85.7343 112.697 85.7919C112.62 85.7535 112.582 85.6767 112.582 85.5615C112.639 85.4847 112.659 85.4655 112.62 85.5039C112.659 85.4847 112.697 85.4463 112.755 85.4271C112.794 85.4271 112.832 85.4271 112.851 85.4271C112.717 85.3887 112.524 85.4847 112.505 85.6191C112.466 85.7727 112.543 85.9262 112.697 85.9646C112.967 86.0606 113.218 85.7535 113.141 85.5039C113.063 85.2351 112.774 85.1775 112.524 85.2351C112.428 85.2543 112.35 85.3503 112.331 85.4271C112.273 85.6575 112.331 85.9262 112.582 86.003C112.832 86.0798 113.121 85.8686 113.025 85.5999C112.948 85.3503 112.62 85.2735 112.428 85.4463C112.235 85.6191 112.312 85.8686 112.447 86.0414C112.543 86.1566 112.755 86.1374 112.851 86.0414C113.006 85.9646 112.986 85.7919 112.89 85.6767Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M112.948 82.7768C112.986 82.8152 113.006 82.8536 113.006 82.9112C112.89 82.9688 112.774 83.0456 112.659 83.1032C112.504 83.0456 112.447 82.8344 112.601 82.7384C112.678 82.7192 112.755 82.7192 112.832 82.7C112.794 82.6808 112.813 82.6808 112.832 82.7C112.794 82.6616 112.851 82.7192 112.832 82.7C112.736 82.5656 112.582 82.5081 112.427 82.604C112.293 82.6808 112.235 82.8728 112.331 83.0072C112.485 83.2184 112.813 83.3911 113.006 83.1416C113.179 82.9304 113.063 82.6232 112.813 82.5465C112.659 82.4889 112.504 82.604 112.466 82.7384C112.408 82.892 112.466 83.0456 112.562 83.1608C112.659 83.2759 112.871 83.2567 112.967 83.1608C113.063 83.0648 113.044 82.892 112.948 82.7768Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M114.238 81.6087C114.199 81.6471 114.161 81.6663 114.103 81.6855C114.026 81.6663 113.968 81.6279 113.891 81.6087C113.949 81.4935 113.987 81.3591 114.045 81.244C114.141 81.3208 114.238 81.3783 114.315 81.4551V81.4359C114.315 81.4935 114.315 81.5319 114.315 81.5895C114.199 81.6855 114.18 81.7047 114.238 81.6855C114.18 81.7047 114.141 81.7047 114.084 81.7239C114.045 81.5895 114.007 81.4551 113.987 81.3208C113.852 81.3975 113.795 81.5703 113.891 81.7239C113.968 81.8583 114.161 81.9159 114.296 81.8199C114.527 81.6663 114.546 81.3208 114.296 81.1864C114.18 81.1288 114.026 81.1288 113.93 81.2056C113.795 81.3016 113.737 81.4551 113.775 81.6087C113.795 81.7239 113.93 81.8199 114.045 81.8199C114.315 81.8199 114.508 81.5319 114.373 81.2824C114.238 81.0328 113.852 81.0712 113.737 81.3208C113.679 81.4551 113.698 81.6279 113.833 81.7239C113.968 81.7815 114.161 81.7431 114.238 81.6087Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.082 80.1288C113.082 80.1096 113.082 80.1096 113.082 80.1288C113.063 80.2056 113.024 80.3016 113.005 80.3976C112.966 80.4168 112.928 80.4552 112.87 80.4744C112.831 80.4744 112.793 80.4744 112.754 80.4744C112.716 80.4552 112.677 80.4168 112.619 80.3976C112.6 80.3016 112.562 80.2056 112.542 80.1096C112.542 80.1096 112.542 80.1096 112.542 80.1288C112.504 80.2824 112.581 80.4552 112.735 80.4744C112.889 80.5127 113.063 80.436 113.082 80.2824C113.12 80.0904 112.986 79.8984 112.793 79.8984C112.716 79.8984 112.619 79.9368 112.562 79.9944C112.484 80.0712 112.465 80.1864 112.484 80.2824C112.504 80.436 112.696 80.5127 112.831 80.4744C113.043 80.436 113.101 80.2824 113.082 80.1288Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.444 81.2442C111.483 81.2634 111.521 81.2826 111.56 81.321C111.579 81.3978 111.618 81.4554 111.637 81.5321C111.541 81.6857 111.521 81.7241 111.579 81.6857C111.541 81.7049 111.502 81.7433 111.444 81.7625C111.444 81.7625 111.444 81.7625 111.464 81.7625C111.406 81.7625 111.367 81.7625 111.309 81.7625C111.309 81.7625 111.309 81.7625 111.329 81.7625C111.29 81.7433 111.252 81.7049 111.194 81.6857C111.174 81.6665 111.155 81.6281 111.136 81.6089C111.136 81.5513 111.136 81.5129 111.136 81.4554C111.174 81.3786 111.232 81.3402 111.329 81.321C111.386 81.3402 111.425 81.3402 111.483 81.3594H111.464C111.329 81.2826 111.155 81.321 111.059 81.4554C110.982 81.5897 111.02 81.7817 111.155 81.8585C111.329 81.9545 111.521 81.8969 111.637 81.7433C111.733 81.5897 111.714 81.3978 111.56 81.2826C111.406 81.1674 111.194 81.225 111.097 81.3978C111.001 81.5705 111.078 81.8009 111.29 81.8585C111.444 81.8969 111.618 81.8009 111.637 81.6665C111.676 81.4362 111.598 81.2826 111.444 81.2442Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.961 80.3787C109.883 80.3595 109.787 80.3211 109.691 80.3019C109.671 80.2635 109.633 80.2251 109.614 80.1675C109.614 80.1291 109.614 80.0907 109.614 80.0523C109.633 80.0139 109.671 79.9755 109.691 79.9179C109.787 79.8987 109.883 79.8603 109.98 79.8411C109.98 79.8411 109.98 79.8411 109.961 79.8411C109.806 79.8027 109.633 79.8795 109.614 80.0331C109.575 80.1867 109.652 80.3403 109.806 80.3787C109.999 80.4171 110.192 80.2827 110.192 80.0715C110.192 79.8603 109.999 79.726 109.806 79.7643C109.652 79.8027 109.556 79.9755 109.614 80.1099C109.652 80.3403 109.806 80.4171 109.961 80.3787Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.366 78.4961C111.347 78.4961 111.328 78.4961 111.309 78.4961C111.154 78.4961 111.02 78.6305 111.02 78.7841C111.02 78.9376 111.154 79.072 111.309 79.072C111.328 79.072 111.347 79.072 111.366 79.072C111.521 79.072 111.655 78.9376 111.655 78.7841C111.636 78.6305 111.521 78.4961 111.366 78.4961Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.999 77.654C110.365 77.654 110.365 77.0781 109.999 77.0781C109.614 77.0781 109.614 77.654 109.999 77.654Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.881 78.4604C108.862 78.4412 108.843 78.422 108.823 78.4028C108.708 78.2876 108.534 78.2876 108.419 78.4028C108.303 78.518 108.303 78.6908 108.419 78.8059C108.438 78.8251 108.457 78.8443 108.477 78.8635C108.592 78.9787 108.766 78.9787 108.881 78.8635C108.997 78.7675 108.997 78.5756 108.881 78.4604Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.186 77.654C107.552 77.654 107.552 77.0781 107.186 77.0781C106.82 77.0781 106.82 77.654 107.186 77.654Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.785 76.0018C108.785 75.9826 108.785 75.9634 108.785 75.9442C108.785 75.7906 108.65 75.6562 108.496 75.6562C108.342 75.6562 108.207 75.7906 108.207 75.9442C108.207 75.9634 108.207 75.9826 108.207 76.0018C108.207 76.1554 108.342 76.2898 108.496 76.2898C108.67 76.2706 108.785 76.1554 108.785 76.0018Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.242 74.3906C107.223 74.3906 107.204 74.3906 107.185 74.3906C107.03 74.3906 106.896 74.525 106.896 74.6786C106.896 74.8322 107.03 74.9665 107.185 74.9665C107.204 74.9665 107.223 74.9665 107.242 74.9665C107.397 74.9665 107.531 74.8322 107.531 74.6786C107.531 74.525 107.416 74.3906 107.242 74.3906Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.701 75.6562C105.682 75.6562 105.663 75.6562 105.644 75.6562C105.489 75.6562 105.354 75.7906 105.354 75.9442C105.354 76.0978 105.489 76.2322 105.644 76.2322C105.663 76.2322 105.682 76.2322 105.701 76.2322C105.856 76.2322 105.99 76.0978 105.99 75.9442C105.99 75.7906 105.875 75.6562 105.701 75.6562Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.333 74.8689C104.352 74.8689 104.372 74.8689 104.391 74.8689C104.545 74.8689 104.68 74.7345 104.68 74.5809C104.68 74.4273 104.545 74.293 104.391 74.293C104.372 74.293 104.352 74.293 104.333 74.293C104.179 74.293 104.044 74.4273 104.044 74.5809C104.063 74.7345 104.179 74.8689 104.333 74.8689Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.759 73.5447C106.125 73.5447 106.125 72.9688 105.759 72.9688C105.393 72.9688 105.393 73.5447 105.759 73.5447Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.35 75.6752C103.331 75.656 103.311 75.6368 103.292 75.6176C103.177 75.5025 103.003 75.5025 102.888 75.6176C102.772 75.7328 102.772 75.9056 102.888 76.0208C102.907 76.04 102.926 76.0592 102.945 76.0784C103.061 76.1936 103.234 76.1936 103.35 76.0784C103.446 75.9824 103.446 75.7904 103.35 75.6752Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.391 77.4236C104.757 77.4236 104.757 76.8477 104.391 76.8477C104.025 76.8477 104.025 77.4236 104.391 77.4236Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.971 78.5151C105.952 78.4959 105.933 78.4767 105.913 78.4575C105.798 78.3423 105.624 78.3423 105.509 78.4575C105.393 78.5727 105.393 78.7454 105.509 78.8606C105.528 78.8798 105.547 78.899 105.566 78.9182C105.682 79.0334 105.855 79.0334 105.971 78.9182C106.087 78.8222 106.087 78.6303 105.971 78.5151Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.474 80.2635C107.474 80.2443 107.474 80.2251 107.474 80.2059C107.474 80.0523 107.339 79.918 107.185 79.918C107.03 79.918 106.896 80.0523 106.896 80.2059C106.896 80.2251 106.896 80.2443 106.896 80.2635C106.896 80.4171 107.03 80.5515 107.185 80.5515C107.339 80.5323 107.474 80.4171 107.474 80.2635Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.701 81.74C105.72 81.74 105.74 81.74 105.759 81.74C105.913 81.74 106.048 81.6056 106.048 81.452C106.048 81.2984 105.913 81.1641 105.759 81.1641C105.74 81.1641 105.72 81.1641 105.701 81.1641C105.547 81.1641 105.412 81.2984 105.412 81.452C105.431 81.6056 105.547 81.74 105.701 81.74Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.186 83.1033C107.552 83.1033 107.552 82.5273 107.186 82.5273C106.82 82.5273 106.82 83.1033 107.186 83.1033Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.612 81.3398C108.592 81.3398 108.573 81.3398 108.554 81.3398C108.4 81.3398 108.265 81.4742 108.265 81.6278C108.265 81.7814 108.4 81.9158 108.554 81.9158C108.573 81.9158 108.592 81.9158 108.612 81.9158C108.766 81.9158 108.901 81.7814 108.901 81.6278C108.901 81.4742 108.785 81.3398 108.612 81.3398Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.999 82.5859C109.98 82.5859 109.961 82.5859 109.941 82.5859C109.787 82.5859 109.652 82.7203 109.652 82.8739C109.652 83.0275 109.787 83.1619 109.941 83.1619C109.961 83.1619 109.98 83.1619 109.999 83.1619C110.153 83.1619 110.288 83.0275 110.288 82.8739C110.269 82.7203 110.153 82.5859 109.999 82.5859Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.553 84.6423C108.919 84.6423 108.919 84.0664 108.553 84.0664C108.187 84.0664 108.187 84.6423 108.553 84.6423Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.251 84.6423C111.617 84.6423 111.617 84.0664 111.251 84.0664C110.866 84.0664 110.866 84.6423 111.251 84.6423Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.941 85.8884C110.308 85.8884 110.308 85.3125 109.941 85.3125C109.556 85.3125 109.556 85.8884 109.941 85.8884Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.193 87.365C111.56 87.365 111.56 86.7891 111.193 86.7891C110.808 86.7891 110.808 87.365 111.193 87.365Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.54 89.7088C111.54 89.6896 111.54 89.6704 111.54 89.6512C111.54 89.4977 111.405 89.3633 111.251 89.3633C111.097 89.3633 110.962 89.4977 110.962 89.6512C110.962 89.6704 110.962 89.6896 110.962 89.7088C110.962 89.8624 111.097 89.9968 111.251 89.9968C111.405 89.9776 111.54 89.8624 111.54 89.7088Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.883 88.6345C110.249 88.6345 110.249 88.0586 109.883 88.0586C109.497 88.0586 109.497 88.6345 109.883 88.6345Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.265 89.9403C108.265 89.9595 108.265 89.9787 108.265 89.9979C108.265 90.1515 108.4 90.2859 108.554 90.2859C108.708 90.2859 108.843 90.1515 108.843 89.9979C108.843 89.9787 108.843 89.9595 108.843 89.9403C108.843 89.7867 108.708 89.6523 108.554 89.6523C108.4 89.6523 108.265 89.7675 108.265 89.9403Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.652 91.245C109.652 91.2642 109.652 91.2834 109.652 91.3026C109.652 91.4562 109.787 91.5905 109.941 91.5905C110.096 91.5905 110.23 91.4562 110.23 91.3026C110.23 91.2834 110.23 91.2642 110.23 91.245C110.23 91.0914 110.096 90.957 109.941 90.957C109.768 90.957 109.652 91.0722 109.652 91.245Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.425 92.8376C111.791 92.8376 111.791 92.2617 111.425 92.2617C111.039 92.2617 111.039 92.8376 111.425 92.8376Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M110.23 94.201C110.23 94.1818 110.23 94.1626 110.23 94.1434C110.23 93.9898 110.096 93.8555 109.941 93.8555C109.787 93.8555 109.652 93.9898 109.652 94.1434C109.652 94.1626 109.652 94.1818 109.652 94.201C109.652 94.3546 109.787 94.489 109.941 94.489C110.096 94.4698 110.23 94.3546 110.23 94.201Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.598 95.6219C111.598 95.5835 111.598 95.5451 111.598 95.5067C111.598 95.3531 111.463 95.2188 111.309 95.2188C111.154 95.2188 111.02 95.3531 111.02 95.5067C111.02 95.5451 111.02 95.5835 111.02 95.6219C111.02 95.7755 111.154 95.9099 111.309 95.9099C111.463 95.9099 111.598 95.7755 111.598 95.6219Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.825 96.9861C110.191 96.9861 110.191 96.4102 109.825 96.4102C109.44 96.4102 109.44 96.9861 109.825 96.9861Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.495 98.1189C108.861 98.1189 108.861 97.543 108.495 97.543C108.129 97.543 108.129 98.1189 108.495 98.1189Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.377 96.5246C107.127 96.3326 106.741 96.7166 106.934 96.9661C107.03 97.0813 107.184 97.1581 107.339 97.0621C107.454 96.9853 107.531 96.7933 107.435 96.659C107.435 96.659 107.435 96.659 107.435 96.6398C107.454 96.6974 107.454 96.7358 107.474 96.7933C107.474 96.7933 107.474 96.7933 107.474 96.7741C107.454 96.8317 107.454 96.8701 107.435 96.9277C107.416 96.9469 107.377 96.9853 107.358 97.0045C107.3 97.0237 107.262 97.0237 107.204 97.0429C107.204 97.0429 107.204 97.0429 107.223 97.0429C107.165 97.0237 107.127 97.0237 107.069 97.0045C107.069 97.0045 107.069 97.0045 107.088 97.0045C107.204 97.1005 107.416 97.0237 107.493 96.9085C107.57 96.7549 107.512 96.6014 107.377 96.5246Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.207 95.2762C108.207 95.2954 108.207 95.3146 108.207 95.3338C108.207 95.4874 108.342 95.6218 108.496 95.6218C108.65 95.6218 108.785 95.4874 108.785 95.3338C108.785 95.3146 108.785 95.2954 108.785 95.2762C108.785 95.1227 108.65 94.9883 108.496 94.9883C108.342 95.0075 108.207 95.1227 108.207 95.2762Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.243 94.3728C107.61 94.3728 107.61 93.7969 107.243 93.7969C106.877 93.7969 106.877 94.3728 107.243 94.3728Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.399 92.7244C108.766 92.7244 108.766 92.1484 108.399 92.1484C108.014 92.1484 108.014 92.7244 108.399 92.7244Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.759 95.0469C105.74 95.0469 105.72 95.0469 105.701 95.0469C105.547 95.0469 105.412 95.1813 105.412 95.3348C105.412 95.4884 105.547 95.6228 105.701 95.6228C105.72 95.6228 105.74 95.6228 105.759 95.6228C105.913 95.6228 106.048 95.4884 106.048 95.3348C106.048 95.1813 105.932 95.0469 105.759 95.0469Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.759 98.404C106.125 98.404 106.125 97.8281 105.759 97.8281C105.393 97.8281 105.393 98.404 105.759 98.404Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.564 97.2165C104.93 97.2165 104.93 96.6406 104.564 96.6406C104.198 96.6406 104.198 97.2165 104.564 97.2165Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.312 98.1151C103.312 98.0959 103.312 98.0767 103.312 98.0575C103.312 97.9039 103.177 97.7695 103.022 97.7695C102.868 97.7695 102.733 97.9039 102.733 98.0575C102.733 98.0767 102.733 98.0959 102.733 98.1151C102.733 98.2687 102.868 98.403 103.022 98.403C103.177 98.403 103.312 98.2879 103.312 98.1151Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.402 97.6562C100.382 97.6562 100.363 97.6562 100.344 97.6562C100.19 97.6562 100.055 97.7906 100.055 97.9442C100.055 98.0978 100.19 98.2322 100.344 98.2322C100.363 98.2322 100.382 98.2322 100.402 98.2322C100.556 98.2322 100.691 98.0978 100.691 97.9442C100.671 97.7906 100.556 97.6562 100.402 97.6562Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.827 96.8104C101.827 96.7912 101.827 96.772 101.827 96.7528C101.827 96.5992 101.692 96.4648 101.538 96.4648C101.384 96.4648 101.249 96.5992 101.249 96.7528C101.249 96.772 101.249 96.7912 101.249 96.8104C101.249 96.964 101.384 97.0984 101.538 97.0984C101.692 97.0984 101.827 96.9832 101.827 96.8104Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.917 96.9861C99.2832 96.9861 99.2832 96.4102 98.917 96.4102C98.5316 96.4102 98.5316 96.9861 98.917 96.9861Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.3158 96.5034C96.2966 96.4842 96.2773 96.465 96.258 96.4458C96.1424 96.3306 95.969 96.3306 95.8533 96.4458C95.7377 96.5609 95.7377 96.7337 95.8533 96.8489C95.8726 96.8681 95.8919 96.8873 95.9111 96.9065C96.0268 97.0217 96.2002 97.0217 96.3158 96.9065C96.4315 96.7913 96.4315 96.5993 96.3158 96.5034Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.761 94.9883C97.7417 94.9883 97.7224 94.9883 97.7031 94.9883C97.549 94.9883 97.4141 95.1227 97.4141 95.2762C97.4141 95.4298 97.549 95.5642 97.7031 95.5642C97.7224 95.5642 97.7417 95.5642 97.761 95.5642C97.9151 95.5642 98.05 95.4298 98.05 95.2762C98.05 95.1227 97.9344 94.9883 97.761 94.9883Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.113 95.7361C100.479 95.7361 100.479 95.1602 100.113 95.1602C99.7464 95.1602 99.7464 95.7361 100.113 95.7361Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.655 94.2009C102.021 94.2009 102.021 93.625 101.655 93.625C101.288 93.625 101.288 94.2009 101.655 94.2009Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.391 94.1423C104.757 94.1423 104.757 93.5664 104.391 93.5664C104.025 93.5664 104.025 94.1423 104.391 94.1423Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.138 95.6228C103.504 95.6228 103.504 95.0469 103.138 95.0469C102.772 95.0469 102.772 95.6228 103.138 95.6228Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.023 92.4922C103.003 92.4922 102.984 92.4922 102.965 92.4922C102.811 92.4922 102.676 92.6266 102.676 92.7801C102.676 92.9337 102.811 93.0681 102.965 93.0681C102.984 93.0681 103.003 93.0681 103.023 93.0681C103.177 93.0681 103.312 92.9337 103.312 92.7801C103.312 92.6266 103.177 92.4922 103.023 92.4922Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.391 91.4744C104.757 91.4744 104.757 90.8984 104.391 90.8984C104.025 90.8984 104.025 91.4744 104.391 91.4744Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.817 92.7244C106.183 92.7244 106.183 92.1484 105.817 92.1484C105.45 92.1484 105.45 92.7244 105.817 92.7244Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.933 90.0525C106.299 90.0525 106.299 89.4766 105.933 89.4766C105.567 89.4766 105.567 90.0525 105.933 90.0525Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.32 91.1487C107.301 91.1104 107.281 91.072 107.262 91.0336C107.185 90.8992 106.992 90.8608 106.857 90.9376C106.722 91.0144 106.684 91.1871 106.761 91.3407C106.78 91.3791 106.8 91.4175 106.819 91.4559C106.896 91.5903 107.089 91.6287 107.223 91.5519C107.358 91.4559 107.397 91.2831 107.32 91.1487Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.301 88.6931C107.667 88.6931 107.667 88.1172 107.301 88.1172C106.935 88.1172 106.935 88.6931 107.301 88.6931Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M108.457 87.365C108.823 87.365 108.823 86.7891 108.457 86.7891C108.072 86.7891 108.072 87.365 108.457 87.365Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.029 86.7729C106.009 86.7537 105.99 86.7345 105.971 86.7153C105.855 86.6001 105.682 86.6001 105.566 86.7153C105.451 86.8305 105.451 87.0033 105.566 87.1184C105.585 87.1376 105.605 87.1568 105.624 87.176C105.74 87.2912 105.913 87.2912 106.029 87.176C106.144 87.0608 106.144 86.8881 106.029 86.7729Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.204 85.7752C107.204 85.756 107.204 85.7368 107.204 85.7176C107.204 85.5641 107.069 85.4297 106.915 85.4297C106.761 85.4297 106.626 85.5641 106.626 85.7176C106.626 85.7368 106.626 85.756 106.626 85.7752C106.626 85.9288 106.761 86.0632 106.915 86.0632C107.069 86.0632 107.204 85.948 107.204 85.7752Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.817 84.7556C106.183 84.7556 106.183 84.1797 105.817 84.1797C105.45 84.1797 105.45 84.7556 105.817 84.7556Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.448 82.7578C104.429 82.7578 104.41 82.7578 104.391 82.7578C104.236 82.7578 104.102 82.8922 104.102 83.0458C104.102 83.1993 104.236 83.3337 104.391 83.3337C104.41 83.3337 104.429 83.3337 104.448 83.3337C104.603 83.3337 104.738 83.1993 104.738 83.0458C104.738 82.8922 104.622 82.7578 104.448 82.7578Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.0654 83.0486C96.4316 83.0486 96.4316 82.4727 96.0654 82.4727C95.68 82.4727 95.68 83.0486 96.0654 83.0486Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.3674 82.99C93.7336 82.99 93.7336 82.4141 93.3674 82.4141C93.0012 82.4141 93.0012 82.99 93.3674 82.99Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M91.71 84.2958C91.71 84.315 91.71 84.3342 91.71 84.3534C91.71 84.5069 91.8449 84.6413 91.999 84.6413C92.1532 84.6413 92.2881 84.5069 92.2881 84.3534C92.2881 84.3342 92.2881 84.315 92.2881 84.2958C92.2881 84.1422 92.1532 84.0078 91.999 84.0078C91.8449 84.027 91.71 84.1422 91.71 84.2958Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M91.9992 86.6953C91.98 86.6953 91.9607 86.6953 91.9414 86.6953C91.7872 86.6953 91.6523 86.8297 91.6523 86.9833C91.6523 87.1368 91.7872 87.2712 91.9414 87.2712C91.9607 87.2712 91.98 87.2712 91.9992 87.2712C92.1534 87.2712 92.2883 87.1368 92.2883 86.9833C92.2883 86.8105 92.1727 86.6953 91.9992 86.6953Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.0759 89.4401C91.8831 89.4017 91.6904 89.5361 91.6904 89.7473C91.6904 89.9585 91.8831 90.0928 92.0759 90.0544C92.23 90.016 92.3264 89.8433 92.2686 89.7089C92.23 89.5553 92.0566 89.4785 91.9217 89.5169C91.9217 89.5169 91.9217 89.5169 91.9024 89.5169C91.9988 89.5361 92.0951 89.5745 92.1915 89.5937C92.2108 89.6321 92.2493 89.6705 92.2686 89.7281C92.2686 89.7665 92.2686 89.8049 92.2686 89.8433C92.2493 89.8817 92.2108 89.9201 92.1915 89.9777C92.0951 89.9969 91.9988 90.0352 91.9024 90.0544C91.9024 90.0544 91.9024 90.0544 91.9217 90.0544C92.0759 90.0928 92.2493 90.016 92.2686 89.8625C92.3071 89.6513 92.23 89.4785 92.0759 89.4401Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.4824 91.244C93.4824 91.2248 93.4824 91.2056 93.4824 91.1864C93.4824 91.0328 93.3475 90.8984 93.1934 90.8984C93.0392 90.8984 92.9043 91.0328 92.9043 91.1864C92.9043 91.2056 92.9043 91.2248 92.9043 91.244C92.9043 91.3976 93.0392 91.5319 93.1934 91.5319C93.3475 91.5127 93.4824 91.3976 93.4824 91.244Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.5987 93.9149C93.5987 93.8765 93.5987 93.8381 93.5987 93.7997C93.5987 93.6461 93.4638 93.5117 93.3096 93.5117C93.1554 93.5117 93.0205 93.6461 93.0205 93.7997C93.0205 93.8381 93.0205 93.8765 93.0205 93.9149C93.0205 94.0684 93.1554 94.2028 93.3096 94.2028C93.4638 94.2028 93.5987 94.0684 93.5987 93.9149Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.0568 92.3203C92.0376 92.3203 92.0183 92.3203 91.999 92.3203C91.8449 92.3203 91.71 92.4547 91.71 92.6083C91.71 92.7618 91.8449 92.8962 91.999 92.8962C92.0183 92.8962 92.0376 92.8962 92.0568 92.8962C92.211 92.8962 92.3459 92.7618 92.3459 92.6083C92.3459 92.4547 92.211 92.3203 92.0568 92.3203Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.2344 92.5497C94.2344 92.5689 94.2344 92.5881 94.2344 92.6073C94.2344 92.7608 94.3693 92.8952 94.5234 92.8952C94.6776 92.8952 94.8125 92.7608 94.8125 92.6073C94.8125 92.5881 94.8125 92.5689 94.8125 92.5497C94.8125 92.3961 94.6776 92.2617 94.5234 92.2617C94.35 92.2617 94.2344 92.3961 94.2344 92.5497Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M95.6611 91.245C95.6611 91.2642 95.6611 91.2834 95.6611 91.3026C95.6611 91.4562 95.796 91.5905 95.9502 91.5905C96.1044 91.5905 96.2393 91.4562 96.2393 91.3026C96.2393 91.2834 96.2393 91.2642 96.2393 91.245C96.2393 91.0914 96.1044 90.957 95.9502 90.957C95.7768 90.957 95.6611 91.0722 95.6611 91.245Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.3949 89.5159C97.2407 89.5927 97.1637 89.7847 97.2022 89.9574C97.2407 90.111 97.4142 90.207 97.5491 90.1494C97.7033 90.111 97.7996 89.9382 97.7418 89.8039C97.7225 89.8807 97.684 89.9382 97.6647 90.015C97.7996 89.9574 97.8382 89.7463 97.7611 89.6119C97.7033 89.4583 97.5298 89.4583 97.3949 89.5159Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.917 88.7478C99.2832 88.7478 99.2832 88.1719 98.917 88.1719C98.5316 88.1719 98.5316 88.7478 98.917 88.7478Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.112 87.3103C100.132 87.3103 100.151 87.3103 100.17 87.3103C100.324 87.3103 100.459 87.1759 100.459 87.0223C100.459 86.8688 100.324 86.7344 100.17 86.7344C100.151 86.7344 100.132 86.7344 100.112 86.7344C99.9581 86.7344 99.8232 86.8688 99.8232 87.0223C99.8232 87.1951 99.9389 87.3103 100.112 87.3103Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.655 85.947C102.021 85.947 102.021 85.3711 101.655 85.3711C101.288 85.3711 101.288 85.947 101.655 85.947Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M102.926 83.9887C102.907 84.0079 102.887 84.0271 102.868 84.0463C102.752 84.1615 102.752 84.3343 102.868 84.4495C102.984 84.5646 103.157 84.5646 103.273 84.4495C103.292 84.4303 103.311 84.4111 103.33 84.3919C103.446 84.2767 103.446 84.1039 103.33 83.9887C103.234 83.8735 103.041 83.8735 102.926 83.9887Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.423 83.279C101.789 83.279 101.789 82.7031 101.423 82.7031C101.057 82.7031 101.057 83.279 101.423 83.279Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.08 81.6853C103.446 81.6853 103.446 81.1094 103.08 81.1094C102.714 81.1094 102.714 81.6853 103.08 81.6853Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.737 79.9745C104.737 79.9553 104.737 79.9361 104.737 79.9169C104.737 79.7633 104.602 79.6289 104.448 79.6289C104.294 79.6289 104.159 79.7633 104.159 79.9169C104.159 79.9361 104.159 79.9553 104.159 79.9745C104.159 80.128 104.294 80.2624 104.448 80.2624C104.602 80.2624 104.737 80.128 104.737 79.9745Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.022 79.072C103.388 79.072 103.388 78.4961 103.022 78.4961C102.656 78.4961 102.656 79.072 103.022 79.072Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.249 77.3075C101.249 77.3267 101.249 77.3459 101.249 77.3651C101.249 77.5187 101.384 77.653 101.538 77.653C101.692 77.653 101.827 77.5187 101.827 77.3651C101.827 77.3459 101.827 77.3267 101.827 77.3075C101.827 77.1539 101.692 77.0195 101.538 77.0195C101.384 77.0195 101.249 77.1347 101.249 77.3075Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.9971 78.5536C99.9971 78.5728 99.9971 78.592 99.9971 78.6112C99.9971 78.7648 100.132 78.8991 100.286 78.8991C100.44 78.8991 100.575 78.7648 100.575 78.6112C100.575 78.592 100.575 78.5728 100.575 78.5536C100.575 78.4 100.44 78.2656 100.286 78.2656C100.132 78.2656 99.9971 78.4 99.9971 78.5536Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.249 79.9169C101.249 79.9361 101.249 79.9553 101.249 79.9745C101.249 80.128 101.384 80.2624 101.538 80.2624C101.692 80.2624 101.827 80.128 101.827 79.9745C101.827 79.9553 101.827 79.9361 101.827 79.9169C101.827 79.7633 101.692 79.6289 101.538 79.6289C101.384 79.6289 101.249 79.7633 101.249 79.9169Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.8018 80.2634C99.1679 80.2634 99.1679 79.6875 98.8018 79.6875C98.4163 79.6875 98.4163 80.2634 98.8018 80.2634Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.17 81.74C100.536 81.74 100.536 81.1641 100.17 81.1641C99.804 81.1641 99.804 81.74 100.17 81.74Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.2021 81.5106C97.2021 81.5298 97.2021 81.549 97.2021 81.5682C97.2021 81.7218 97.337 81.8562 97.4912 81.8562C97.6454 81.8562 97.7803 81.7218 97.7803 81.5682C97.7803 81.549 97.7803 81.5298 97.7803 81.5106C97.7803 81.357 97.6454 81.2227 97.4912 81.2227C97.3178 81.2227 97.2021 81.357 97.2021 81.5106Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.8213 82.5669C98.802 82.5861 98.7828 82.6052 98.7635 82.6244C98.6479 82.7396 98.6479 82.9124 98.7635 83.0276C98.8791 83.1428 99.0526 83.1428 99.1682 83.0276C99.1875 83.0084 99.2067 82.9892 99.226 82.97C99.3416 82.8548 99.3416 82.682 99.226 82.5669C99.1104 82.4517 98.9369 82.4517 98.8213 82.5669Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.4914 83.9492C97.4721 83.9492 97.4529 83.9492 97.4336 83.9492C97.2794 83.9492 97.1445 84.0836 97.1445 84.2372C97.1445 84.3908 97.2794 84.5251 97.4336 84.5251C97.4529 84.5251 97.4721 84.5251 97.4914 84.5251C97.6456 84.5251 97.7805 84.3908 97.7805 84.2372C97.7612 84.0836 97.6456 83.9492 97.4914 83.9492Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.6862 85.7751C99.0524 85.7751 99.0524 85.1992 98.6862 85.1992C98.32 85.1992 98.3008 85.7751 98.6862 85.7751Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.17 84.5837C100.536 84.5837 100.536 84.0078 100.17 84.0078C99.804 84.0078 99.804 84.5837 100.17 84.5837Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.376 87.2712C97.7421 87.2712 97.7421 86.6953 97.376 86.6953C96.9906 86.6953 96.9906 87.2712 97.376 87.2712Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.1037 86.0056C96.4699 86.0056 96.4699 85.4297 96.1037 85.4297C95.7376 85.4297 95.7376 86.0056 96.1037 86.0056Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.7942 84.4665C95.1603 84.4665 95.1603 83.8906 94.7942 83.8906C94.428 83.8906 94.428 84.4665 94.7942 84.4665Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.3674 85.947C93.7336 85.947 93.7336 85.3711 93.3674 85.3711C93.0012 85.3711 93.0012 85.947 93.3674 85.947Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.5234 87.3103C94.5427 87.3103 94.562 87.3103 94.5813 87.3103C94.7354 87.3103 94.8703 87.1759 94.8703 87.0223C94.8703 86.8688 94.7354 86.7344 94.5813 86.7344C94.562 86.7344 94.5427 86.7344 94.5234 86.7344C94.3693 86.7344 94.2344 86.8688 94.2344 87.0223C94.2344 87.1951 94.35 87.3103 94.5234 87.3103Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.0654 88.5759C96.4316 88.5759 96.4316 88 96.0654 88C95.68 88 95.68 88.5759 96.0654 88.5759Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.0205 88.4051C93.0205 88.4243 93.0205 88.4435 93.0205 88.4627C93.0205 88.6163 93.1554 88.7507 93.3096 88.7507C93.4638 88.7507 93.5987 88.6163 93.5987 88.4627C93.5987 88.4435 93.5987 88.4243 93.5987 88.4051C93.5987 88.2516 93.4638 88.1172 93.3096 88.1172C93.1554 88.1172 93.0205 88.2324 93.0205 88.4051Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.2537 89.7278C94.273 89.747 94.2923 89.7662 94.3115 89.7854C94.4272 89.9006 94.6006 89.9006 94.7162 89.7854C94.8319 89.6702 94.8319 89.4974 94.7162 89.3823C94.697 89.3631 94.6777 89.3439 94.6584 89.3247C94.5428 89.2095 94.3693 89.2095 94.2537 89.3247C94.1381 89.4399 94.1381 89.6318 94.2537 89.7278Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.4338 82.7009C79.8 82.7009 79.8 82.125 79.4338 82.125C79.0676 82.125 79.0676 82.7009 79.4338 82.7009Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.3184 84.1239C79.3184 84.1431 79.3184 84.1623 79.3184 84.1815C79.3184 84.3351 79.4533 84.4694 79.6074 84.4694C79.7616 84.4694 79.8965 84.3351 79.8965 84.1815C79.8965 84.1623 79.8965 84.1431 79.8965 84.1239C79.8965 83.9703 79.7616 83.8359 79.6074 83.8359C79.4533 83.8551 79.3184 83.9703 79.3184 84.1239Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.8967 83.3923C80.2629 83.3923 80.2629 82.8164 79.8967 82.8164C79.5305 82.8164 79.5305 83.3923 79.8967 83.3923Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.9746 94.2009C99.3408 94.2009 99.3408 93.625 98.9746 93.625C98.5892 93.625 98.5892 94.2009 98.9746 94.2009Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.5615 95.3348C94.5615 95.354 94.5615 95.3732 94.5615 95.3924C94.5615 95.546 94.6964 95.6804 94.8506 95.6804C95.0048 95.6804 95.1397 95.546 95.1397 95.3924C95.1397 95.3732 95.1397 95.354 95.1397 95.3348C95.1397 95.1813 95.0048 95.0469 94.8506 95.0469C94.6964 95.0469 94.5615 95.1813 94.5615 95.3348Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.0078 94.4314C96.374 94.4314 96.374 93.8555 96.0078 93.8555C95.6224 93.8555 95.6224 94.4314 96.0078 94.4314Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.3184 92.4364C97.3184 92.4556 97.3184 92.4748 97.3184 92.494C97.3184 92.6476 97.4533 92.7819 97.6074 92.7819C97.7616 92.7819 97.8965 92.6476 97.8965 92.494C97.8965 92.4748 97.8965 92.4556 97.8965 92.4364C97.8965 92.2828 97.7616 92.1484 97.6074 92.1484C97.434 92.1484 97.3184 92.2828 97.3184 92.4364Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.6279 91.1864C98.6279 91.2056 98.6279 91.2248 98.6279 91.244C98.6279 91.3976 98.7628 91.5319 98.917 91.5319C99.0712 91.5319 99.2061 91.3976 99.2061 91.244C99.2061 91.2248 99.2061 91.2056 99.2061 91.1864C99.2061 91.0328 99.0712 90.8984 98.917 90.8984C98.7628 90.8984 98.6279 91.0136 98.6279 91.1864Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.517 92.494C100.517 92.4748 100.517 92.4556 100.517 92.4364C100.517 92.2828 100.382 92.1484 100.228 92.1484C100.073 92.1484 99.9385 92.2828 99.9385 92.4364C99.9385 92.4556 99.9385 92.4748 99.9385 92.494C99.9385 92.6476 100.073 92.7819 100.228 92.7819C100.382 92.7819 100.517 92.6476 100.517 92.494Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.112 89.7098C100.112 89.729 100.112 89.7482 100.112 89.7674C100.112 89.921 100.247 90.0554 100.401 90.0554C100.556 90.0554 100.69 89.921 100.69 89.7674C100.69 89.7482 100.69 89.729 100.69 89.7098C100.69 89.5563 100.556 89.4219 100.401 89.4219C100.247 89.4219 100.112 89.5371 100.112 89.7098Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.943 91.3026C101.943 91.2834 101.943 91.2642 101.943 91.245C101.943 91.0914 101.808 90.957 101.654 90.957C101.5 90.957 101.365 91.0914 101.365 91.245C101.365 91.2642 101.365 91.2834 101.365 91.3026C101.365 91.4562 101.5 91.5905 101.654 91.5905C101.808 91.5713 101.943 91.4562 101.943 91.3026Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M102.849 90.0525C102.868 90.0525 102.887 90.0525 102.906 90.0525C103.061 90.0525 103.196 89.9181 103.196 89.7645C103.196 89.6109 103.061 89.4766 102.906 89.4766C102.887 89.4766 102.868 89.4766 102.849 89.4766C102.694 89.4766 102.56 89.6109 102.56 89.7645C102.56 89.9181 102.694 90.0525 102.849 90.0525Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.712 88.7478C102.078 88.7478 102.078 88.1719 101.712 88.1719C101.346 88.1719 101.346 88.7478 101.712 88.7478Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.061 87.3479C103.08 87.3287 103.099 87.3095 103.119 87.2903C103.234 87.1751 103.234 87.0024 103.119 86.8872C103.003 86.772 102.83 86.772 102.714 86.8872C102.695 86.9064 102.675 86.9256 102.656 86.9448C102.54 87.0599 102.54 87.2327 102.656 87.3479C102.752 87.4631 102.945 87.4631 103.061 87.3479Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.564 88.0586C104.544 88.0586 104.525 88.0586 104.506 88.0586C104.352 88.0586 104.217 88.193 104.217 88.3466C104.217 88.5001 104.352 88.6345 104.506 88.6345C104.525 88.6345 104.544 88.6345 104.564 88.6345C104.718 88.6345 104.853 88.5001 104.853 88.3466C104.853 88.193 104.718 88.0586 104.564 88.0586Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.391 86.1189C104.757 86.1189 104.757 85.543 104.391 85.543C104.025 85.543 104.025 86.1189 104.391 86.1189Z"
        fill="#1C2A3C"
      />
      <path
        opacity="0.42"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.24737 176.04C-0.195878 177.384 0.84479 178.823 1.26877 179.419C3.60063 182.644 7.80185 182.913 8.01383 182.932C10.5191 183.047 12.4463 182.087 13.3713 181.55C14.3735 181.818 15.8959 182.029 17.6304 181.703C18.1122 181.607 18.5554 181.473 18.9408 181.338C19.1721 181.492 19.4612 181.626 19.8273 181.703C21.2534 182.01 22.429 180.993 22.6025 180.82C22.8915 180.954 23.3733 181.146 23.99 181.262C25.3968 181.492 25.8786 181.012 27.5745 180.974C29.1934 180.935 29.5017 181.358 30.2147 180.974C30.8893 180.609 31.4674 179.745 31.3903 178.785C31.3325 178.152 31.0242 177.288 30.3689 177.038C29.7522 176.808 29.0777 177.192 29.0584 177.115C29.0199 177 30.5231 176.769 31.1012 175.733C31.6023 174.83 31.1012 173.947 31.6216 173.621C31.8721 173.448 32.0648 173.621 33.0091 173.775C33.6836 173.871 34.5894 174.005 35.4952 173.698C35.8421 173.583 36.4202 173.391 36.5166 172.968C36.6129 172.584 36.266 172.239 35.9384 171.797C35.5723 171.317 35.1097 170.569 34.7628 169.455C35.0134 169.57 36.1119 169.993 37.326 169.532C38.0583 169.244 38.5015 168.764 38.7135 168.515C39.1568 168.687 39.9469 168.937 40.9105 168.803C41.0069 168.783 43.1653 168.476 43.2616 167.42C43.3002 167.036 42.8184 166.96 42.1632 165.961C41.797 165.405 41.6236 165.136 41.6428 164.867C41.7199 164.099 42.8762 164.022 43.6278 162.89C43.9554 162.391 44.0903 161.872 44.1481 161.508C45.4008 161.719 46.4222 161.7 47.1545 161.661C47.829 161.604 48.5228 161.546 49.3515 161.22C50.3536 160.817 51.4521 160.068 51.3364 159.684C51.2786 159.511 50.9317 159.454 50.238 159.319C49.5827 159.204 49.1009 159.185 48.9853 159.166C48.0025 159.089 47.2123 158.091 46.5764 157.265C43.5507 153.33 43.4351 152.984 42.6257 152.447C42.0475 152.063 40.7563 151.199 39.1761 151.429C37.5572 151.659 35.8999 152.984 35.4374 154.577C35.1868 155.46 35.3795 156.075 34.8592 156.555C34.2232 157.131 33.2211 156.919 32.7393 156.843C31.6601 156.689 29.9449 157.303 26.5146 158.513C20.7717 160.567 20.0393 162.122 17.3606 163.12C17.0908 163.216 16.3584 163.485 16.0501 164.138C15.7996 164.694 15.9152 165.289 16.0501 165.673C14.0844 167.094 12.4463 168.111 11.3671 168.745C8.26437 170.569 5.35435 172.738 2.13599 174.37C1.55784 174.581 0.574987 175.061 0.24737 176.04Z"
        fill="url(#pattern1_438_5922)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M78.7022 85.6586C77.9698 87.2712 77.9506 89.1525 76.9677 90.6691C76.139 91.9553 74.8864 93.0687 75.3296 94.7581C75.426 95.1228 75.9849 94.9693 75.8885 94.6045C75.426 92.8384 77.2953 91.5906 77.9313 90.1316C78.5094 88.7878 78.6058 87.3096 79.2225 85.9658C79.3574 85.6202 78.8563 85.3323 78.7022 85.6586Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.3101 95.5655C75.6377 96.9668 76.3122 98.2147 77.3143 99.2513C77.5071 99.4625 77.8154 99.1553 77.6227 98.9442C76.6784 97.9459 76.0424 96.7749 75.7341 95.4311C75.6763 95.1815 75.2523 95.2967 75.3101 95.5655Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.8673 93.9116C73.5568 94.2956 72.9786 95.7162 72.362 96.7912C71.4755 98.3462 70.6661 99.9396 69.8952 101.552C68.4498 104.662 67.1201 107.906 66.2914 111.228C64.4991 118.388 66.2143 125.606 67.9873 132.594C68.0644 132.863 68.4691 132.748 68.4113 132.479C66.7154 125.837 65.0002 118.887 66.5419 112.034C67.255 108.847 68.4884 105.737 69.8181 102.742C70.4926 101.226 71.2442 99.7284 72.0343 98.2502C72.6896 97.0408 73.5375 94.7371 74.9829 94.3148C75.2527 94.2572 75.1371 93.8349 74.8673 93.9116Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.7945 131.561C69.6445 139.355 71.6102 147.13 73.3254 154.943C74.1734 158.84 74.6937 162.776 75.0599 166.749C75.1562 167.748 75.2333 168.746 75.2911 169.744C75.3489 170.627 75.6187 171.741 75.4838 172.624C75.3682 173.392 74.6359 173.833 74.501 174.601C74.4046 175.119 74.501 175.58 74.713 176.041C74.8286 176.29 75.1948 176.079 75.0791 175.83C74.8093 175.254 74.8093 174.601 75.1562 174.044C75.3297 173.756 75.638 173.564 75.7922 173.257C76.062 172.662 75.8693 171.856 75.8307 171.242C75.6958 169.36 75.5609 167.498 75.3875 165.636C75.0213 161.893 74.4817 158.149 73.6723 154.482C71.9571 146.784 70.03 139.125 68.2184 131.465C68.1606 131.177 67.7367 131.292 67.7945 131.561Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.0753 178.938C46.7306 177.786 47.4244 176.654 48.1759 175.559C48.889 174.484 49.7755 172.699 51.1438 172.507C52.3964 172.334 53.784 172.488 55.0366 172.526C56.3278 172.565 57.619 172.622 58.9102 172.718C64.2485 173.102 69.5482 173.947 74.7322 175.233C75.002 175.291 75.1177 174.887 74.8479 174.811C69.2591 173.428 63.5547 172.545 57.8118 172.2C56.4049 172.123 54.9788 172.065 53.5527 172.046C52.5313 172.027 51.1631 171.797 50.2187 172.296C49.2552 172.814 48.5807 174.139 47.9832 175.003C47.1738 176.193 46.403 177.421 45.6706 178.669C45.555 178.957 45.9212 179.188 46.0753 178.938Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.6875 180.685C43.9359 182.144 43.6854 183.718 43.6854 185.331C43.6661 186.886 43.7239 188.537 44.6104 189.861C44.7646 190.092 45.15 189.88 44.9766 189.65C44.1286 188.383 44.1094 186.809 44.1094 185.35C44.1286 183.814 44.3406 182.298 45.0537 180.915C45.1886 180.666 44.8224 180.455 44.6875 180.685Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.6344 186.501C36.7093 182.776 37.8078 179.014 39.7542 175.788C40.6215 174.349 41.6043 172.736 43.0882 171.872C44.6878 170.97 46.6342 170.97 48.253 171.795C48.5036 171.93 48.7155 171.546 48.465 171.431C46.9426 170.644 45.1503 170.528 43.5507 171.162C41.8934 171.815 40.8334 173.274 39.8891 174.733C37.5958 178.246 36.1504 182.431 37.2104 186.616C37.2875 186.884 37.7114 186.769 37.6344 186.501Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.7668 172.259C46.5762 172.336 47.3085 172.259 48.0794 171.99C48.9659 171.703 50.2378 171.184 50.8545 172.24C50.9894 172.49 51.3748 172.259 51.2207 172.029C50.8545 171.415 50.2378 171.146 49.5248 171.165C49.043 171.184 48.5805 171.357 48.1179 171.511C47.3278 171.76 46.5955 171.895 45.7668 171.818C45.497 171.799 45.497 172.221 45.7668 172.259Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.2106 186.272C37.3648 187.193 37.9044 188 38.7523 188.46C39.9279 189.094 41.2769 188.499 42.4525 189.036C42.703 189.151 42.915 188.787 42.6645 188.672C41.855 188.288 41.0649 188.422 40.1977 188.384C38.868 188.326 37.8658 187.481 37.6346 186.176C37.5768 185.888 37.172 186.003 37.2106 186.272Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.5833 187.231C42.1828 187.769 42.7802 191.013 44.9579 190.034C45.2084 189.919 44.9965 189.554 44.7459 189.67C43.4933 190.226 42.7417 188.729 42.1443 187.942C41.7588 187.423 41.3348 187.04 40.6989 186.828C40.4291 186.713 40.3134 187.135 40.5833 187.231Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.6725 172.028C56.0001 169.494 56.771 167.056 57.9851 164.81C58.5247 163.812 59.1414 162.718 59.9701 161.93C61.2034 160.759 62.4561 161.143 63.728 162.026C63.9593 162.18 64.1713 161.815 63.94 161.662C63.015 161.009 62.0128 160.414 60.8565 160.855C59.681 161.297 58.9101 162.468 58.2934 163.466C56.6553 166.077 55.6532 169.014 55.2678 172.047C55.1907 172.297 55.6339 172.297 55.6725 172.028Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.0129 162.467C63.439 162.409 66.2912 161.104 67.0235 162.908C67.1199 163.158 67.5439 163.043 67.4475 162.793C66.5417 160.585 63.6895 161.968 62.0129 162.044C61.7431 162.044 61.7431 162.467 62.0129 162.467Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.8882 162.678C65.597 163.772 64.6719 165.154 64.1323 166.767C64.036 167.036 64.4599 167.151 64.5563 166.882C65.0766 165.346 65.9631 164.041 67.1965 162.985C67.4085 162.793 67.1001 162.486 66.8882 162.678Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.1697 168.13C61.9749 167.804 61.7244 166.537 63.3624 166.767C63.6901 166.825 64.0177 166.978 64.326 167.094C65.0391 167.362 65.9256 167.631 66.5615 168.092C67.3324 168.457 67.4095 168.783 66.8313 169.032C66.6579 169.32 66.4266 169.397 66.1376 169.244C65.8292 169.224 65.4823 169.052 65.1932 168.956C64.3838 168.668 63.5937 168.303 62.8421 167.881C62.5916 167.746 62.3796 168.111 62.6301 168.245C63.4203 168.687 64.2297 169.071 65.0776 169.359C65.6172 169.551 66.5808 170.012 67.1782 169.724C67.5058 169.57 67.66 169.186 67.6407 168.841C67.5829 168.149 66.9277 167.785 66.3688 167.497C65.5401 167.094 64.6922 166.748 63.825 166.46C63.2854 166.287 62.553 165.999 62.052 166.441C61.1077 167.286 62.264 168.322 63.0734 168.553C63.3239 168.629 63.4395 168.207 63.1697 168.13Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.0152 167.478C63.1501 167.574 63.285 167.67 63.4199 167.766C63.5162 167.843 63.6704 167.786 63.7089 167.69C63.7667 167.574 63.7282 167.459 63.6318 167.402C63.4969 167.306 63.362 167.21 63.2271 167.114C63.1308 167.037 62.9766 167.095 62.9381 167.19C62.861 167.286 62.9188 167.402 63.0152 167.478Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.6687 180.108C44.3025 180.108 43.9749 180.032 43.6473 179.878C43.3968 178.803 43.6473 178.381 44.3796 178.649C44.7458 178.707 45.0927 178.803 45.4588 178.88C46.3453 179.072 47.2511 179.245 48.1376 179.437C48.5037 179.513 50.0262 179.801 48.7543 180.55C48.523 180.684 47.7136 180.473 47.4438 180.454C46.4031 180.358 45.3625 180.204 44.3411 179.993C44.0713 179.936 43.9556 180.358 44.2254 180.416C45.2854 180.627 46.3646 180.78 47.4438 180.876C48.0027 180.934 49.0819 181.222 49.5637 180.78C49.8913 180.492 49.8528 179.974 49.6215 179.648C49.2168 179.072 48.3303 179.033 47.7136 178.899C46.6344 178.669 45.5745 178.419 44.4952 178.227C43.9942 178.131 43.3582 178.035 42.9728 178.458C42.6259 178.822 42.6644 179.417 42.9535 179.801C43.3389 180.358 44.052 180.473 44.688 180.512C44.9385 180.569 44.9385 180.128 44.6687 180.108Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.1479 179.304C44.4563 179.361 44.7839 179.4 45.0922 179.457C45.362 179.496 45.4777 179.093 45.2079 179.035C44.8995 178.977 44.5719 178.939 44.2635 178.881C43.9745 178.843 43.8588 179.265 44.1479 179.304Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.247 168.649C62.8037 170.012 62.5532 171.413 62.5146 172.853C62.5146 173.122 62.9386 173.122 62.9579 172.853C62.9964 171.452 63.247 170.108 63.6709 168.764C63.748 168.495 63.3433 168.38 63.247 168.649Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.8888 163.179C68.2185 163.659 69.4904 164.138 70.878 164.388C72.2463 164.638 73.5375 165.06 74.848 165.521C75.1178 165.617 75.2334 165.194 74.9636 165.098C73.6531 164.638 72.3619 164.215 70.9936 163.966C69.6061 163.716 68.3149 163.236 67.0044 162.756C66.7539 162.66 66.6383 163.083 66.8888 163.179Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.3059 170.856C67.3701 171.221 70.3764 171.893 73.325 172.814C73.5948 172.891 73.7104 172.488 73.4406 172.392C70.4535 171.451 67.4086 170.799 64.3059 170.415C64.0361 170.396 64.0361 170.818 64.3059 170.856Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.6589 119.274C93.1364 120.311 91.5947 121.443 90.978 123.248C90.8817 123.517 91.3056 123.632 91.402 123.363C91.9994 121.674 93.4833 120.618 94.8902 119.639C95.1214 119.504 94.8902 119.12 94.6589 119.274Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M91.1708 123.092C93.6762 131.539 95.2757 140.216 96.1815 148.97C97.0487 157.455 97.5112 166.113 96.8367 174.637C96.4513 179.455 95.6226 184.235 94.1001 188.823C94.0038 189.092 94.4277 189.207 94.5241 188.939C97.2029 180.837 97.7039 172.237 97.5112 163.771C97.3185 155.017 96.5669 146.263 95.0252 137.644C94.1387 132.691 93.0017 127.815 91.5756 122.996C91.4985 122.708 91.0938 122.823 91.1708 123.092Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.5336 190.051C50.8932 193.008 57.8696 194.121 64.8073 194.736C72.1498 195.369 79.6465 195.523 86.8541 193.757C89.8219 193.027 93.021 191.875 94.5627 189.034C94.6976 188.784 94.3122 188.573 94.1966 188.823C92.7512 191.491 89.7255 192.585 86.9312 193.296C83.5008 194.16 79.9741 194.582 76.4281 194.716C69.5674 194.966 62.4947 194.409 55.7497 193.123C51.9724 192.394 48.2723 191.318 44.7649 189.687C44.4951 189.552 44.2831 189.936 44.5336 190.051Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M81.902 96.2546C78.2211 100.516 76.0434 105.796 75.6194 111.382C75.1183 117.813 76.5252 124.359 77.8356 130.637C78.6258 134.38 79.5123 138.085 80.5144 141.771C80.5915 142.04 80.9962 141.925 80.9384 141.656C79.3003 135.628 77.932 129.523 76.9106 123.342C75.8699 117.18 75.3303 110.787 77.4309 104.797C78.4909 101.764 80.129 98.9806 82.2296 96.5617C82.3837 96.3506 82.0754 96.0434 81.902 96.2546Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M76.4473 107.619C79.3766 107.484 82.0939 106.448 84.3679 104.624C84.5799 104.451 84.2716 104.144 84.0596 104.317C81.8819 106.064 79.2417 107.062 76.4473 107.196C76.1582 107.196 76.1582 107.619 76.4473 107.619Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.835 109.154C80.321 109.115 82.4794 107.944 84.3488 106.389C84.5608 106.217 84.2524 105.91 84.0404 106.082C82.2674 107.56 80.1861 108.693 77.835 108.732C77.5459 108.732 77.5459 109.173 77.835 109.154Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M81.2654 146.245C83.5587 156.784 84.3874 167.592 83.7514 178.342C83.7322 178.611 84.1754 178.611 84.1947 178.342C84.8306 167.554 83.9827 156.707 81.6894 146.13C81.6123 145.861 81.2076 145.976 81.2654 146.245Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M82.4215 180.857C82.7299 179.955 83.1538 178.918 84.1174 178.554C84.368 178.458 84.2716 178.035 84.0018 178.131C82.884 178.554 82.3637 179.667 81.9975 180.723C81.9012 181.011 82.3252 181.107 82.4215 180.857Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.009 180.667C61.3386 182.356 71.9958 183.739 82.2869 181.07C82.5567 180.993 82.441 180.59 82.1712 180.648C71.9573 183.278 61.3772 181.915 51.1247 180.245C50.8549 180.206 50.7392 180.629 51.009 180.667Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M80.167 179.456C81.5931 180.359 82.7494 181.568 83.6167 183.027C83.7516 183.257 84.137 183.046 83.9828 182.816C83.0963 181.299 81.863 180.032 80.379 179.092C80.1478 178.938 79.9165 179.303 80.167 179.456Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.43 99.0783C103.755 101.017 102.869 102.86 101.77 104.588C101.616 104.818 102.001 105.049 102.136 104.799C103.254 103.033 104.16 101.152 104.834 99.1934C104.931 98.9247 104.526 98.8287 104.43 99.0783Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.3205 98.5584C97.6846 100.094 96.9908 101.611 96.2392 103.089C96.1043 103.338 96.4897 103.55 96.6054 103.3C97.3762 101.783 98.07 100.229 98.7252 98.6543C98.8409 98.424 98.4169 98.3088 98.3205 98.5584Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.19 99.0788C99.7656 100.653 99.1681 102.15 98.378 103.59C98.2431 103.84 98.6093 104.051 98.7442 103.801C99.5536 102.342 100.17 100.806 100.594 99.1939C100.671 98.9252 100.247 98.81 100.19 99.0788Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.545 180.205C33.3566 180.877 35.1874 181.492 37.0374 182.048C37.3072 182.125 37.4229 181.722 37.1531 181.626C35.303 181.05 33.4722 180.436 31.6607 179.783C31.4101 179.706 31.2945 180.109 31.545 180.205Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.3659 178.955C0.961198 178.111 0.74921 177.208 0.787753 176.268C0.826297 175.442 1.07683 175.116 1.75133 174.713C2.07895 174.502 2.40657 174.31 2.71492 174.118C4.23737 173.196 5.74056 172.256 7.26302 171.334C10.2308 169.51 13.1987 167.687 16.1858 165.863C16.8796 165.441 17.5926 164.999 18.3635 164.749C19.3463 164.423 20.0401 164.673 20.9651 164.845C21.8516 165.018 22.0829 164.365 22.0829 163.617C22.0829 162.542 22.8538 162.158 23.721 161.755C24.5689 161.352 25.4747 160.968 26.4383 160.891C28.0378 160.756 29.9264 161.697 29.9072 163.502C29.9072 163.77 30.3311 163.77 30.3311 163.502C30.3697 161.294 28.0186 160.219 26.0721 160.507C24.8195 160.699 23.4319 161.294 22.372 161.966C22.0636 162.158 21.8131 162.369 21.6975 162.734C21.6396 162.906 21.6396 163.079 21.6204 163.271C21.6204 163.425 21.6782 163.636 21.6396 163.77C21.5433 164.058 20.9651 164.346 20.6568 164.327C20.1365 164.308 19.7125 164.097 19.1729 164.154C18.4984 164.231 17.8817 164.481 17.2843 164.769C15.7618 165.517 14.3357 166.516 12.8903 167.418C9.98032 169.203 7.05103 170.989 4.14102 172.793C3.33161 173.292 2.5222 173.791 1.71279 174.29C1.25027 174.578 0.74921 174.79 0.537222 175.327C0.0554318 176.537 0.479407 178.13 0.999741 179.243C1.11537 179.435 1.48153 179.205 1.3659 178.955Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.0952 178.901C2.00097 181.896 5.21933 183.201 8.14861 183.009C9.05438 182.952 9.96015 182.779 10.8466 182.529C11.8488 182.26 12.8509 181.742 13.8916 181.646C14.8744 181.569 15.838 181.992 16.8208 181.973C17.6303 181.973 18.4011 181.761 19.1527 181.454C19.4032 181.339 19.1913 180.974 18.9407 181.089C17.9579 181.512 16.9557 181.627 15.9151 181.473C15.2406 181.377 14.5853 181.166 13.9108 181.224C12.4269 181.32 10.9815 182.126 9.5169 182.395C6.43344 182.971 2.54057 182.164 1.51918 178.786C1.42282 178.517 0.998843 178.632 1.0952 178.901Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6134 181.586C20.1359 182.238 21.5813 181.624 22.9688 180.933C23.2193 180.799 23.0074 180.434 22.7568 180.568C21.5427 181.183 20.1937 181.816 18.8447 181.221C18.5749 181.087 18.3436 181.471 18.6134 181.586Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5258 180.992C23.8941 181.99 25.5515 181.011 27.0739 181.107C28.5193 181.184 30.1574 181.645 31.2366 180.359C31.41 180.147 31.1017 179.84 30.9282 180.051C29.849 181.318 28.1531 180.666 26.727 180.647C25.3973 180.647 23.9519 181.491 22.7571 180.608C22.5258 180.455 22.3138 180.819 22.5258 180.992Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.5703 178.094C26.611 178.036 27.6324 177.863 28.6345 177.537C29.3476 177.307 30.1955 176.923 30.8315 177.537C31.4867 178.19 31.2362 179.514 30.9086 180.224C30.7929 180.474 31.1591 180.685 31.2747 180.436C31.7758 179.361 31.9492 177.575 30.7544 176.846C30.1762 176.481 29.5981 176.731 29.0007 176.942C27.8829 177.345 26.7459 177.575 25.5703 177.652C25.2812 177.69 25.2812 178.113 25.5703 178.094Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.3519 173.409C31.5639 174.734 30.8316 176.02 29.6367 176.577C29.3862 176.692 29.5982 177.076 29.8487 176.941C31.2363 176.289 32.0072 174.791 31.7566 173.275C31.7181 173.025 31.3134 173.14 31.3519 173.409Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.0326 165.213C27.0347 164.464 28.403 163.696 29.7135 163.677C30.7349 163.677 31.0047 164.33 31.5636 164.944C31.9683 165.367 32.4308 165.674 32.7391 166.192C33.0475 166.71 33.1824 167.306 33.4907 167.824C33.7991 168.361 34.1652 168.86 34.4929 169.379C35.2252 170.569 35.8611 171.836 36.4008 173.122C36.4971 173.372 36.9211 173.257 36.8247 173.007C36.208 171.529 35.4757 170.089 34.6085 168.726C34.1267 167.958 33.7413 167.267 33.3558 166.461C33.1053 165.904 32.8355 165.52 32.373 165.098C31.4865 164.292 31.0432 163.217 29.7135 163.255C28.3259 163.293 26.8998 164.042 25.8206 164.848C25.5894 165.002 25.8014 165.386 26.0326 165.213Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.8486 172.776C31.159 173.717 32.7008 174.082 34.3003 173.871C34.5701 173.832 34.4545 173.41 34.1847 173.448C32.7008 173.659 31.2747 173.275 30.0605 172.392C29.8486 172.239 29.6366 172.604 29.8486 172.776Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.9537 174.099C34.0501 175.424 35.2449 176.461 36.5747 176.365C36.8445 176.346 36.8445 175.904 36.5747 175.923C35.4955 176 34.4741 175.194 34.397 174.099C34.3777 173.831 33.9345 173.811 33.9537 174.099Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.2231 174.024C35.0518 174.177 35.8612 173.947 36.4586 173.333C36.6513 173.141 36.343 172.834 36.1503 173.026C35.6685 173.506 35.0132 173.717 34.3387 173.602C34.0497 173.563 33.934 173.966 34.2231 174.024Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.5338 173.849C35.8036 174.271 36.1312 174.655 36.5166 174.962C36.6708 175.078 36.9984 175.212 36.9984 175.404C36.9984 175.615 36.4395 175.826 36.2661 175.922C36.0156 176.057 36.2468 176.441 36.4781 176.287C36.825 176.095 37.8271 175.749 37.5187 175.174C37.3646 174.905 36.9984 174.77 36.7672 174.598C36.4203 174.329 36.1505 173.983 35.9192 173.619C35.765 173.388 35.3796 173.599 35.5338 173.849Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.919 173.697C37.3451 174.33 38.829 174.58 40.3707 174.426C40.6405 174.407 40.6405 173.965 40.3707 173.985C38.9061 174.138 37.48 173.908 36.131 173.313C35.8804 173.217 35.6684 173.582 35.919 173.697Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.36471 179.11C3.02207 176.135 5.89354 174.253 8.89992 172.833C12.4459 171.163 16.2231 169.896 19.9618 168.725C20.2316 168.648 20.116 168.225 19.8462 168.302C15.9919 169.531 12.0797 170.817 8.41812 172.583C5.43102 174.023 2.63664 175.962 0.979278 178.899C0.863648 179.129 1.22981 179.36 1.36471 179.11Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.7002 166.672C22.9871 166.979 22.2933 167.325 21.6188 167.728C21.2141 167.958 20.6167 168.246 20.3855 168.707C19.9615 169.609 20.9829 170.435 21.561 170.934C23.7773 172.815 26.4175 174.236 27.1305 177.269C27.1883 177.538 27.6123 177.423 27.5545 177.154C27.0534 175.023 25.6273 173.564 23.9507 172.259C23.1028 171.606 22.2163 170.972 21.4261 170.243C21.3105 170.147 21.2141 170.051 21.1178 169.936C21.1563 169.437 21.2141 168.937 21.2527 168.458C21.3876 168.285 21.9272 168.054 22.1199 167.939C22.6981 167.613 23.2955 167.325 23.9122 167.056C24.182 166.941 23.97 166.576 23.7002 166.672Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.8761 166.4C24.1053 166.842 25.0303 168.435 25.3579 168.934C26.0324 169.952 27.0346 170.681 28.2101 171.046C28.4799 171.123 28.5956 170.7 28.3258 170.624C27.4778 170.374 26.7262 169.913 26.1481 169.241C25.9361 169.011 24.6063 167.072 25.1267 166.784C25.3387 166.631 25.1074 166.266 24.8761 166.4Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.79088 180.744C2.61744 180.36 4.06281 179.611 4.33261 179.477C4.91076 179.189 5.52745 178.997 6.18269 178.882C6.45249 178.824 6.33686 178.421 6.06706 178.46C5.10347 178.632 4.15917 178.997 3.34976 179.554C2.88724 179.861 2.13564 180.322 2.42472 180.955C2.52108 181.224 2.90651 180.994 2.79088 180.744Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.04849 178.571C5.60524 178.015 5.81723 177.055 6.47246 176.767C7.22405 176.421 8.11055 177.112 8.11055 177.9C8.11055 178.168 8.5538 178.188 8.5538 177.9C8.5538 176.825 7.35896 175.903 6.31829 176.364C5.35471 176.805 5.14272 178.092 5.75941 178.879C5.91358 179.09 6.22193 178.783 6.04849 178.571Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.47622 178.091C9.42053 177.765 10.3648 177.458 11.3092 177.131C11.579 177.035 11.4633 176.632 11.1935 176.709C10.2492 177.035 9.3049 177.342 8.36059 177.669C8.09079 177.765 8.20642 178.168 8.47622 178.091Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3669 176.883C10.6539 173.965 15.4718 174.349 17.1484 174.119C19.2297 173.831 21.2532 173.236 23.1804 172.391C23.4309 172.276 23.219 171.911 22.9684 172.026C20.174 173.255 17.3796 173.696 14.3733 173.907C12.6966 174.023 10.4611 174.906 10.9622 176.998C11.02 177.267 11.4247 177.152 11.3669 176.883Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.53624 179.226C9.59405 179.207 9.65187 179.188 9.69041 179.169C9.74822 179.073 9.78677 178.996 9.84458 178.9C9.74822 178.862 9.67114 178.842 9.57478 178.804C9.49769 178.919 9.42061 179.015 9.32425 179.13C10.6733 179.61 11.8488 180.417 12.7931 181.511C12.9666 181.722 13.2749 181.415 13.1015 181.204C12.1186 180.052 10.866 179.226 9.43988 178.727C9.24716 178.65 9.11226 178.881 9.18935 179.054C9.34352 179.361 9.61332 179.476 9.94094 179.342C10.0566 179.303 10.1337 179.207 10.0951 179.073C9.86385 178.324 8.86173 178.631 9.09299 179.361C9.20862 179.61 9.61332 179.495 9.53624 179.226Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7594 178.42C14.7594 178.439 14.7594 178.478 14.7594 178.497C14.8365 178.42 14.9135 178.343 14.9714 178.286C14.8557 178.267 14.7401 178.267 14.6245 178.247C14.6823 178.324 14.7401 178.382 14.7786 178.459C14.7594 178.689 15.4532 179.13 15.6073 179.265C15.8964 179.514 16.1662 179.745 16.4553 179.994C17.0142 180.493 17.5538 180.993 18.0934 181.511C18.2861 181.703 18.5944 181.396 18.4017 181.204C17.4381 180.282 16.436 179.38 15.3953 178.516C15.1063 178.267 14.4318 177.748 14.3547 178.459C14.3354 178.555 14.4318 178.651 14.5088 178.67C14.7594 178.747 14.7208 178.747 14.9714 178.727C15.087 178.727 15.2026 178.631 15.1834 178.516C15.0677 177.422 13.6416 178.401 14.5281 178.823C14.7786 178.919 15.0099 178.555 14.7594 178.42Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2478 177.806C18.3249 177.787 18.3827 177.787 18.4598 177.767C18.5368 177.652 18.6139 177.556 18.7103 177.441C18.6332 177.383 18.5368 177.345 18.4598 177.287C18.4598 177.383 18.4598 177.499 18.4598 177.595C18.7103 177.383 20.1942 178.881 20.4255 179.13C21.0422 179.764 21.5432 180.455 22.0057 181.204C22.1406 181.434 22.5261 181.223 22.3719 180.993C21.7552 179.937 20.9843 178.996 20.0593 178.171C19.6546 177.806 18.7296 176.788 18.1514 177.287C18.055 177.364 18.0743 177.518 18.1514 177.595C18.3441 177.767 18.3441 177.787 18.5947 177.863C18.7681 177.921 18.9608 177.691 18.8452 177.537C18.6139 177.23 18.2092 177.153 17.9587 177.499C17.766 177.729 18.0743 178.036 18.2478 177.806Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.2177 176.789C22.1599 176.789 22.102 176.77 22.0442 176.77C22.1599 176.75 22.2755 176.731 22.3911 176.731C22.2948 176.654 22.2177 176.578 22.1213 176.52C22.0828 176.635 22.0635 176.77 22.025 176.885C22.8536 176.75 23.9714 178.209 24.3761 178.785C24.8772 179.476 25.224 180.263 25.4553 181.089C25.5324 181.358 25.9564 181.243 25.8793 180.974C25.5709 179.88 25.0506 178.862 24.299 177.979C23.7401 177.326 22.8536 176.309 21.9093 176.462C21.7552 176.482 21.6973 176.731 21.813 176.827C21.9093 176.904 21.9864 176.981 22.0828 177.038C22.1791 177.115 22.3526 177.134 22.4297 177C22.8922 176.078 21.2926 176.232 21.8515 177.019C22.0057 177.23 22.3911 177.019 22.2177 176.789Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2048 165.135C15.7037 163.523 18.0934 162.697 19.1919 162.102C20.3867 161.45 21.6008 160.816 22.8342 160.221C25.301 158.992 27.9219 157.725 30.6199 157.13C31.3523 156.977 32.0846 156.919 32.8362 156.996C33.2794 157.053 33.7419 157.169 34.1852 157.111C34.8597 157.015 35.2258 156.612 35.3607 155.978C35.4957 155.287 35.3607 154.711 35.7847 154.078C36.1123 153.598 36.5941 153.176 37.0374 152.792C38.1937 151.755 39.7932 150.93 41.2579 151.87C41.4891 152.024 41.7011 151.64 41.4699 151.505C39.3114 150.104 36.729 152.062 35.4378 153.79C35.168 154.155 35.0524 154.462 34.9946 154.903C34.879 155.786 34.8211 156.746 33.6648 156.689C32.9325 156.65 32.2966 156.478 31.545 156.554C30.8512 156.612 30.1767 156.785 29.5022 156.996C26.5536 157.898 23.74 159.261 21.0034 160.682C19.6158 161.392 18.1126 162.064 16.8214 162.947C16.012 163.485 15.4724 164.291 15.7615 165.289C15.8579 165.5 16.2818 165.385 16.2048 165.135Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.2195 151.467C41.1039 152.139 41.9711 152.196 42.4336 152.446C43.4935 153.041 44.2066 154.193 44.9196 155.114C45.5556 155.959 46.153 156.842 46.8853 157.629C47.1744 157.936 47.4828 158.224 47.8104 158.454C48.3885 158.858 49.1016 159.069 49.4677 159.702C49.6026 159.933 49.9881 159.721 49.8339 159.491C49.4099 158.762 48.6776 158.55 48.0031 158.09C47.001 157.379 46.3265 156.285 45.5942 155.325C45.0353 154.577 44.4957 153.809 43.8597 153.118C43.5899 152.811 43.3008 152.542 42.9732 152.292C42.8961 152.235 41.6242 151.563 41.6049 151.563C41.7013 151.313 41.2773 151.198 41.2195 151.467Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.8157 159.741C42.9142 161.008 44.4944 161.776 46.1903 161.814C46.8841 161.833 47.6357 161.756 48.2139 161.315C48.9076 160.797 49.1967 159.837 50.0447 159.491C50.2952 159.395 50.1796 158.973 49.929 159.069C48.6378 159.587 48.3873 161.142 46.8841 161.315C45.0726 161.545 43.3189 160.758 42.1433 159.395C41.9313 159.222 41.623 159.53 41.8157 159.741Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.1187 161.333C49.5062 161.525 51.4912 161.256 51.5297 159.471C51.5297 159.202 51.1058 159.202 51.0865 159.471C51.048 160.93 49.3135 161.064 48.215 160.93C47.9645 160.892 47.8489 161.314 48.1187 161.333Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.0843 159.473C50.4697 159.3 50.913 159.435 51.1828 159.742C51.3562 159.953 51.6646 159.646 51.4911 159.435C51.0864 158.955 50.4119 158.839 49.853 159.089C49.6025 159.223 49.8337 159.588 50.0843 159.473Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.2082 160.854C28.3067 159.491 29.7135 159.549 31.3131 159.491C32.4886 159.453 33.6064 159.165 34.6663 158.627C34.9169 158.512 34.7049 158.128 34.4544 158.263C33.6257 158.685 32.7392 158.954 31.8141 159.03C31.0818 159.088 30.3302 159.011 29.5979 159.088C28.4994 159.203 27.5937 159.702 26.8999 160.547C26.7264 160.758 27.0348 161.065 27.2082 160.854Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.7973 152.061C40.8145 152.503 39.9473 153.117 39.1957 153.885C38.6946 154.403 37.8659 155.21 38.1357 155.997C38.2321 156.265 38.6561 156.15 38.5597 155.881C38.2899 155.152 39.5426 154.115 40.0051 153.712C40.6025 153.194 41.277 152.772 42.0093 152.445C42.2791 152.311 42.0479 151.946 41.7973 152.061Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.29 156.764C38.7718 157.455 39.4078 158.012 40.1594 158.396C40.4099 158.511 40.6219 158.146 40.3714 158.031C39.6776 157.685 39.0802 157.186 38.6562 156.553C38.502 156.322 38.1359 156.533 38.29 156.764Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.3543 159.414C34.2622 159.645 35.6305 161.085 37.2493 161.968C38.0587 162.409 38.9452 162.659 39.6582 163.292C40.3713 163.964 40.8531 164.847 41.3156 165.692C41.4505 165.942 41.8167 165.711 41.6818 165.481C41.2193 164.636 40.7375 163.772 40.063 163.081C39.3306 162.352 38.3671 162.083 37.4806 161.584C35.7654 160.643 34.3778 159.203 32.3736 158.954C32.0845 158.935 32.0845 159.376 32.3543 159.414Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.6066 164.731C33.5873 164.693 33.5488 164.654 33.5295 164.616C33.4717 164.75 33.4139 164.885 33.3561 165.019C35.5338 165.326 37.326 166.804 38.0005 168.897C38.0776 169.166 38.5016 169.05 38.4245 168.782C37.7115 166.555 35.8036 164.923 33.4717 164.597C33.2405 164.558 33.067 164.865 33.2983 165C33.7608 165.268 34.416 164.808 33.9535 164.328C33.5488 163.905 33.1055 164.405 33.1826 164.846C33.2405 165.115 33.6644 165 33.6066 164.731Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.6087 169.591C36.1697 170.109 37.8078 169.783 39.0412 168.708C39.2532 168.516 38.9448 168.228 38.7328 168.401C37.6151 169.38 36.1119 169.649 34.7051 169.188C34.4738 169.073 34.3582 169.495 34.6087 169.591Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.2301 166.631C38.1744 166.094 39.215 165.787 40.3135 165.806C41.3156 165.825 43.821 166.439 42.7803 167.956C42.6261 168.186 42.9923 168.398 43.1465 168.167C43.898 167.073 42.9537 165.979 41.8745 165.614C40.2557 165.076 38.4442 165.403 36.9988 166.247C36.7675 166.401 36.9795 166.785 37.2301 166.631Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.5786 168.591C38.8484 169.302 40.1396 168.956 40.737 168.956C41.5464 168.937 42.3944 168.937 42.9533 168.265C43.1267 168.054 42.8184 167.747 42.6449 167.958C42.2017 168.495 41.5464 168.495 40.8912 168.514C40.6792 168.514 39.0797 168.668 39.0026 168.476C38.9062 168.207 38.4822 168.322 38.5786 168.591Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.1286 161.526C44.2828 162.563 42.8567 163.024 42.2785 163.676C41.816 164.176 41.5269 164.809 41.2186 165.404C41.103 165.654 41.4691 165.865 41.5847 165.615C41.7967 165.174 42.028 164.713 42.2978 164.31C42.6832 163.753 43.2421 163.427 43.7624 163.024C44.302 162.601 44.6297 162.083 44.5333 161.392C44.4948 161.142 44.0708 161.258 44.1286 161.526Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.8381 168.244C46.9237 169.262 50.99 170.26 55.0756 171.277C55.3454 171.354 55.461 170.932 55.1912 170.855C51.1057 169.837 47.0393 168.839 42.9538 167.822C42.684 167.764 42.5683 168.187 42.8381 168.244Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.3303 161.507C51.6836 162.025 55.0176 162.582 58.3516 163.215C58.6214 163.273 58.737 162.851 58.4672 162.793C55.1332 162.16 51.7992 161.584 48.4459 161.085C48.1761 161.046 48.0605 161.449 48.3303 161.507Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.9768 161.681C44.996 162.641 43.7048 163.236 43.146 163.889C42.6449 164.484 42.3173 165.175 42.1246 165.924C42.0475 166.193 42.4714 166.308 42.5485 166.039C42.8569 164.907 43.4736 164.081 44.3601 163.352C44.9189 162.91 45.42 162.449 45.4007 161.681C45.42 161.413 44.9768 161.394 44.9768 161.681Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.8544 165.671C42.0664 165.287 42.2784 164.922 42.5674 164.596C42.4518 164.519 42.3169 164.461 42.2013 164.385C42.0664 164.749 41.9508 165.133 41.8158 165.498C41.7388 165.728 42.1049 165.882 42.2206 165.671C42.3555 165.383 42.4904 165.095 42.6253 164.807C42.7409 164.557 42.3747 164.346 42.2591 164.596C42.1627 164.769 42.0664 164.961 41.97 165.133C42.1049 165.172 42.2398 165.21 42.3747 165.249C42.4711 164.231 43.4925 163.809 44.1092 163.137C44.4946 162.714 44.7259 162.215 44.88 161.678C44.7451 161.697 44.6102 161.716 44.4753 161.735C44.8993 162.369 43.2612 163.463 42.8758 163.866C42.394 164.346 42.0086 164.884 41.8737 165.556C41.8159 165.824 42.2398 165.94 42.2976 165.671C42.5289 164.557 43.4732 163.924 44.2441 163.194C44.6873 162.772 45.2847 162.158 44.8608 161.524C44.7644 161.371 44.5139 161.39 44.4561 161.582C44.167 162.599 43.4925 163.079 42.7409 163.77C42.2976 164.193 42.0086 164.634 41.9315 165.268C41.9122 165.479 42.2398 165.556 42.3362 165.383C42.4325 165.21 42.5289 165.018 42.6253 164.845C42.5096 164.769 42.3747 164.692 42.2591 164.634C42.1242 164.922 41.9893 165.21 41.8544 165.498C41.9893 165.556 42.1242 165.613 42.2591 165.671C42.394 165.306 42.5096 164.922 42.6445 164.557C42.7216 164.365 42.4133 164.173 42.2784 164.346C41.97 164.711 41.7195 165.095 41.4882 165.517C41.3533 165.69 41.7388 165.92 41.8544 165.671Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.404 165.135C73.7102 166.633 73.6909 168.053 73.8066 169.685C73.8644 170.683 73.7488 171.586 73.5368 172.565C73.3826 173.256 73.3055 173.928 73.4019 174.638C73.4404 174.907 73.8644 174.792 73.8259 174.523C73.5946 173.045 74.3269 171.566 74.2691 170.05C74.192 168.38 74.0571 166.921 74.7894 165.346C74.9051 165.097 74.5389 164.886 74.404 165.135Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M73.9618 174.37C73.9618 173.218 74.1738 172.124 74.5785 171.049C74.6749 170.78 74.2509 170.684 74.1545 170.934C73.7305 172.047 73.5378 173.18 73.5186 174.37C73.5378 174.639 73.9618 174.639 73.9618 174.37Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.1922 174.483C74.1537 173.446 74.3657 172.467 74.8667 171.546C75.0016 171.296 74.6162 171.085 74.5006 171.335C73.961 172.314 73.7104 173.369 73.749 174.502C73.7682 174.752 74.2115 174.752 74.1922 174.483Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.3854 174.754C74.5782 173.718 74.8287 172.72 75.137 171.721C75.2141 171.453 74.8094 171.337 74.7131 171.606C74.4047 172.604 74.1542 173.622 73.9615 174.639C73.9229 174.908 74.3469 175.023 74.3854 174.754Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.3853 174.675C74.501 173.561 74.8093 172.524 75.3296 171.526C75.4645 171.277 75.0791 171.065 74.9635 171.315C74.4239 172.371 74.0963 173.484 73.9614 174.675C73.9228 174.962 74.3661 174.962 74.3853 174.675Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.539 174.965C74.7895 173.986 75.1171 173.026 75.5218 172.085C75.6375 171.836 75.252 171.606 75.1557 171.874C74.7317 172.853 74.4041 173.832 74.1343 174.85C74.0379 175.119 74.4619 175.234 74.539 174.965Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.6747 174.58C74.9831 173.889 75.2914 173.179 75.5997 172.488C75.7154 172.238 75.3299 172.008 75.2336 172.277C74.9252 172.968 74.6169 173.678 74.3085 174.369C74.1736 174.619 74.5591 174.83 74.6747 174.58Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.311 173.601C75.6579 172.929 75.8121 172.181 75.6964 171.432C75.6579 171.163 75.2339 171.163 75.2532 171.432C75.3495 172.123 75.2339 172.776 74.9256 173.39C74.8099 173.621 75.1761 173.851 75.311 173.601Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.2894 166.208C74.2508 168.051 74.2315 169.894 74.2701 171.718C74.405 171.699 74.5592 171.679 74.6941 171.66C74.3857 169.932 74.4243 168.224 74.8097 166.515C74.8675 166.247 74.4628 166.131 74.3857 166.4C74.0003 167.802 73.9232 169.184 74.1352 170.624C74.1737 170.892 74.5977 170.777 74.5592 170.508C74.3664 169.165 74.4435 167.84 74.8097 166.515C74.6748 166.477 74.5399 166.439 74.3857 166.4C73.981 168.185 73.9425 169.99 74.2701 171.775C74.3086 172.025 74.6941 171.967 74.6941 171.718C74.6555 169.875 74.6748 168.032 74.7133 166.208C74.7326 165.92 74.3086 165.92 74.2894 166.208Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.4649 168.266C75.7347 168.266 75.7539 167.824 75.4649 167.824C75.1758 167.843 75.1758 168.266 75.4649 168.266Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.5015 165.345C74.3666 167.341 74.4052 169.338 74.6172 171.334C74.6557 171.603 75.0797 171.603 75.0604 171.334C74.8292 169.338 74.7906 167.341 74.9448 165.345C74.9641 165.057 74.5208 165.057 74.5015 165.345Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.6549 165.346C74.732 167.343 74.8091 169.339 74.9054 171.336C74.9247 171.604 75.3487 171.624 75.3487 171.336C75.2716 169.339 75.1945 167.343 75.0982 165.346C75.0789 165.077 74.6356 165.077 74.6549 165.346Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.7126 165.443C74.9824 167.727 75.1365 170.031 75.1365 172.354C75.1365 172.622 75.5798 172.641 75.5798 172.354C75.5798 170.05 75.4256 167.746 75.1558 165.443C75.1173 165.155 74.6933 165.155 74.7126 165.443Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.2026 164.884C97.8964 172.851 98.5516 181.029 96.1812 188.804C96.1041 189.072 96.5281 189.188 96.6052 188.919C98.9756 181.125 98.3204 172.889 97.6458 164.884C97.6073 164.596 97.1833 164.596 97.2026 164.884Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.2607 166.516C97.5112 173.983 96.5476 181.432 94.3892 188.592C94.3121 188.861 94.7361 188.976 94.8132 188.708C96.9716 181.509 97.9352 174.022 97.7039 166.535C97.6847 166.247 97.2607 166.247 97.2607 166.516Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.4337 169.877C97.3952 176.155 96.5087 182.394 94.7935 188.441C94.7164 188.71 95.1404 188.825 95.2175 188.556C96.9519 182.471 97.8384 176.193 97.8577 169.877C97.8577 169.609 97.4337 169.609 97.4337 169.877Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.3186 171.431C97.5499 177.19 96.779 182.93 95.0253 188.44C94.9482 188.708 95.3529 188.823 95.4493 188.555C97.203 183.026 97.9932 177.228 97.7619 171.431C97.7426 171.143 97.3186 171.143 97.3186 171.431Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.685 172.967C97.685 178.323 96.8563 183.602 95.2568 188.709C95.1797 188.978 95.5844 189.093 95.6807 188.824C97.2996 183.679 98.1282 178.342 98.1282 172.967C98.1282 172.698 97.685 172.698 97.685 172.967Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.5308 178.88C97.4152 182.24 96.837 185.522 95.8349 188.728C95.7578 188.997 96.1625 189.112 96.2589 188.843C97.2803 185.599 97.8584 182.259 97.974 178.88C97.974 178.592 97.5501 178.592 97.5308 178.88Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.2409 182.165C96.9325 184.392 96.5086 186.58 95.7184 188.673C95.8533 188.711 95.9882 188.749 96.1424 188.788C96.7976 186.676 97.2409 184.526 97.4529 182.318C97.4721 182.05 97.0482 182.05 97.0096 182.318C96.7976 184.488 96.3544 186.599 95.6992 188.673C95.6221 188.941 96.0268 189.037 96.1231 188.788C96.9325 186.695 97.3565 184.507 97.6456 182.28C97.6841 182.011 97.2794 181.896 97.2409 182.165Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.5047 188.823C97.4725 189.438 100.479 189.476 103.447 188.939C103.717 188.881 103.601 188.478 103.331 188.516C100.44 189.035 97.4918 188.996 94.601 188.401C94.3312 188.363 94.2156 188.766 94.5047 188.823Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.6885 174.33C27.0546 174.33 27.0546 173.754 26.6885 173.754C26.3031 173.754 26.3031 174.33 26.6885 174.33Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.0949 173.006C28.4611 173.006 28.4611 172.43 28.0949 172.43C27.7288 172.43 27.7288 173.006 28.0949 173.006Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.791 171.279C29.791 171.26 29.791 171.241 29.791 171.241C29.791 171.088 29.6561 170.953 29.502 170.953C29.3478 170.953 29.2129 171.088 29.2129 171.241C29.2129 171.26 29.2129 171.279 29.2129 171.279C29.2129 171.433 29.3478 171.567 29.502 171.567C29.6754 171.548 29.791 171.433 29.791 171.279Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.8313 170.279C31.1974 170.279 31.1974 169.703 30.8313 169.703C30.4651 169.703 30.4651 170.279 30.8313 170.279Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.2578 169.013C32.624 169.013 32.624 168.438 32.2578 168.438C31.8724 168.438 31.8724 169.013 32.2578 169.013Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.8313 167.513C31.1974 167.513 31.1974 166.938 30.8313 166.938C30.4651 166.938 30.4651 167.513 30.8313 167.513Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.2573 165.578C32.238 165.578 32.2188 165.578 32.2188 165.578C32.0646 165.578 31.9297 165.713 31.9297 165.866C31.9297 166.02 32.0646 166.154 32.2188 166.154C32.238 166.154 32.2573 166.154 32.2573 166.154C32.4115 166.154 32.5464 166.02 32.5464 165.866C32.5271 165.713 32.4115 165.578 32.2573 165.578Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.4143 169.801C33.3951 169.82 33.3758 169.84 33.3758 169.84C33.2602 169.955 33.2602 170.128 33.3758 170.243C33.4914 170.358 33.6649 170.358 33.7805 170.243C33.7998 170.224 33.819 170.204 33.819 170.204C33.9347 170.089 33.9347 169.916 33.819 169.801C33.7227 169.686 33.53 169.686 33.4143 169.801Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.9942 171.564C35.3603 171.564 35.3603 170.988 34.9942 170.988C34.6087 170.988 34.6087 171.564 34.9942 171.564Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.6643 173.006C34.0304 173.006 34.0304 172.43 33.6643 172.43C33.2981 172.43 33.2981 173.006 33.6643 173.006Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.5847 171.238C32.5654 171.219 32.5461 171.2 32.5461 171.2C32.4305 171.084 32.257 171.084 32.1414 171.2C32.0258 171.315 32.0258 171.488 32.1414 171.603C32.1607 171.622 32.18 171.641 32.18 171.641C32.2956 171.756 32.469 171.756 32.5847 171.641C32.7003 171.545 32.7003 171.353 32.5847 171.238Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.8313 172.927C31.1974 172.927 31.1974 172.352 30.8313 172.352C30.4651 172.352 30.4651 172.927 30.8313 172.927Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.1201 175.365C31.1201 175.346 31.1201 175.327 31.1201 175.327C31.1201 175.173 30.9852 175.039 30.8311 175.039C30.6769 175.039 30.542 175.173 30.542 175.327C30.542 175.346 30.542 175.365 30.542 175.365C30.542 175.519 30.6769 175.653 30.8311 175.653C30.9852 175.653 31.1201 175.519 31.1201 175.365Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.4631 174.388C29.8293 174.388 29.8293 173.812 29.4631 173.812C29.0969 173.812 29.0969 174.388 29.4631 174.388Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.211 175.635C28.211 175.616 28.211 175.597 28.211 175.597C28.211 175.443 28.0761 175.309 27.9219 175.309C27.7677 175.309 27.6328 175.443 27.6328 175.597C27.6328 175.616 27.6328 175.635 27.6328 175.635C27.6328 175.789 27.7677 175.923 27.9219 175.923C28.0761 175.904 28.211 175.789 28.211 175.635Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.0949 178.552C28.4611 178.552 28.4611 177.977 28.0949 177.977C27.7288 177.977 27.7288 178.552 28.0949 178.552Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.3858 179.974C29.7519 179.974 29.7519 179.398 29.3858 179.398C29.0003 179.398 29.0003 179.974 29.3858 179.974Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.1198 178.285C31.1005 178.266 31.0813 178.247 31.0813 178.247C30.9656 178.131 30.7922 178.131 30.6766 178.247C30.5609 178.362 30.5609 178.535 30.6766 178.65C30.6958 178.669 30.7151 178.688 30.7151 178.688C30.8307 178.803 31.0042 178.803 31.1198 178.688C31.2354 178.592 31.2354 178.4 31.1198 178.285Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.688 179.438C26.6687 179.438 26.6494 179.438 26.6494 179.438C26.4953 179.438 26.3604 179.572 26.3604 179.725C26.3604 179.879 26.4953 180.013 26.6494 180.013C26.6687 180.013 26.688 180.013 26.688 180.013C26.8421 180.013 26.977 179.879 26.977 179.725C26.9578 179.572 26.8421 179.438 26.688 179.438Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.3576 178.552C25.7238 178.552 25.7238 177.977 25.3576 177.977C24.9915 177.977 24.9915 178.552 25.3576 178.552Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.7266 177.189C26.7458 177.189 26.7651 177.189 26.7651 177.189C26.9193 177.189 27.0542 177.055 27.0542 176.901C27.0542 176.748 26.9193 176.613 26.7651 176.613C26.7458 176.613 26.7266 176.613 26.7266 176.613C26.5724 176.613 26.4375 176.748 26.4375 176.901C26.4375 177.055 26.5724 177.189 26.7266 177.189Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.8938 177.115C24.2599 177.115 24.2599 176.539 23.8938 176.539C23.5276 176.539 23.5276 177.115 23.8938 177.115Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.6856 175.635C25.6856 175.616 25.6856 175.597 25.6856 175.597C25.6856 175.443 25.5507 175.309 25.3965 175.309C25.2423 175.309 25.1074 175.443 25.1074 175.597C25.1074 175.616 25.1074 175.635 25.1074 175.635C25.1074 175.789 25.2423 175.923 25.3965 175.923C25.5507 175.904 25.6856 175.789 25.6856 175.635Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.9897 179.266C23.9705 179.266 23.9512 179.266 23.9512 179.266C23.797 179.266 23.6621 179.4 23.6621 179.554C23.6621 179.707 23.797 179.842 23.9512 179.842C23.9705 179.842 23.9897 179.842 23.9897 179.842C24.1439 179.842 24.2788 179.707 24.2788 179.554C24.2788 179.4 24.1439 179.266 23.9897 179.266Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.4865 178.689C22.8527 178.689 22.8527 178.113 22.4865 178.113C22.1204 178.113 22.1204 178.689 22.4865 178.689Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.1955 177.115C21.5617 177.115 21.5617 176.539 21.1955 176.539C20.8294 176.539 20.8294 177.115 21.1955 177.115Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.6787 175.541C22.6787 175.522 22.6787 175.503 22.6787 175.503C22.6787 175.349 22.5438 175.215 22.3897 175.215C22.2355 175.215 22.1006 175.349 22.1006 175.503C22.1006 175.522 22.1006 175.541 22.1006 175.541C22.1006 175.695 22.2355 175.829 22.3897 175.829C22.5438 175.829 22.6787 175.714 22.6787 175.541Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.9897 173.926C23.9705 173.926 23.9512 173.926 23.9512 173.926C23.797 173.926 23.6621 174.06 23.6621 174.214C23.6621 174.367 23.797 174.502 23.9512 174.502C23.9705 174.502 23.9897 174.502 23.9897 174.502C24.1439 174.502 24.2788 174.367 24.2788 174.214C24.2788 174.06 24.1439 173.926 23.9897 173.926Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.0801 174.388C21.4463 174.388 21.4463 173.812 21.0801 173.812C20.6947 173.812 20.6947 174.388 21.0801 174.388Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.4865 172.967C22.8527 172.967 22.8527 172.391 22.4865 172.391C22.1204 172.391 22.1204 172.967 22.4865 172.967Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.8557 171.74C24.2218 171.74 24.2218 171.164 23.8557 171.164C23.4895 171.164 23.4895 171.74 23.8557 171.74Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.1074 170.05C25.1074 170.069 25.1074 170.088 25.1074 170.088C25.1074 170.242 25.2423 170.376 25.3965 170.376C25.5507 170.376 25.6856 170.242 25.6856 170.088C25.6856 170.069 25.6856 170.05 25.6856 170.05C25.6856 169.896 25.5507 169.762 25.3965 169.762C25.2423 169.762 25.1074 169.877 25.1074 170.05Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.3193 172.834C25.6855 172.834 25.6855 172.258 25.3193 172.258C24.9339 172.258 24.9339 172.834 25.3193 172.834Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.8227 170.895C26.8035 170.895 26.7842 170.895 26.7842 170.895C26.63 170.895 26.4951 171.029 26.4951 171.182C26.4951 171.336 26.63 171.47 26.7842 171.47C26.8035 171.47 26.8227 171.47 26.8227 171.47C26.9769 171.47 27.1118 171.336 27.1118 171.182C27.0925 171.029 26.9769 170.895 26.8227 170.895Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.134 170.24C28.5002 170.24 28.5002 169.664 28.134 169.664C27.7678 169.664 27.7678 170.24 28.134 170.24Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.5596 168.916C29.9257 168.916 29.9257 168.34 29.5596 168.34C29.1741 168.34 29.1741 168.916 29.5596 168.916Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.9776 168.552C26.9776 168.514 26.9776 168.494 26.9776 168.456C26.9776 168.302 26.8427 168.168 26.6885 168.168C26.5343 168.168 26.3994 168.302 26.3994 168.456C26.3994 168.494 26.3994 168.514 26.3994 168.552C26.3994 168.705 26.5343 168.84 26.6885 168.84C26.8427 168.821 26.9776 168.705 26.9776 168.552Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.0949 167.381C28.4611 167.381 28.4611 166.805 28.0949 166.805C27.7288 166.805 27.7288 167.381 28.0949 167.381Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.5596 166.056C29.9257 166.056 29.9257 165.48 29.5596 165.48C29.1741 165.48 29.1741 166.056 29.5596 166.056Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.8891 164.156C30.8699 164.156 30.8506 164.156 30.8506 164.156C30.6964 164.156 30.5615 164.291 30.5615 164.444C30.5615 164.598 30.6964 164.732 30.8506 164.732C30.8699 164.732 30.8891 164.732 30.8891 164.732C31.0433 164.732 31.1782 164.598 31.1782 164.444C31.1589 164.291 31.0433 164.156 30.8891 164.156Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.0949 164.654C28.4611 164.654 28.4611 164.078 28.0949 164.078C27.7288 164.078 27.7288 164.654 28.0949 164.654Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.7268 166.115C27.0929 166.115 27.0929 165.539 26.7268 165.539C26.3606 165.539 26.3606 166.115 26.7268 166.115Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.3193 167.287C25.6855 167.287 25.6855 166.711 25.3193 166.711C24.9339 166.711 24.9339 167.287 25.3193 167.287Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7373 169.916C22.7373 169.897 22.7373 169.878 22.7373 169.878C22.7373 169.724 22.6024 169.59 22.4483 169.59C22.2941 169.59 22.1592 169.724 22.1592 169.878C22.1592 169.897 22.1592 169.916 22.1592 169.916C22.1592 170.07 22.2941 170.204 22.4483 170.204C22.6024 170.185 22.7373 170.07 22.7373 169.916Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.7199 169.088C24.0861 169.088 24.0861 168.512 23.7199 168.512C23.3538 168.512 23.3538 169.088 23.7199 169.088Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6348 175.597C19.6348 175.616 19.6348 175.635 19.6348 175.635C19.6348 175.789 19.7697 175.923 19.9238 175.923C20.078 175.923 20.2129 175.789 20.2129 175.635C20.2129 175.616 20.2129 175.597 20.2129 175.597C20.2129 175.443 20.078 175.309 19.9238 175.309C19.7697 175.309 19.6348 175.424 19.6348 175.597Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4201 174.427C18.7863 174.427 18.7863 173.852 18.4201 173.852C18.054 173.852 18.054 174.427 18.4201 174.427Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.052 175.924C17.4181 175.924 17.4181 175.348 17.052 175.348C16.6858 175.348 16.6858 175.924 17.052 175.924Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6325 176.578C18.6132 176.559 18.594 176.54 18.594 176.54C18.4783 176.424 18.3049 176.424 18.1893 176.54C18.0736 176.655 18.0736 176.827 18.1893 176.943C18.2085 176.962 18.2278 176.981 18.2278 176.981C18.3434 177.096 18.5169 177.096 18.6325 176.981C18.7289 176.866 18.7289 176.693 18.6325 176.578Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7893 181.338C20.1554 181.338 20.1554 180.762 19.7893 180.762C19.4231 180.762 19.4231 181.338 19.7893 181.338Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5549 180.052C18.9211 180.052 18.9211 179.477 18.5549 179.477C18.1887 179.477 18.1887 180.052 18.5549 180.052Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2061 178.19C17.2061 178.17 17.2061 178.151 17.2061 178.151C17.2061 177.998 17.0712 177.863 16.917 177.863C16.7628 177.863 16.6279 177.998 16.6279 178.151C16.6279 178.17 16.6279 178.19 16.6279 178.19C16.6279 178.343 16.7628 178.478 16.917 178.478C17.0712 178.458 17.2061 178.343 17.2061 178.19Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8386 176.789C15.8193 176.77 15.8 176.75 15.8 176.75C15.6844 176.635 15.5109 176.635 15.3953 176.75C15.2797 176.866 15.2797 177.038 15.3953 177.154C15.4146 177.173 15.4339 177.192 15.4339 177.192C15.5495 177.307 15.7229 177.307 15.8386 177.192C15.9542 177.096 15.9542 176.904 15.8386 176.789Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3161 175.83C14.6822 175.83 14.6822 175.254 14.3161 175.254C13.9499 175.254 13.9306 175.83 14.3161 175.83Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5615 176.827C12.5615 176.846 12.5615 176.865 12.5615 176.865C12.5615 177.019 12.6964 177.153 12.8506 177.153C13.0048 177.153 13.1397 177.019 13.1397 176.865C13.1397 176.846 13.1397 176.827 13.1397 176.827C13.1397 176.673 13.0048 176.539 12.8506 176.539C12.6964 176.539 12.5615 176.654 12.5615 176.827Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1416 178.517C14.5078 178.517 14.5078 177.941 14.1416 177.941C13.7562 177.941 13.7562 178.517 14.1416 178.517Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6455 180.111C16.0117 180.111 16.0117 179.535 15.6455 179.535C15.2601 179.535 15.2601 180.111 15.6455 180.111Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1416 181.377C14.5078 181.377 14.5078 180.801 14.1416 180.801C13.7562 180.801 13.7562 181.377 14.1416 181.377Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0239 179.477C13.0046 179.477 12.9854 179.477 12.9854 179.477C12.8312 179.477 12.6963 179.611 12.6963 179.765C12.6963 179.918 12.8312 180.052 12.9854 180.052C13.0046 180.052 13.0239 180.052 13.0239 180.052C13.1781 180.052 13.313 179.918 13.313 179.765C13.313 179.611 13.1974 179.477 13.0239 179.477Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.052 181.24C17.4181 181.24 17.4181 180.664 17.052 180.664C16.6858 180.664 16.6858 181.24 17.052 181.24Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4443 178.552C11.8105 178.552 11.8105 177.977 11.4443 177.977C11.0589 177.977 11.0589 178.552 11.4443 178.552Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.9577 178.152C8.93843 178.133 8.91916 178.114 8.91916 178.114C8.80353 177.999 8.63009 177.999 8.51446 178.114C8.39883 178.229 8.39883 178.402 8.51446 178.517C8.53373 178.536 8.553 178.555 8.553 178.555C8.66863 178.67 8.84207 178.67 8.9577 178.555C9.05406 178.459 9.05406 178.267 8.9577 178.152Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0762 180.013C10.4423 180.013 10.4423 179.438 10.0762 179.438C9.69075 179.438 9.69075 180.013 10.0762 180.013Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5791 181.416C11.9453 181.416 11.9453 180.84 11.5791 180.84C11.1937 180.84 11.1937 181.416 11.5791 181.416Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.43771 181.416C8.80387 181.416 8.80387 180.84 8.43771 180.84C8.07155 180.84 8.07155 181.416 8.43771 181.416Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.14695 182.164C7.12768 182.164 7.10841 182.164 7.10841 182.164C6.95424 182.164 6.81934 182.298 6.81934 182.452C6.81934 182.606 6.95424 182.74 7.10841 182.74C7.12768 182.74 7.14695 182.74 7.14695 182.74C7.30113 182.74 7.43603 182.606 7.43603 182.452C7.43603 182.298 7.3204 182.164 7.14695 182.164Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.87521 181.416C6.24137 181.416 6.24137 180.84 5.87521 180.84C5.50905 180.84 5.50905 181.416 5.87521 181.416Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.53225 179.686C7.53225 179.667 7.53225 179.647 7.53225 179.647C7.53225 179.494 7.39735 179.359 7.24318 179.359C7.089 179.359 6.9541 179.494 6.9541 179.647C6.9541 179.667 6.9541 179.686 6.9541 179.686C6.9541 179.839 7.089 179.974 7.24318 179.974C7.39735 179.954 7.53225 179.839 7.53225 179.686Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.58321 179.916C4.94938 179.916 4.94938 179.34 4.58321 179.34C4.21705 179.34 4.21705 179.916 4.58321 179.916Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.13771 181.338C3.50387 181.338 3.50387 180.762 3.13771 180.762C2.75227 180.762 2.75227 181.338 3.13771 181.338Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.00943 178.302C6.37559 178.302 6.37559 177.727 6.00943 177.727C5.64327 177.727 5.624 178.302 6.00943 178.302Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.28146 177.115C7.64762 177.115 7.64762 176.539 7.28146 176.539C6.9153 176.539 6.9153 177.115 7.28146 177.115Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.00314 178.65C3.3693 178.65 3.3693 178.074 3.00314 178.074C2.63698 178.074 2.63698 178.65 3.00314 178.65Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.50685 177.115C4.52612 177.115 4.54539 177.115 4.54539 177.115C4.69956 177.115 4.83447 176.981 4.83447 176.827C4.83447 176.673 4.69956 176.539 4.54539 176.539C4.52612 176.539 4.50685 176.539 4.50685 176.539C4.35267 176.539 4.21777 176.673 4.21777 176.827C4.21777 176.981 4.3334 177.115 4.50685 177.115Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83595 175.83C6.20211 175.83 6.20211 175.254 5.83595 175.254C5.45052 175.254 5.45052 175.83 5.83595 175.83Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.28126 174.197C7.30053 174.197 7.31981 174.197 7.31981 174.197C7.47398 174.197 7.60888 174.063 7.60888 173.909C7.60888 173.755 7.47398 173.621 7.31981 173.621C7.30053 173.621 7.28126 173.621 7.28126 173.621C7.12709 173.621 6.99219 173.755 6.99219 173.909C7.01146 174.082 7.12709 174.197 7.28126 174.197Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.88053 175.693C9.24669 175.693 9.24669 175.117 8.88053 175.117C8.51437 175.117 8.49509 175.693 8.88053 175.693Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0178 176.845C10.3839 176.845 10.3839 176.27 10.0178 176.27C9.65162 176.27 9.65162 176.845 10.0178 176.845Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0762 174.388C10.4423 174.388 10.4423 173.812 10.0762 173.812C9.69075 173.812 9.69075 174.388 10.0762 174.388Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5217 173.006C11.8879 173.006 11.8879 172.43 11.5217 172.43C11.1555 172.43 11.1555 173.006 11.5217 173.006Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1397 174.1C13.1397 174.081 13.1397 174.061 13.1397 174.061C13.1397 173.908 13.0048 173.773 12.8506 173.773C12.6964 173.773 12.5615 173.908 12.5615 174.061C12.5615 174.081 12.5615 174.1 12.5615 174.1C12.5615 174.253 12.6964 174.388 12.8506 174.388C13.0048 174.369 13.1397 174.253 13.1397 174.1Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0252 171.183C13.0445 171.24 13.0637 171.317 13.1023 171.375C13.1023 171.375 13.1023 171.375 13.1023 171.355C13.083 171.413 13.083 171.451 13.0637 171.509C13.0252 171.547 12.9674 171.586 12.9288 171.605C12.8517 171.586 12.7747 171.586 12.6976 171.567C12.659 171.509 12.6012 171.451 12.5627 171.394C12.5627 171.394 12.5627 171.394 12.5627 171.413C12.6205 171.547 12.7554 171.663 12.9096 171.605C13.0445 171.567 13.1794 171.394 13.1023 171.259C13.0637 171.163 13.0252 171.087 12.9288 171.048C12.8325 171.01 12.7361 171.029 12.6397 171.067C12.4663 171.163 12.4278 171.413 12.5819 171.567C12.6976 171.663 12.871 171.682 12.9866 171.567C13.1215 171.49 13.1408 171.298 13.0252 171.183Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1416 173.006C14.5078 173.006 14.5078 172.43 14.1416 172.43C13.7562 172.43 13.7562 173.006 14.1416 173.006Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6455 171.529C16.0117 171.529 16.0117 170.953 15.6455 170.953C15.2601 170.953 15.2601 171.529 15.6455 171.529Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7061 170.165C16.7253 170.185 16.7446 170.204 16.7446 170.204C16.8602 170.319 17.0337 170.319 17.1493 170.204C17.2649 170.089 17.2649 169.916 17.1493 169.801C17.13 169.781 17.1108 169.762 17.1108 169.762C16.9951 169.647 16.8217 169.647 16.7061 169.762C16.6097 169.858 16.6097 170.05 16.7061 170.165Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7893 170.146C20.1554 170.146 20.1554 169.57 19.7893 169.57C19.4231 169.57 19.4231 170.146 19.7893 170.146Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.0801 171.47C21.4463 171.47 21.4463 170.895 21.0801 170.895C20.6947 170.895 20.6947 171.47 21.0801 171.47Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5166 171.642C18.8828 171.642 18.8828 171.066 18.5166 171.066C18.1312 171.066 18.1312 171.642 18.5166 171.642Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8274 173.006C20.1935 173.006 20.1935 172.43 19.8274 172.43C19.4612 172.43 19.4612 173.006 19.8274 173.006Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0518 172.834C17.071 172.834 17.0903 172.834 17.0903 172.834C17.2445 172.834 17.3794 172.699 17.3794 172.546C17.3794 172.392 17.2445 172.258 17.0903 172.258C17.071 172.258 17.0518 172.258 17.0518 172.258C16.8976 172.258 16.7627 172.392 16.7627 172.546C16.7627 172.699 16.8976 172.834 17.0518 172.834Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.42285 176.69C1.42285 176.709 1.42285 176.729 1.42285 176.729C1.42285 176.882 1.55775 177.017 1.71193 177.017C1.8661 177.017 2.001 176.882 2.001 176.729C2.001 176.71 2.001 176.69 2.001 176.69C2.001 176.537 1.8661 176.402 1.71193 176.402C1.55775 176.402 1.42285 176.518 1.42285 176.69Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.04122 175.791C3.40738 175.791 3.40738 175.215 3.04122 175.215C2.67506 175.215 2.67506 175.791 3.04122 175.791Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.50607 174.388C4.87223 174.388 4.87223 173.812 4.50607 173.812C4.13991 173.812 4.13991 174.388 4.50607 174.388Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83543 172.488C5.81616 172.488 5.79689 172.488 5.79689 172.488C5.64271 172.488 5.50781 172.623 5.50781 172.776C5.50781 172.93 5.64271 173.064 5.79689 173.064C5.81616 173.064 5.83543 173.064 5.83543 173.064C5.9896 173.064 6.1245 172.93 6.1245 172.776C6.10523 172.623 5.9896 172.488 5.83543 172.488Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.24239 171.603C7.60855 171.603 7.60855 171.027 7.24239 171.027C6.87623 171.027 6.87623 171.603 7.24239 171.603Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0178 171.603C10.3839 171.603 10.3839 171.027 10.0178 171.027C9.65162 171.027 9.65162 171.603 10.0178 171.603Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4443 170.279C11.8105 170.279 11.8105 169.703 11.4443 169.703C11.0589 169.703 11.0589 170.279 11.4443 170.279Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8127 169.013C13.1789 169.013 13.1789 168.438 12.8127 168.438C12.4465 168.438 12.4465 169.013 12.8127 169.013Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2774 167.478C14.6435 167.478 14.6435 166.902 14.2774 166.902C13.8919 166.902 13.8919 167.478 14.2774 167.478Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6436 169.916C14.6436 169.897 14.6436 169.878 14.6436 169.878C14.6436 169.724 14.5087 169.59 14.3545 169.59C14.2003 169.59 14.0654 169.724 14.0654 169.878C14.0654 169.897 14.0654 169.916 14.0654 169.916C14.0654 170.07 14.2003 170.204 14.3545 170.204C14.5087 170.185 14.6436 170.07 14.6436 169.916Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5881 168.842C15.9543 168.842 15.9543 168.266 15.5881 168.266C15.2219 168.266 15.2219 168.842 15.5881 168.842Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.052 167.381C17.4181 167.381 17.4181 166.805 17.052 166.805C16.6858 166.805 16.6858 167.381 17.052 167.381Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4592 166.056C18.8254 166.056 18.8254 165.48 18.4592 165.48C18.093 165.48 18.093 166.056 18.4592 166.056Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3436 168.285C18.2087 168.342 18.1123 168.438 18.1123 168.573C18.1123 168.707 18.2087 168.822 18.3436 168.861C18.4785 168.899 18.6712 168.803 18.6905 168.669C18.729 168.515 18.6519 168.362 18.4977 168.323C18.4977 168.323 18.4977 168.323 18.4785 168.323C18.5363 168.381 18.6134 168.458 18.6712 168.515C18.6712 168.515 18.6712 168.515 18.6712 168.496C18.6712 168.553 18.6712 168.592 18.6712 168.649C18.6712 168.649 18.6712 168.649 18.6712 168.63C18.6134 168.688 18.5363 168.765 18.4785 168.822C18.4785 168.822 18.4785 168.822 18.4977 168.822C18.6519 168.765 18.7483 168.63 18.6905 168.477C18.6519 168.342 18.4977 168.227 18.3436 168.285Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.635 166.977C19.6158 166.996 19.5965 167.015 19.5965 167.015C19.4809 167.131 19.4809 167.303 19.5965 167.419C19.7121 167.534 19.8856 167.534 20.0012 167.419C20.0205 167.399 20.0397 167.38 20.0397 167.38C20.1554 167.265 20.1554 167.092 20.0397 166.977C19.9241 166.862 19.7507 166.862 19.635 166.977Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.0217 166.189C21.3879 166.189 21.3879 165.613 21.0217 165.613C20.6555 165.613 20.6555 166.189 21.0217 166.189Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.4865 164.654C22.8527 164.654 22.8527 164.078 22.4865 164.078C22.1204 164.078 22.1204 164.654 22.4865 164.654Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.9904 163.256C24.3566 163.256 24.3566 162.68 23.9904 162.68C23.6243 162.68 23.6243 163.256 23.9904 163.256Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.3576 164.654C25.7238 164.654 25.7238 164.078 25.3576 164.078C24.9915 164.078 24.9915 164.654 25.3576 164.654Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.9904 166.056C24.3566 166.056 24.3566 165.48 23.9904 165.48C23.6243 165.48 23.6243 166.056 23.9904 166.056Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.6604 167.342C23.0265 167.342 23.0265 166.766 22.6604 166.766C22.2942 166.766 22.2942 167.342 22.6604 167.342Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.7268 163.33C27.0929 163.33 27.0929 162.754 26.7268 162.754C26.3606 162.754 26.3606 163.33 26.7268 163.33Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.2617 161.967C25.281 161.967 25.3003 161.967 25.3003 161.967C25.4544 161.967 25.5893 161.832 25.5893 161.679C25.5893 161.525 25.4544 161.391 25.3003 161.391C25.281 161.391 25.2617 161.391 25.2617 161.391C25.1076 161.391 24.9727 161.525 24.9727 161.679C24.9919 161.832 25.1076 161.967 25.2617 161.967Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.1914 161.756C28.5576 161.756 28.5576 161.18 28.1914 161.18C27.806 161.18 27.806 161.756 28.1914 161.756Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.001 162.831C29.001 162.85 29.001 162.869 29.001 162.869C29.001 163.023 29.1359 163.157 29.2901 163.157C29.4442 163.157 29.5791 163.023 29.5791 162.869C29.5791 162.85 29.5791 162.831 29.5791 162.831C29.5791 162.677 29.4442 162.543 29.2901 162.543C29.1359 162.543 29.001 162.658 29.001 162.831Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.1198 161.527C31.1005 161.508 31.0813 161.489 31.0813 161.489C30.9656 161.374 30.7922 161.374 30.6766 161.489C30.5609 161.604 30.5609 161.777 30.6766 161.892C30.6958 161.911 30.7151 161.93 30.7151 161.93C30.8307 162.045 31.0042 162.045 31.1198 161.93C31.2354 161.815 31.2354 161.623 31.1198 161.527Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.5466 162.851C32.5273 162.832 32.508 162.813 32.508 162.813C32.3924 162.698 32.219 162.698 32.1033 162.813C31.9877 162.928 31.9877 163.101 32.1033 163.216C32.1226 163.235 32.1419 163.254 32.1419 163.254C32.2575 163.37 32.4309 163.37 32.5466 163.254C32.6622 163.139 32.6622 162.947 32.5466 162.851Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.5293 162.006C33.5486 162.006 33.5679 162.006 33.5679 162.006C33.722 162.006 33.8569 161.871 33.8569 161.718C33.8569 161.564 33.722 161.43 33.5679 161.43C33.5486 161.43 33.5293 161.43 33.5293 161.43C33.3751 161.43 33.2402 161.564 33.2402 161.718C33.2402 161.871 33.3751 162.006 33.5293 162.006Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.624 160.451C32.624 160.432 32.624 160.413 32.624 160.413C32.624 160.259 32.4891 160.125 32.335 160.125C32.1808 160.125 32.0459 160.259 32.0459 160.413C32.0459 160.432 32.0459 160.451 32.0459 160.451C32.0459 160.605 32.1808 160.739 32.335 160.739C32.4891 160.739 32.624 160.605 32.624 160.451Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.6174 160.567C29.6367 160.548 29.6559 160.529 29.6559 160.529C29.7716 160.413 29.7716 160.241 29.6559 160.125C29.5403 160.01 29.3669 160.01 29.2512 160.125C29.232 160.145 29.2127 160.164 29.2127 160.164C29.0971 160.279 29.0971 160.452 29.2127 160.567C29.3283 160.682 29.521 160.682 29.6174 160.567Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.0324 166.189C35.3986 166.189 35.3986 165.613 35.0324 165.613C34.6663 165.613 34.6663 166.189 35.0324 166.189Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.3235 166.977C36.3042 166.996 36.285 167.015 36.285 167.015C36.1693 167.131 36.1693 167.303 36.285 167.419C36.4006 167.534 36.574 167.534 36.6897 167.419C36.7089 167.399 36.7282 167.38 36.7282 167.38C36.8438 167.265 36.8438 167.092 36.7282 166.977C36.6319 166.862 36.4391 166.862 36.3235 166.977Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.2832 168.553C35.2832 168.534 35.2832 168.515 35.2832 168.515C35.2832 168.361 35.1483 168.227 34.9942 168.227C34.84 168.227 34.7051 168.361 34.7051 168.515C34.7051 168.534 34.7051 168.553 34.7051 168.553C34.7051 168.706 34.84 168.841 34.9942 168.841C35.1483 168.822 35.2832 168.706 35.2832 168.553Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.2237 167.494C34.2237 167.475 34.2237 167.456 34.2237 167.456C34.2237 167.302 34.0888 167.168 33.9346 167.168C33.7804 167.168 33.6455 167.302 33.6455 167.456C33.6455 167.475 33.6455 167.494 33.6455 167.494C33.6455 167.648 33.7804 167.782 33.9346 167.782C34.0888 167.763 34.2237 167.648 34.2237 167.494Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.9062 167.19C38.9062 167.209 38.9062 167.229 38.9062 167.229C38.9062 167.382 39.0412 167.517 39.1953 167.517C39.3495 167.517 39.4844 167.382 39.4844 167.229C39.4844 167.21 39.4844 167.19 39.4844 167.19C39.4844 167.037 39.3495 166.902 39.1953 166.902C39.0219 166.902 38.9062 167.018 38.9062 167.19Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.6924 168.974C38.0586 168.974 38.0586 168.398 37.6924 168.398C37.307 168.398 37.307 168.974 37.6924 168.974Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.1438 167.552C42.5099 167.552 42.5099 166.977 42.1438 166.977C41.7776 166.977 41.7776 167.552 42.1438 167.552Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.7756 166.287C41.1418 166.287 41.1418 165.711 40.7756 165.711C40.4094 165.711 40.4094 166.287 40.7756 166.287Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.7697 166.154C38.1359 166.154 38.1359 165.578 37.7697 165.578C37.4036 165.578 37.4036 166.154 37.7697 166.154Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.234 164.693C39.6002 164.693 39.6002 164.117 39.234 164.117C38.8679 164.117 38.8486 164.693 39.234 164.693Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.5168 164.579C36.5361 164.56 36.5554 164.54 36.5554 164.54C36.671 164.425 36.671 164.252 36.5554 164.137C36.4397 164.022 36.2663 164.022 36.1507 164.137C36.1314 164.156 36.1121 164.176 36.1121 164.176C35.9965 164.291 35.9965 164.464 36.1121 164.579C36.2277 164.675 36.4012 164.675 36.5168 164.579Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.0324 163.467C35.3986 163.467 35.3986 162.891 35.0324 162.891C34.6663 162.891 34.6663 163.467 35.0324 163.467Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.6323 161.488C36.613 161.488 36.5938 161.488 36.5938 161.488C36.4396 161.488 36.3047 161.623 36.3047 161.776C36.3047 161.93 36.4396 162.064 36.5938 162.064C36.613 162.064 36.6323 162.064 36.6323 162.064C36.7865 162.064 36.9214 161.93 36.9214 161.776C36.9021 161.623 36.7865 161.488 36.6323 161.488Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.7697 163.33C38.1359 163.33 38.1359 162.754 37.7697 162.754C37.4036 162.754 37.4036 163.33 37.7697 163.33Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.234 161.967C39.6002 161.967 39.6002 161.391 39.234 161.391C38.8679 161.391 38.8486 161.967 39.234 161.967Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.5635 163.291C40.9296 163.291 40.9296 162.715 40.5635 162.715C40.1781 162.715 40.1781 163.291 40.5635 163.291Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.0674 161.927C42.4336 161.927 42.4336 161.352 42.0674 161.352C41.682 161.352 41.682 161.927 42.0674 161.927Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.6408 160.701C41.007 160.701 41.007 160.125 40.6408 160.125C40.2747 160.125 40.2747 160.701 40.6408 160.701Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.4356 160.564C43.8017 160.564 43.8017 159.988 43.4356 159.988C43.0501 159.988 43.0501 160.564 43.4356 160.564Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.2102 160.603C46.5763 160.603 46.5763 160.027 46.2102 160.027C45.844 160.027 45.844 160.603 46.2102 160.603Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.7453 159.205C45.1115 159.205 45.1115 158.629 44.7453 158.629C44.3792 158.629 44.3792 159.205 44.7453 159.205Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.6174 159.24C47.9836 159.24 47.9836 158.664 47.6174 158.664C47.2512 158.664 47.2512 159.24 47.6174 159.24Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.1719 157.842C46.538 157.842 46.538 157.266 46.1719 157.266C45.7865 157.266 45.7865 157.842 46.1719 157.842Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.1652 157.783C43.5314 157.783 43.5314 157.207 43.1652 157.207C42.7991 157.207 42.7991 157.783 43.1652 157.783Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.919 156.131C44.919 156.112 44.919 156.093 44.919 156.093C44.919 155.939 44.7841 155.805 44.6299 155.805C44.4757 155.805 44.3408 155.939 44.3408 156.093C44.3408 156.112 44.3408 156.131 44.3408 156.131C44.3408 156.285 44.4757 156.419 44.6299 156.419C44.7841 156.419 44.919 156.304 44.919 156.131Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.1059 155.844C42.0867 155.844 42.0674 155.844 42.0674 155.844C41.9132 155.844 41.7783 155.978 41.7783 156.132C41.7783 156.285 41.9132 156.42 42.0674 156.42C42.0867 156.42 42.1059 156.42 42.1059 156.42C42.2601 156.42 42.395 156.285 42.395 156.132C42.3757 155.978 42.2601 155.844 42.1059 155.844Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.2207 158.725C42.2207 158.706 42.2207 158.686 42.2207 158.686C42.2207 158.533 42.0858 158.398 41.9317 158.398C41.7775 158.398 41.6426 158.533 41.6426 158.686C41.6426 158.706 41.6426 158.725 41.6426 158.725C41.6426 158.878 41.7775 159.013 41.9317 159.013C42.0858 159.013 42.2207 158.898 42.2207 158.725Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.7373 157.783C41.1035 157.783 41.1035 157.207 40.7373 157.207C40.3519 157.207 40.3519 157.783 40.7373 157.783Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.3384 154.48C43.3191 154.48 43.2998 154.48 43.2998 154.48C43.1456 154.48 43.0107 154.615 43.0107 154.768C43.0107 154.922 43.1456 155.056 43.2998 155.056C43.3191 155.056 43.3384 155.056 43.3384 155.056C43.4925 155.056 43.6274 154.922 43.6274 154.768C43.6274 154.615 43.4925 154.48 43.3384 154.48Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.9321 153.117C41.9128 153.117 41.8936 153.117 41.8936 153.117C41.7394 153.117 41.6045 153.252 41.6045 153.405C41.6045 153.559 41.7394 153.693 41.8936 153.693C41.9128 153.693 41.9321 153.693 41.9321 153.693C42.0863 153.693 42.2212 153.559 42.2212 153.405C42.2019 153.252 42.0863 153.117 41.9321 153.117Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.5639 154.402C40.5447 154.402 40.5254 154.402 40.5254 154.402C40.3712 154.402 40.2363 154.537 40.2363 154.69C40.2363 154.844 40.3712 154.978 40.5254 154.978C40.5447 154.978 40.5639 154.978 40.5639 154.978C40.7181 154.978 40.853 154.844 40.853 154.69C40.8337 154.518 40.7181 154.402 40.5639 154.402Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.4268 155.998C39.4268 155.979 39.4268 155.96 39.4268 155.96C39.4268 155.806 39.2919 155.672 39.1377 155.672C38.9835 155.672 38.8486 155.806 38.8486 155.96C38.8486 155.979 38.8486 155.998 38.8486 155.998C38.8486 156.152 38.9835 156.286 39.1377 156.286C39.2919 156.286 39.4268 156.171 39.4268 155.998Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.9811 154.48C37.9619 154.461 37.9426 154.442 37.9426 154.442C37.827 154.327 37.6535 154.327 37.5379 154.442C37.4223 154.557 37.4223 154.73 37.5379 154.845C37.5572 154.864 37.5764 154.883 37.5764 154.883C37.6921 154.999 37.8655 154.999 37.9811 154.883C38.0968 154.768 38.0968 154.595 37.9811 154.48Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.1379 153.732C39.5041 153.732 39.5041 153.156 39.1379 153.156C38.7717 153.156 38.7717 153.732 39.1379 153.732Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.5061 152.291C40.8722 152.291 40.8722 151.715 40.5061 151.715C40.1399 151.715 40.1399 152.291 40.5061 152.291Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.6897 153.657C36.7089 153.638 36.7282 153.618 36.7282 153.618C36.8438 153.503 36.8438 153.33 36.7282 153.215C36.6126 153.1 36.4391 153.1 36.3235 153.215C36.3042 153.234 36.285 153.254 36.285 153.254C36.1693 153.369 36.1693 153.542 36.285 153.657C36.4006 153.772 36.5933 153.772 36.6897 153.657Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.0732 156.054C36.0732 156.073 36.0732 156.092 36.0732 156.092C36.0732 156.246 36.2081 156.38 36.3623 156.38C36.5165 156.38 36.6514 156.246 36.6514 156.092C36.6514 156.073 36.6514 156.054 36.6514 156.054C36.6514 155.9 36.5165 155.766 36.3623 155.766C36.2081 155.766 36.0732 155.881 36.0732 156.054Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.5576 157.533C37.5769 157.533 37.5962 157.533 37.5962 157.533C37.7503 157.533 37.8852 157.399 37.8852 157.245C37.8852 157.091 37.7503 156.957 37.5962 156.957C37.5769 156.957 37.5576 156.957 37.5576 156.957C37.4035 156.957 37.2686 157.091 37.2686 157.245C37.2686 157.399 37.3842 157.533 37.5576 157.533Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.3493 158.531C39.33 158.512 39.3108 158.493 39.3108 158.493C39.1951 158.377 39.0217 158.377 38.9061 158.493C38.7904 158.608 38.7904 158.781 38.9061 158.896C38.9253 158.915 38.9446 158.934 38.9446 158.934C39.0602 159.049 39.2337 159.049 39.3493 158.934C39.4649 158.819 39.4649 158.646 39.3493 158.531Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.8078 160.47C38.174 160.47 38.174 159.895 37.8078 159.895C37.4417 159.895 37.4417 160.47 37.8078 160.47Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.4397 159.377C36.8058 159.377 36.8058 158.801 36.4397 158.801C36.0735 158.801 36.0735 159.377 36.4397 159.377Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.8213 157.744C34.8406 157.744 34.8598 157.744 34.8598 157.744C35.014 157.744 35.1489 157.61 35.1489 157.456C35.1489 157.302 35.014 157.168 34.8598 157.168C34.8406 157.168 34.8213 157.168 34.8213 157.168C34.6671 157.168 34.5322 157.302 34.5322 157.456C34.5322 157.61 34.6479 157.744 34.8213 157.744Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.2578 157.842C32.624 157.842 32.624 157.266 32.2578 157.266C31.8724 157.266 31.8724 157.842 32.2578 157.842Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.8313 159.24C31.1974 159.24 31.1974 158.664 30.8313 158.664C30.4651 158.664 30.4651 159.24 30.8313 159.24Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.2705 157.628C29.2705 157.647 29.2705 157.666 29.2705 157.666C29.2705 157.82 29.4054 157.954 29.5596 157.954C29.7138 157.954 29.8487 157.82 29.8487 157.666C29.8487 157.647 29.8487 157.628 29.8487 157.628C29.8487 157.474 29.7138 157.34 29.5596 157.34C29.4054 157.359 29.2705 157.474 29.2705 157.628Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.0561 158.629C28.0369 158.629 28.0176 158.629 28.0176 158.629C27.8634 158.629 27.7285 158.763 27.7285 158.917C27.7285 159.07 27.8634 159.205 28.0176 159.205C28.0369 159.205 28.0561 159.205 28.0561 159.205C28.2103 159.205 28.3452 159.07 28.3452 158.917C28.3259 158.744 28.2103 158.629 28.0561 158.629Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.7649 160.51C27.131 160.51 27.131 159.934 26.7649 159.934C26.3987 159.934 26.3987 160.51 26.7649 160.51Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.9512 160.47C24.3173 160.47 24.3173 159.895 23.9512 159.895C23.5658 159.895 23.5658 160.47 23.9512 160.47Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.3908 162.064C22.757 162.064 22.757 161.488 22.3908 161.488C22.0247 161.488 22.0247 162.064 22.3908 162.064Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.1567 162.754C21.1374 162.754 21.1182 162.754 21.1182 162.754C20.964 162.754 20.8291 162.888 20.8291 163.042C20.8291 163.195 20.964 163.33 21.1182 163.33C21.1374 163.33 21.1567 163.33 21.1567 163.33C21.3109 163.33 21.4458 163.195 21.4458 163.042C21.4458 162.888 21.3302 162.754 21.1567 162.754Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4397 163.426C18.4589 163.407 18.4782 163.388 18.4782 163.388C18.5938 163.273 18.5938 163.1 18.4782 162.985C18.3626 162.87 18.1891 162.87 18.0735 162.985C18.0542 163.004 18.035 163.023 18.035 163.023C17.9193 163.138 17.9193 163.311 18.035 163.426C18.1506 163.542 18.3433 163.542 18.4397 163.426Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7893 162.142C20.1554 162.142 20.1554 161.566 19.7893 161.566C19.4231 161.566 19.4231 162.142 19.7893 162.142Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1479 164.156C17.1287 164.156 17.1094 164.156 17.1094 164.156C16.9552 164.156 16.8203 164.291 16.8203 164.444C16.8203 164.598 16.9552 164.732 17.1094 164.732C17.1287 164.732 17.1479 164.732 17.1479 164.732C17.3021 164.732 17.437 164.598 17.437 164.444C17.4177 164.291 17.3021 164.156 17.1479 164.156Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M122.121 75.9231C128.095 86.424 138.56 93.047 148.966 98.6142C151.992 100.246 155.075 102.185 158.409 103.145C158.679 103.222 158.795 102.799 158.525 102.722C155.557 101.878 152.84 100.169 150.142 98.7486C147.405 97.2896 144.688 95.7922 142.048 94.1989C137.076 91.1849 132.335 87.7294 128.326 83.506C126.091 81.1256 124.106 78.5339 122.506 75.6928C122.372 75.4624 121.986 75.6736 122.121 75.9231Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M128.943 67.7275C130.967 70.8183 133.009 73.9474 135.476 76.7118C137.962 79.4954 140.853 81.8567 143.782 84.1411C146.769 86.464 149.776 88.7677 152.782 91.0521C155.75 93.3174 158.795 95.4867 162.167 97.1184C162.418 97.2336 162.63 96.8689 162.379 96.7537C159.122 95.1795 156.155 93.087 153.283 90.8986C150.2 88.5565 147.135 86.2144 144.091 83.834C141.258 81.6263 138.444 79.3226 136.016 76.6542C133.453 73.8514 131.391 70.6647 129.309 67.4971C129.174 67.286 128.789 67.4971 128.943 67.7275Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.201 115.857C98.9761 122.077 101.385 128.432 103.466 134.92C103.543 135.189 103.967 135.074 103.89 134.805C101.809 128.278 99.3808 121.885 96.5864 115.627C96.4515 115.377 96.0853 115.608 96.201 115.857Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.293 134.959C103.255 151.719 103.236 168.478 103.197 185.237C103.197 189.979 103.178 194.701 103.178 199.443C103.178 199.712 103.602 199.712 103.621 199.443C103.66 182.684 103.679 165.924 103.717 149.165C103.717 144.424 103.737 139.701 103.737 134.959C103.737 134.691 103.293 134.691 103.293 134.959Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.486 199.655C117.361 204.608 131.121 209.829 144.881 215.051C148.89 216.567 152.898 218.084 156.907 219.601C157.176 219.697 157.273 219.274 157.022 219.178C143.224 213.957 129.444 208.658 115.588 203.571C111.599 202.112 107.61 200.653 103.601 199.232C103.331 199.156 103.216 199.559 103.486 199.655Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M157.408 160.243C157.832 175.313 157.967 190.383 157.832 205.453C157.793 209.715 157.716 213.976 157.639 218.238C157.639 218.507 158.063 218.507 158.082 218.238C158.391 203.168 158.41 188.098 158.14 173.029C158.063 168.767 157.967 164.505 157.851 160.243C157.832 159.955 157.389 159.955 157.408 160.243Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M158.16 219.505C164.288 215.608 170.455 211.75 176.66 207.949C176.892 207.795 176.68 207.43 176.448 207.584C170.243 211.385 164.076 215.244 157.948 219.141C157.716 219.275 157.928 219.659 158.16 219.505Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M204.488 138.413C204.642 151.927 204.681 165.461 204.623 178.976C204.604 182.796 204.585 186.636 204.546 190.456C204.546 190.725 204.97 190.725 204.989 190.456C205.105 176.941 205.124 163.407 205.028 149.892C205.009 146.072 204.97 142.233 204.932 138.413C204.912 138.144 204.488 138.144 204.488 138.413Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M193.118 197.77C196.973 195.409 200.827 193.048 204.662 190.667C204.893 190.514 204.681 190.149 204.45 190.303C200.596 192.664 196.741 195.025 192.906 197.406C192.656 197.54 192.887 197.905 193.118 197.77Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M179.127 208.636C177.277 208.502 176.024 206.774 175.562 205.104C175.292 204.144 175.292 203.031 176.024 202.282C176.564 201.745 177.315 201.457 177.855 200.919C180.129 198.692 176.949 195.16 178.915 192.933C179.397 192.376 180.148 192.184 180.63 191.628C181.016 191.167 181.208 190.591 181.382 190.034C181.806 188.575 181.979 187.02 182.731 185.677C182.904 185.389 183.135 184.928 183.424 184.736C184.542 183.987 184.696 185.101 184.812 185.734C185.005 186.732 185.005 187.769 184.908 188.786C184.812 189.766 184.639 190.725 184.465 191.704C184.369 192.261 184.176 192.914 184.369 193.471C184.562 194.085 185.005 194.143 185.544 194.392C186.469 194.814 186.566 195.928 186.296 196.811C186.084 197.521 185.487 198.116 185.39 198.865C185.313 199.499 186.18 200.554 185.872 201.034C185.718 201.265 186.103 201.495 186.238 201.245C186.546 200.746 186.315 200.362 186.065 199.882C185.448 198.654 186.431 197.924 186.72 196.792C187.028 195.601 186.739 194.603 185.699 193.97C184.812 193.432 184.658 193.087 184.812 192.146C184.908 191.628 185.005 191.109 185.101 190.591C185.275 189.535 185.409 188.46 185.409 187.385C185.39 186.521 185.371 183.814 183.983 183.872C182.654 183.93 181.902 186.291 181.613 187.289C181.362 188.153 181.208 189.036 180.938 189.9C180.784 190.399 180.611 190.898 180.283 191.321C179.898 191.781 179.377 191.954 178.934 192.3C177.816 193.163 177.797 194.699 177.971 195.985C178.106 196.907 178.337 197.809 178.298 198.75C178.221 200.247 177.277 200.746 176.178 201.553C173.268 203.722 175.966 208.79 179.127 209.04C179.416 209.078 179.416 208.656 179.127 208.636Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M183.386 209.02C182.057 207.964 181.845 206.025 183.136 204.835C183.965 204.067 185.371 204.316 185.988 203.28C186.451 202.493 186.296 201.514 186.489 200.669C186.682 199.767 187.183 199.479 187.973 199.095C188.359 198.922 188.705 198.711 188.956 198.365C189.573 197.501 189.399 196.311 189.611 195.313C189.746 194.641 190.151 193.72 190.748 193.316C190.883 193.24 192.001 193.028 192.155 193.163C192.251 193.24 192.309 193.566 192.328 193.7C192.463 194.199 192.483 194.756 192.502 195.275C192.54 196.868 192.174 198.308 191.673 199.805C191.346 200.765 191.442 201.206 192.29 201.686C194.198 202.8 192.502 204.988 191.423 205.948C190.421 206.831 189.38 207.695 189.091 209.077C189.033 209.346 189.457 209.461 189.515 209.192C190.054 206.678 194.68 205.257 193.369 202.243C193.119 201.648 192.714 201.59 192.29 201.206C191.538 200.554 192.386 199.268 192.598 198.519C193.022 196.945 193.157 195.179 192.791 193.585C192.54 192.529 191.77 192.069 190.825 192.74C189.708 193.528 189.245 194.756 189.129 196.042C189.033 196.964 189.033 198.039 188.127 198.576C187.588 198.903 186.952 198.999 186.547 199.536C185.795 200.554 186.296 201.917 185.738 202.973C185.294 203.817 184.119 203.683 183.367 204.163C182.808 204.528 182.346 205.065 182.095 205.679C181.556 207.004 182.057 208.463 183.155 209.327C183.309 209.5 183.618 209.192 183.386 209.02Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M192.694 198.001C192.906 197.905 193.138 197.79 193.35 197.694C193.6 197.579 193.388 197.195 193.138 197.329C192.926 197.425 192.694 197.54 192.482 197.636C192.232 197.751 192.444 198.116 192.694 198.001Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M190.17 195.45C190.344 197.524 190.035 199.52 189.226 201.44C189.11 201.689 189.534 201.805 189.65 201.555C190.459 199.616 190.787 197.562 190.594 195.45C190.575 195.162 190.151 195.162 190.17 195.45Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M191.056 196.044C190.035 199.864 188.609 203.55 186.759 207.044C186.624 207.293 187.009 207.504 187.125 207.255C188.975 203.722 190.44 199.998 191.461 196.159C191.557 195.89 191.133 195.775 191.056 196.044Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M186.893 201.956C187.279 203.472 187.298 204.97 186.99 206.505C186.932 206.774 187.356 206.889 187.414 206.621C187.741 205.027 187.722 203.434 187.317 201.84C187.24 201.572 186.836 201.687 186.893 201.956Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M187.259 206.87C188.3 205.68 189.34 204.471 190.4 203.28C190.574 203.069 190.285 202.762 190.092 202.973C189.051 204.164 188.011 205.373 186.951 206.563C186.777 206.774 187.066 207.082 187.259 206.87Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M183.329 188.444C182.134 191.458 181.845 194.76 181.363 197.947C180.881 201.133 180.187 204.397 180.476 207.641C180.496 207.91 180.939 207.91 180.92 207.641C180.631 204.32 181.344 200.98 181.845 197.697C182.307 194.625 182.616 191.458 183.753 188.559C183.849 188.31 183.425 188.194 183.329 188.444Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M178.511 201.38C179.301 202.897 179.879 204.509 180.226 206.179C180.284 206.448 180.708 206.333 180.65 206.064C180.284 204.337 179.705 202.705 178.877 201.15C178.761 200.919 178.395 201.131 178.511 201.38Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M181.325 201.343C182.057 199.424 183.194 197.734 184.697 196.333C184.909 196.141 184.601 195.834 184.389 196.026C182.828 197.485 181.652 199.232 180.92 201.228C180.824 201.478 181.228 201.593 181.325 201.343Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M180.052 192.839C180.861 194.355 181.266 195.987 181.285 197.715C181.285 197.984 181.728 198.003 181.728 197.715C181.709 195.929 181.285 194.221 180.437 192.628C180.302 192.378 179.917 192.589 180.052 192.839Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M120.502 151.545C120.637 153.983 120.541 156.421 120.213 158.859C120.175 159.128 120.618 159.128 120.657 158.859C120.984 156.441 121.081 154.003 120.946 151.545C120.926 151.277 120.502 151.277 120.502 151.545Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M120.406 159.511C127.518 162.102 134.61 164.675 141.721 167.266C141.991 167.362 142.087 166.94 141.837 166.844C134.725 164.252 127.633 161.68 120.522 159.088C120.252 158.992 120.137 159.415 120.406 159.511Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M142.376 159.436C142.665 161.912 142.396 164.37 141.567 166.731C141.471 167 141.894 167.115 141.991 166.846C142.82 164.446 143.109 161.951 142.82 159.436C142.781 159.167 142.357 159.167 142.376 159.436Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M120.58 151.678C124.338 152.753 128.096 153.905 131.815 155.133C133.646 155.748 135.458 156.362 137.289 157.015C138.233 157.341 139.158 157.687 140.102 158.032C140.835 158.301 142.396 158.512 142.357 159.434C142.357 159.702 142.781 159.702 142.8 159.434C142.8 159.203 142.82 158.973 142.82 158.743C142.82 158.647 142.742 158.57 142.665 158.531C135.458 155.786 128.135 153.367 120.715 151.256C120.426 151.198 120.31 151.601 120.58 151.678Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.775 134.903C113.296 139.126 122.527 143.983 131.411 149.435C131.642 149.588 131.873 149.204 131.623 149.07C122.758 143.618 113.527 138.761 103.987 134.538C103.756 134.423 103.525 134.787 103.775 134.903Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M130.736 149.223C139.235 153.484 148.023 157.189 157.004 160.319C157.273 160.414 157.389 159.992 157.119 159.896C148.158 156.786 139.428 153.081 130.948 148.839C130.717 148.723 130.486 149.088 130.736 149.223Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.155 161.163C156.155 161.873 156.155 162.602 156.155 163.313C156.155 163.581 156.599 163.601 156.599 163.313C156.599 162.602 156.599 161.873 156.599 161.163C156.599 160.894 156.155 160.894 156.155 161.163Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.232 165.233C156.348 166.02 156.367 166.826 156.29 167.613C156.271 167.882 156.695 167.882 156.733 167.613C156.791 166.769 156.772 165.943 156.656 165.118C156.598 164.849 156.194 164.964 156.232 165.233Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.31 169.493C156.31 170.357 156.31 171.221 156.31 172.085C156.31 172.354 156.753 172.373 156.753 172.085C156.753 171.221 156.753 170.357 156.753 169.493C156.734 169.205 156.31 169.205 156.31 169.493Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.483 173.45C156.309 174.352 156.309 175.235 156.483 176.137C156.54 176.406 156.964 176.291 156.907 176.022C156.733 175.197 156.733 174.391 156.907 173.565C156.964 173.296 156.54 173.181 156.483 173.45Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.444 178.229C156.502 178.978 156.483 179.726 156.386 180.475C156.348 180.744 156.772 180.859 156.81 180.59C156.926 179.803 156.964 179.016 156.887 178.229C156.849 177.96 156.406 177.96 156.444 178.229Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.599 183.971C156.599 184.681 156.599 185.411 156.599 186.121C156.599 186.39 157.042 186.409 157.042 186.121C157.042 185.411 157.042 184.681 157.042 183.971C157.023 183.702 156.599 183.702 156.599 183.971Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.425 189.42C156.483 190.092 156.541 190.764 156.599 191.417C156.618 191.686 157.061 191.686 157.042 191.417C156.984 190.745 156.927 190.073 156.869 189.42C156.83 189.152 156.406 189.152 156.425 189.42Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.599 194.739C156.599 195.738 156.599 196.755 156.599 197.753C156.599 198.022 157.042 198.041 157.042 197.753C157.042 196.755 157.042 195.738 157.042 194.739C157.023 194.451 156.599 194.451 156.599 194.739Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.599 200.767C156.599 201.477 156.599 202.207 156.599 202.917C156.599 203.186 157.042 203.205 157.042 202.917C157.042 202.207 157.042 201.477 157.042 200.767C157.023 200.479 156.599 200.479 156.599 200.767Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.271 206.506C156.329 207.408 156.387 208.329 156.445 209.232C156.464 209.5 156.888 209.5 156.888 209.232C156.83 208.329 156.772 207.408 156.714 206.506C156.676 206.237 156.252 206.218 156.271 206.506Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.599 212.247C156.599 213.303 156.599 214.359 156.599 215.396C156.599 215.664 157.042 215.684 157.042 215.396C157.042 214.34 157.042 213.284 157.042 212.247C157.023 211.959 156.599 211.959 156.599 212.247Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M195.084 161.833C193.484 167.4 190.555 172.506 186.546 176.71C186.354 176.922 186.662 177.21 186.855 177.018C190.902 172.756 193.87 167.592 195.508 161.948C195.565 161.679 195.161 161.564 195.084 161.833Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M157.619 160.721C169.606 154.597 181.728 148.761 194.004 143.232C197.492 141.658 200.98 140.122 204.488 138.586C204.738 138.471 204.526 138.106 204.276 138.221C191.942 143.597 179.724 149.26 167.66 155.211C164.229 156.9 160.818 158.609 157.426 160.356C157.157 160.49 157.369 160.855 157.619 160.721Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.2593 103.993C108.612 108.447 120.85 113.169 132.972 118.18C136.537 119.658 140.083 121.156 143.629 122.672C143.879 122.787 144.111 122.403 143.841 122.307C131.7 117.105 119.443 112.19 107.09 107.545C103.525 106.201 99.9402 104.895 96.3556 103.59C96.1051 103.475 95.9895 103.897 96.2593 103.993Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.5095 103.821C96.4903 102.823 100.653 104.608 101.096 104.781C102.638 105.338 104.18 105.914 105.702 106.49C108.901 107.68 112.081 108.889 115.261 110.099C121.505 112.479 127.73 114.917 133.935 117.413C137.5 118.853 141.066 120.292 144.612 121.771C144.862 121.886 144.978 121.463 144.727 121.348C131.083 115.724 117.361 110.329 103.524 105.223C101.655 104.532 99.7665 103.687 97.8393 103.13C97.1841 102.938 96.0663 102.919 96.0856 103.821C96.0663 104.109 96.5095 104.109 96.5095 103.821Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M143.282 122.615C145.094 125.206 146.25 128.144 147.271 131.1C148.37 134.306 149.411 137.55 150.47 140.775C152.629 147.322 154.787 153.868 156.965 160.414C157.061 160.683 157.466 160.568 157.389 160.299C155.192 153.638 152.976 146.957 150.779 140.295C149.719 137.09 148.697 133.864 147.58 130.658C146.578 127.76 145.421 124.919 143.668 122.384C143.494 122.154 143.109 122.384 143.282 122.615Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M144.554 121.425C150.219 133.769 153.939 146.862 157.639 159.897C157.716 160.165 158.14 160.05 158.063 159.781C154.363 146.708 150.624 133.596 144.939 121.214C144.823 120.945 144.438 121.176 144.554 121.425Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M140.064 119.792C140.545 120.022 141.008 119.792 141.509 119.657C142.511 119.369 143.494 119.081 144.496 118.774C146.423 118.179 148.331 117.526 150.22 116.854C150.489 116.758 150.374 116.336 150.104 116.432C148.505 117.008 146.886 117.565 145.248 118.064C144.438 118.313 143.61 118.582 142.8 118.813C142.222 118.985 140.834 119.676 140.276 119.408C140.044 119.292 139.813 119.676 140.064 119.792Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M164.944 92.0722C159.856 100.039 155.096 108.198 150.683 116.568C150.548 116.817 150.933 117.029 151.049 116.779C155.462 108.428 160.222 100.25 165.31 92.2834C165.464 92.053 165.098 91.8418 164.944 92.0722Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M164.866 92.5713C165.657 91.8802 166.851 92.4369 167.68 92.7057C168.586 92.9936 169.511 93.2816 170.417 93.5887C172.19 94.1454 173.943 94.7214 175.716 95.2781C179.32 96.4299 182.905 97.5817 186.508 98.7336C193.639 101.018 200.769 103.303 207.9 105.587C209.846 106.22 211.793 106.835 213.739 107.468C214.78 107.795 215.801 108.14 216.842 108.467C217.806 108.774 219.02 108.985 219.713 109.791C219.887 110.002 220.195 109.695 220.022 109.484C219.039 108.332 217.054 108.083 215.686 107.641C213.797 107.027 211.908 106.432 210.02 105.817C206.185 104.589 202.35 103.36 198.515 102.131C190.845 99.6742 183.155 97.217 175.485 94.7598C173.288 94.0495 171.091 93.3584 168.913 92.6481C167.661 92.2449 165.772 91.2275 164.577 92.2641C164.346 92.4561 164.654 92.7632 164.866 92.5713Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M150.277 116.874C164.249 122.403 178.241 127.932 192.213 133.46C196.202 135.034 200.191 136.609 204.161 138.183C204.411 138.279 204.527 137.876 204.277 137.76C190.305 132.232 176.313 126.703 162.341 121.174C158.352 119.6 154.363 118.026 150.393 116.452C150.143 116.356 150.027 116.778 150.277 116.874Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M218.768 109.081C213.873 118.622 208.997 128.182 204.102 137.723C203.968 137.972 204.353 138.184 204.469 137.934C209.364 128.393 214.239 118.833 219.134 109.292C219.269 109.042 218.884 108.831 218.768 109.081Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M219.559 109.753C214.625 119.294 209.711 128.854 204.777 138.395C204.642 138.644 205.028 138.856 205.143 138.606C210.077 129.065 214.991 119.505 219.925 109.964C220.06 109.733 219.694 109.503 219.559 109.753Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M140.603 119.756C143.859 118.738 147.116 117.74 150.373 116.723C168.296 123.845 186.238 130.967 204.16 138.108C188.782 145.48 173.403 152.852 158.024 160.224C156.174 153.524 154.459 147.822 153.052 143.349C150.181 134.154 148.523 129.796 147.193 126.494C146.365 124.44 145.632 122.751 145.131 121.599C143.609 120.984 142.106 120.37 140.603 119.756Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M182.076 185.984C181.613 186.119 180.977 186.407 180.399 186.963C179.358 188 179.667 188.941 178.876 190.707C177.913 192.857 176.891 192.627 176.602 194.258C176.371 195.506 176.911 195.813 176.757 197.541C176.66 198.559 176.39 199.269 175.966 200.363C174.791 203.358 173.789 203.742 173.615 205.374C173.538 206.141 173.615 207.312 174.56 208.81C175.485 208.695 176.602 208.426 176.795 207.754C177.103 206.737 174.964 205.911 175.061 204.356C175.099 203.627 175.909 202.763 177.489 201.035C178.048 200.421 178.414 200.094 178.607 199.442C178.799 198.808 178.684 198.328 178.472 197.215C178.048 195.141 177.855 194.086 177.913 193.817C178.221 192.569 179.455 192.454 180.553 191.244C181.362 190.381 182.172 188.845 182.076 185.984Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M178.684 192.281C177.392 193.049 177.392 194.566 177.508 195.91C177.547 196.274 178.125 196.274 178.086 195.91C177.99 194.815 177.874 193.433 178.973 192.781C179.281 192.589 178.992 192.089 178.684 192.281Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M185.66 200.459C185.564 200.977 185.603 201.514 185.487 202.033C185.313 202.801 184.889 203.146 184.234 203.492C183.483 203.876 182.712 204.164 182.172 204.836C180.997 206.275 181.421 208.272 182.866 209.328C183.174 209.558 183.444 209.04 183.155 208.829C182.095 208.041 181.71 206.64 182.423 205.488C182.904 204.682 183.733 204.413 184.523 203.991C184.986 203.741 185.448 203.453 185.737 203.012C186.2 202.301 186.065 201.399 186.219 200.612C186.277 200.247 185.718 200.094 185.66 200.459Z"
        fill="#1C2A3C"
      />
      <path
        d="M86.5453 55.1328C83.963 57.3789 82.691 59.6058 82.0165 61.1031C80.6482 64.1747 80.4748 67.3998 80.205 73.7541C80.0894 76.4225 80.1086 78.4382 80.1086 79.0525C80.1664 84.5813 80.706 88.6127 81.7853 96.6948C81.9587 98.0002 82.2478 100.131 83.2499 102.819C83.3077 102.953 83.3655 103.164 83.4619 103.375C85.3505 107.983 88.8772 110.786 90.3226 111.937C92.4232 113.608 94.254 114.529 94.8514 114.836C99.8042 117.389 106.048 120.691 113.795 124.78C114.335 126.546 115.125 128.831 116.224 131.423C117.206 133.765 117.842 135.281 118.96 137.028C120.078 138.794 121.292 140.1 123.74 142.557C123.74 142.557 125.917 144.899 132.45 149.698C133.24 150.274 134.667 151.311 135.804 150.85C136.247 150.658 136.767 150.197 136.767 149.698C136.767 149.199 136.285 148.873 135.707 148.45C133.722 147.03 132.084 145.936 130.832 144.726C130.581 144.496 129.752 143.67 129.868 143.517C130.022 143.306 131.525 144.496 134.088 145.398C135.457 145.878 136.44 146.032 138.405 146.358C138.405 146.358 139.099 146.473 140.968 146.454C141.604 146.454 142.163 146.416 142.606 146.032C142.684 145.974 143.108 145.59 143.05 145.264C142.915 144.496 140.178 144.457 138.001 144.169C136.131 143.92 133.587 143.306 130.639 141.789"
        stroke="#1C2A3C"
        stroke-width="0.7"
      />
      <path
        d="M86.3721 55.1726C86.8731 54.923 87.6633 54.6159 88.5305 54.7887C90.4769 55.1534 91.4212 57.4955 91.903 58.6857C92.963 61.3541 92.8088 63.7538 92.7702 64.4641C92.5004 68.4571 92.6353 72.4693 92.3077 76.4623C91.2863 88.8445 91.7296 93.4135 92.1536 96.2738C92.4041 97.9056 92.6739 99.2302 92.8666 100.094C95.6032 103.914 98.3976 106.832 100.691 108.982C105.663 113.628 110.288 116.335 112.35 117.487C113.699 118.235 114.856 118.792 115.723 119.195C116.397 119.023 117.399 118.888 118.536 119.119C120.252 119.464 120.907 120.405 122.603 121.691C125.378 123.783 128.5 124.916 130.581 125.665C131.622 126.049 132.585 126.605 133.626 126.989C134.628 127.354 135.418 127.584 135.823 128.314C135.996 128.621 136.228 129.312 135.977 129.715C134.994 131.328 127.093 127.7 126.592 128.698C126.322 129.216 128.114 130.598 128.384 130.81C129.386 131.578 132.239 133.555 137.461 134.323C139.62 134.63 141.45 134.63 143.262 136.031C143.647 136.338 144.418 136.953 144.283 137.433C144.052 138.239 141.431 138.22 138.656 138.22C137.673 138.22 137.056 138.22 136.228 138.143C134.551 138.009 131.872 137.586 128.635 136.185C130.967 137.663 132.971 138.546 134.339 139.064C137.847 140.408 139.62 141.08 141.489 141.426C142.992 141.714 144.939 141.925 145.363 143.077C145.401 143.173 145.517 143.537 145.363 143.902C145.035 144.651 143.667 144.939 141.913 144.593"
        stroke="#1C2A3C"
        stroke-width="0.7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M133.665 128.85C133.53 128.773 133.472 128.543 133.607 128.427C133.511 128.408 133.434 128.408 133.337 128.389C133.453 128.523 133.491 128.735 133.414 128.907C133.299 129.157 133.665 129.387 133.78 129.118C133.935 128.754 133.896 128.37 133.626 128.082C133.568 128.024 133.434 128.005 133.356 128.043C132.971 128.312 132.971 128.965 133.414 129.195C133.703 129.349 133.915 128.984 133.665 128.85Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M141.836 136.782C141.855 136.782 141.874 136.82 141.893 136.82C141.913 136.82 141.874 136.82 141.913 136.82C141.951 136.801 141.97 136.782 142.028 136.782C142.048 136.782 142.105 136.782 142.105 136.801C142.125 136.82 142.105 136.858 142.105 136.858C142.086 136.858 142.163 136.839 142.182 136.839C142.221 136.858 142.105 136.993 142.086 136.954C142.067 136.935 142.086 136.897 142.086 136.878C142.086 136.897 142.048 136.878 142.067 136.878C141.855 136.705 141.546 136.993 141.758 137.185C141.893 137.3 142.067 137.338 142.24 137.281C142.433 137.223 142.549 137.031 142.51 136.82C142.471 136.647 142.298 136.513 142.125 136.513C141.932 136.513 141.758 136.667 141.758 136.878C141.758 137.07 141.913 137.223 142.105 137.262C142.298 137.3 142.491 137.166 142.549 136.974C142.683 136.571 142.26 136.244 141.874 136.359C141.662 136.417 141.469 136.609 141.489 136.839C141.489 137.07 141.758 137.281 141.99 137.185C142.221 137.108 142.105 136.705 141.836 136.782Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M143.59 143.308C143.647 143.327 143.724 143.404 143.667 143.462C143.647 143.481 143.628 143.481 143.609 143.481C143.59 143.481 143.628 143.481 143.609 143.481C143.628 143.5 143.628 143.5 143.609 143.5C143.609 143.481 143.609 143.481 143.609 143.519C143.609 143.5 143.609 143.481 143.628 143.442C143.628 143.442 143.647 143.423 143.667 143.423C143.647 143.423 143.647 143.423 143.667 143.423C143.686 143.423 143.686 143.442 143.667 143.423C143.647 143.423 143.647 143.423 143.667 143.423C143.647 143.385 143.667 143.442 143.686 143.442C143.686 143.462 143.686 143.481 143.686 143.481C143.628 143.462 143.686 143.5 143.686 143.481C143.667 143.481 143.667 143.481 143.647 143.481C143.628 143.481 143.667 143.5 143.647 143.481C143.647 143.462 143.647 143.5 143.647 143.481C143.647 143.519 143.628 143.5 143.647 143.5C143.628 143.519 143.628 143.519 143.609 143.519C143.57 143.519 143.532 143.481 143.532 143.423C143.532 143.366 143.551 143.346 143.609 143.327C143.59 143.327 143.647 143.327 143.647 143.327C143.647 143.327 143.705 143.366 143.686 143.346C143.705 143.366 143.705 143.346 143.705 143.385C143.705 143.404 143.705 143.423 143.705 143.462C143.686 143.519 143.686 143.5 143.628 143.538C143.512 143.596 143.493 143.75 143.551 143.826C143.609 143.942 143.744 143.961 143.84 143.903C144.071 143.807 144.187 143.519 144.129 143.27C144.052 143.001 143.782 142.866 143.532 142.905C143.281 142.943 143.089 143.174 143.108 143.423C143.127 143.692 143.32 143.922 143.609 143.942C143.898 143.942 144.129 143.73 144.11 143.442C144.071 143.135 143.782 142.962 143.493 143.097C143.262 143.212 143.185 143.538 143.397 143.711C143.57 143.865 143.898 143.846 144.033 143.634C144.187 143.366 143.936 143.001 143.628 143.02C143.474 143.02 143.339 143.135 143.3 143.289C143.243 143.462 143.339 143.615 143.512 143.692C143.628 143.73 143.744 143.654 143.782 143.538C143.782 143.462 143.705 143.366 143.59 143.308Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M141.277 145.631C141.257 145.612 141.257 145.612 141.277 145.631C141.277 145.612 141.2 145.65 141.219 145.65C141.238 145.65 141.238 145.65 141.219 145.65C141.2 145.65 141.2 145.65 141.238 145.65C141.219 145.631 141.219 145.65 141.238 145.65C141.277 145.669 141.238 145.65 141.257 145.65C141.257 145.631 141.277 145.669 141.257 145.65C141.257 145.669 141.257 145.631 141.257 145.631C141.257 145.631 141.277 145.592 141.257 145.612C141.238 145.631 141.257 145.592 141.277 145.592C141.238 145.592 141.296 145.573 141.277 145.592C141.277 145.592 141.219 145.612 141.257 145.592C141.238 145.592 141.277 145.592 141.257 145.592C141.277 145.592 141.238 145.592 141.238 145.592C141.238 145.573 141.277 145.592 141.238 145.592L141.257 145.612C141.257 145.573 141.277 145.631 141.257 145.612C141.257 145.631 141.257 145.631 141.257 145.65C141.277 145.631 141.277 145.631 141.257 145.631C141.238 145.65 141.277 145.612 141.277 145.631C141.257 145.612 141.257 145.612 141.238 145.592C141.2 145.573 141.257 145.612 141.238 145.592C141.238 145.573 141.238 145.573 141.238 145.612V145.592C141.238 145.612 141.238 145.612 141.238 145.592C141.238 145.592 141.219 145.65 141.219 145.631C141.2 145.65 141.219 145.65 141.219 145.631C141.2 145.631 141.2 145.65 141.219 145.631C141.238 145.631 141.238 145.631 141.238 145.631C141.219 145.631 141.219 145.631 141.2 145.631C141.084 145.612 140.988 145.746 140.988 145.842C140.988 145.976 141.084 146.053 141.2 146.053C141.527 146.092 141.758 145.669 141.624 145.4C141.469 145.074 141.007 145.17 140.853 145.458C140.679 145.784 141.007 146.092 141.335 146.034C141.489 145.996 141.604 145.9 141.643 145.746C141.681 145.573 141.604 145.42 141.469 145.324C141.335 145.228 141.142 145.208 140.988 145.304C140.795 145.42 140.756 145.688 140.872 145.88C141.026 146.092 141.412 145.88 141.277 145.631Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M134.648 149.796H134.667C134.648 149.777 134.648 149.777 134.648 149.777C134.667 149.777 134.667 149.777 134.648 149.796C134.667 149.796 134.667 149.796 134.648 149.796C134.667 149.815 134.628 149.834 134.648 149.796C134.648 149.815 134.686 149.815 134.686 149.815C134.686 149.834 134.725 149.815 134.686 149.815C134.686 149.834 134.686 149.873 134.667 149.892C134.648 149.911 134.609 149.892 134.59 149.873C134.57 149.853 134.57 149.834 134.57 149.815L134.59 149.796C134.609 149.777 134.628 149.777 134.648 149.777C134.686 149.777 134.686 149.777 134.686 149.777C134.725 149.815 134.725 149.892 134.705 149.949C134.705 149.969 134.686 149.969 134.686 149.988C134.686 150.007 134.667 149.93 134.705 149.988C134.725 149.873 134.59 149.777 134.493 149.777C134.358 149.777 134.281 149.873 134.281 149.988C134.262 150.237 134.513 150.429 134.744 150.41C134.994 150.391 135.168 150.141 135.168 149.892C135.168 149.661 135.033 149.431 134.802 149.373C134.609 149.316 134.397 149.373 134.262 149.527C133.896 149.93 134.455 150.564 134.898 150.276C135.091 150.161 135.187 149.911 135.11 149.7C135.033 149.489 134.821 149.373 134.609 149.412C134.358 149.45 134.166 149.681 134.243 149.93C134.32 150.18 134.628 150.333 134.86 150.199C135.11 150.045 134.898 149.661 134.648 149.796Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M110.963 49.0291C114.182 53.2909 119.597 55.9401 124.877 54.0204C130.717 51.8895 133.762 46.1687 136.151 40.8511C136.267 40.6015 135.882 40.3712 135.785 40.6399C133.55 45.612 130.813 50.9296 125.571 53.2909C120.291 55.6714 114.644 53.2141 111.349 48.818C111.156 48.5876 110.79 48.7988 110.963 49.0291Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.589 53.4052C115.608 53.4052 115.627 53.4244 115.627 53.4244C115.685 53.4436 115.801 53.4244 115.839 53.3668C115.936 53.2516 115.955 53.194 115.936 53.0404C115.916 52.9636 115.858 52.906 115.781 52.8868C115.415 52.8292 115.126 53.098 114.837 53.29C114.259 53.6547 113.719 54.0579 113.18 54.461C111.966 55.4209 110.867 56.4959 109.884 57.6669C109.711 57.8781 110.019 58.1853 110.193 57.9741C110.963 57.0526 111.811 56.1696 112.736 55.3825C113.218 54.9601 113.719 54.5762 114.259 54.1922C114.529 54.0003 114.799 53.8083 115.088 53.6355C115.165 53.5779 116.013 53.0788 115.743 52.9636C115.454 52.8676 115.338 53.29 115.589 53.4052Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M112.639 34.3032C112.774 33.209 112.042 32.1723 110.962 31.8844C109.768 31.5772 108.534 32.1915 107.84 33.1514C106.588 34.8791 106.703 39.3329 109.825 38.6034C110.095 38.5458 109.979 38.1235 109.71 38.1811C107.108 38.7954 107.166 35.0519 108.033 33.6313C108.553 32.8058 109.459 32.1723 110.481 32.2491C111.56 32.3259 112.311 33.2474 112.196 34.3032C112.157 34.572 112.6 34.572 112.639 34.3032Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.594 33.461C110.48 32.4244 111.791 34.824 111.097 35.6303C110.924 35.8415 111.232 36.1486 111.406 35.9375C112.446 34.7088 110.577 31.6373 109.286 33.1539C109.112 33.365 109.421 33.6722 109.594 33.461Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.845 36.3395C109.652 35.9939 109.826 35.4948 110.211 35.3796C110.674 35.2452 111.098 35.7443 111.001 36.1859C110.944 36.4546 111.348 36.5698 111.425 36.3011C111.599 35.5908 110.944 34.7845 110.173 34.9573C109.479 35.1108 109.132 35.9747 109.479 36.5698C109.614 36.8002 109.98 36.589 109.845 36.3395Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.267 37.547C109.132 37.4511 109.151 37.2591 109.248 37.1439C109.151 37.1631 109.074 37.1631 108.978 37.1823C109.036 37.2207 109.132 37.2975 109.151 37.3935C109.151 37.4127 109.151 37.4127 109.151 37.4319C109.132 37.4511 109.132 37.4511 109.151 37.4319C109.171 37.4319 109.19 37.4319 109.209 37.4319C109.228 37.4511 109.228 37.4895 109.19 37.5278C109.383 37.3359 109.074 37.0287 108.882 37.2207C108.573 37.5278 109.016 38.027 109.363 37.7966C109.518 37.7006 109.595 37.4895 109.575 37.3167C109.537 37.0863 109.383 36.9327 109.209 36.8176C109.132 36.76 109.016 36.7984 108.939 36.8559C108.612 37.1631 108.689 37.6814 109.036 37.931C109.267 38.0846 109.479 37.7006 109.267 37.547Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.136 32.0198C112.293 27.5852 115.627 23.8033 119.982 22.2676C124.434 20.6934 130.639 20.2711 134.455 23.4962C134.667 23.669 134.975 23.3618 134.763 23.189C130.793 19.8679 124.472 20.2135 119.866 21.8452C115.376 23.4386 111.907 27.3164 110.712 31.9046C110.635 32.1733 111.059 32.2885 111.136 32.0198Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.73 31.9257C110.655 25.5906 115.723 21.06 121.659 19.2363C121.928 19.1595 121.813 18.7372 121.543 18.814C115.472 20.6761 110.269 25.3218 109.325 31.8105C109.286 32.0792 109.691 32.1944 109.73 31.9257Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.203 11.056C114.933 11.5552 114.971 11.9583 114.971 12.515C114.971 13.4365 114.528 13.9548 114.22 14.7611C113.95 15.4906 113.969 16.2777 114.663 16.7576C115.684 17.4679 117.245 17.6215 118.421 17.8902C120.078 18.255 121.736 18.6005 123.297 19.2532C123.547 19.3684 123.779 18.9845 123.509 18.8885C121.37 17.9862 119.096 17.6599 116.86 17.084C116.282 16.9304 115.627 16.796 115.106 16.5272C114.123 16.0089 114.586 14.9723 114.971 14.2236C115.164 13.8588 115.338 13.5133 115.395 13.1101C115.492 12.4766 115.241 11.8815 115.588 11.2864C115.704 11.0368 115.338 10.8257 115.203 11.056Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.318 11.5938C116.494 9.61652 119.23 13.168 120.059 13.9359C121.35 15.1261 122.796 16.1436 123.875 17.545C124.048 17.7561 124.357 17.449 124.183 17.2378C123.393 16.2204 122.43 15.4141 121.447 14.5886C120.541 13.8207 119.712 12.9952 118.884 12.1314C117.978 11.2099 115.916 9.7509 114.952 11.4019C114.798 11.613 115.164 11.8434 115.318 11.5938Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M117.264 11.8836C115.819 12.6707 116.783 13.9953 117.785 14.5904C119.712 15.723 121.813 16.5677 123.354 18.2378C123.547 18.449 123.855 18.1419 123.663 17.9307C122.757 16.9516 121.658 16.2413 120.502 15.5886C119.905 15.2623 119.288 14.9359 118.691 14.6096C117.977 14.2064 115.935 13.093 117.476 12.2675C117.727 12.1331 117.515 11.7492 117.264 11.8836Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M122.661 19.0058C122.776 20.1001 123.875 20.2728 124.781 20.196C125.764 20.1385 126.823 19.8697 126.958 18.7563C126.997 18.4875 126.554 18.4875 126.515 18.7563C126.361 19.9081 123.2 20.3496 123.065 19.0058C123.065 18.7371 122.642 18.7371 122.661 19.0058Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M124.742 17.0272C126.342 15.1651 127.98 13.3221 129.637 11.4984C130.042 11.0377 130.466 10.5961 130.89 10.1354C131.237 9.77064 131.661 9.17552 132.143 9.00275C133.839 8.35004 133.742 10.1546 134.263 11.1144C134.821 12.1703 135.747 12.8422 135.053 14.1476C134.494 15.2034 133.395 15.6642 132.297 15.9905C130.216 16.6048 128.327 17.2 126.515 18.467C126.284 18.6206 126.515 19.0045 126.727 18.8317C127.999 17.9295 129.406 17.2192 130.909 16.7968C132.123 16.4513 133.453 16.2401 134.475 15.453C135.149 14.9347 135.689 14.1284 135.747 13.2837C135.824 12.0935 134.841 11.5368 134.475 10.5001C134.224 9.78983 134.166 8.90676 133.415 8.54202C132.509 8.08128 131.622 8.73399 131.025 9.3483C128.732 11.6904 126.592 14.2244 124.434 16.72C124.261 16.9312 124.569 17.2384 124.742 17.0272Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M131.449 10.9624C131.738 10.2713 132.181 10.3673 132.798 11.2311C132.682 11.5191 132.528 11.7687 132.297 11.9798C132.008 12.287 131.641 12.5557 131.295 12.8245C130.639 13.3044 129.946 13.746 129.29 14.2259C128.038 15.1474 126.843 16.1456 125.686 17.1823C125.474 17.3742 125.783 17.6814 125.995 17.4894C127.209 16.376 128.462 15.3393 129.791 14.3795C130.813 13.65 132.104 12.9973 132.875 11.9606C133.28 11.3847 133.511 10.4633 132.798 10.0025C132.085 9.52259 131.41 10.1753 131.063 10.7512C130.928 10.9816 131.295 11.2119 131.449 10.9624Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M124.241 17.6799C125.089 17.1423 126.072 17.6415 126.207 18.6013C126.246 18.8701 126.67 18.7549 126.631 18.4861C126.458 17.2383 125.089 16.6432 124.029 17.3151C123.779 17.4687 123.991 17.8334 124.241 17.6799Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M132.046 10.6531C132.643 10.7107 131.603 11.6898 131.506 11.7857C131.294 11.9969 131.063 12.1889 130.851 12.4001C130.408 12.8032 129.965 13.2063 129.521 13.5903C128.616 14.3774 127.71 15.1453 126.766 15.8747C126.554 16.0475 126.862 16.3547 127.074 16.1819C128.712 14.8765 130.292 13.5135 131.815 12.0929C132.258 11.6706 133.376 10.346 132.046 10.2116C131.757 10.1924 131.776 10.6147 132.046 10.6531Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M132.393 10.6725C131.988 12.3811 129.811 13.4177 128.481 14.3584C127.305 15.203 126.226 16.1053 125.397 17.3147C125.243 17.5451 125.609 17.7563 125.764 17.5259C126.843 15.9709 128.404 14.9343 129.926 13.8592C131.063 13.053 132.47 12.2083 132.798 10.7877C132.875 10.5189 132.451 10.4037 132.393 10.6725Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M132.663 10.9225C132.374 11.7096 131.834 12.3431 131.102 12.7462C130.851 12.8806 131.082 13.2646 131.314 13.111C132.142 12.6502 132.759 11.9208 133.087 11.0377C133.183 10.7689 132.759 10.6537 132.663 10.9225Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M117.207 12.1886C117.111 12.9373 117.361 13.6284 117.901 14.1275C117.978 14.0124 118.036 13.878 118.113 13.7628C117.573 13.59 117.265 13.0717 117.38 12.515C117.245 12.4958 117.091 12.4766 116.956 12.4574C116.899 12.9949 117.053 13.4556 117.4 13.878C117.496 13.782 117.612 13.6668 117.708 13.5708C117.4 13.2829 117.245 12.9373 117.188 12.5342C117.072 12.5918 116.937 12.6302 116.821 12.6878C117.554 13.5132 118.305 14.3195 119.038 15.145C119.23 15.3562 119.539 15.049 119.346 14.8378C118.614 14.0124 117.862 13.2061 117.13 12.3806C117.014 12.2462 116.744 12.3422 116.764 12.5342C116.821 13.0717 117.014 13.494 117.4 13.878C117.612 14.07 117.881 13.782 117.708 13.5708C117.438 13.2445 117.342 12.8605 117.4 12.4574C117.438 12.2078 117.033 12.1694 116.976 12.3998C116.802 13.1869 117.226 13.9356 118.016 14.1851C118.228 14.2427 118.382 13.974 118.228 13.8204C117.766 13.3789 117.573 12.8029 117.65 12.1886C117.689 11.9007 117.245 11.9007 117.207 12.1886Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M117.612 13.3018C117.592 13.2442 117.592 13.2058 117.573 13.1482C117.438 13.1674 117.303 13.1866 117.168 13.2058C117.746 14.2232 118.71 14.7416 119.712 15.2599C121.061 15.9702 122.237 16.8533 123.277 17.9667C123.47 18.1779 123.778 17.8707 123.586 17.6595C122.738 16.7573 121.793 15.9702 120.714 15.3175C119.577 14.6456 118.209 14.1848 117.534 12.9754C117.438 12.8026 117.188 12.8602 117.13 13.033C117.053 13.2826 117.053 13.321 117.207 13.5129C117.38 13.7433 117.766 13.5321 117.612 13.3018Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M128.886 39.6992C127.305 42.1181 125.744 44.5369 124.164 46.9558C125.108 47.2245 126.072 47.4741 127.016 47.7428C127.479 46.591 127.941 45.2088 128.288 43.6346C128.616 42.1757 128.789 40.8511 128.886 39.6992Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M121.986 36.0708C121.87 35.8213 121.948 35.4949 122.082 35.2838C122.757 34.2663 125.84 34.6694 126.207 35.7829C126.303 36.0708 126.207 36.4548 126.014 36.666C125.879 36.8003 125.609 36.9731 124.048 36.7619C122.237 36.5124 122.044 36.2052 121.986 36.0708Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M131.815 38.0654C131.719 38.4301 132.046 38.7949 132.335 39.102C133.048 39.8699 134.263 40.5802 134.629 40.2538C134.937 39.9659 134.494 39.0636 134.417 38.91C134.34 38.7757 133.723 37.4702 132.74 37.5086C132.374 37.5086 131.911 37.7198 131.815 38.0654Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.575 38.699C108.226 46.3779 106.858 54.0568 105.509 61.7165C105.76 58.7793 106.029 55.8421 106.28 52.905C105.509 55.7078 104.738 58.5106 103.987 61.3133C101.79 60.5071 99.1109 59.2976 96.2779 57.5123C93.6955 55.8805 91.6142 54.1912 90.0146 52.6746C90.0917 52.1563 90.2459 51.3308 90.6892 50.4477C91.4793 48.8736 92.7127 48.0097 92.9825 47.7985C95.006 46.2819 96.6248 42.2313 99.1301 35.9922C101.269 30.6554 103.543 25.0882 106.376 20.5577C106.53 20.3081 108.169 17.7549 111.233 15.8352C112.755 14.8753 114.104 14.4146 114.355 14.7409C114.586 15.0097 113.892 15.6816 114.143 16.2959C114.413 16.9678 115.588 17.083 115.974 17.1214C117.438 17.275 119.616 17.7549 123.065 18.9451C122.333 19.1179 121.215 19.4442 119.943 19.9818C118.498 20.5961 114.74 22.2278 112.061 25.9521C110.732 27.795 110.076 28.7165 110.076 29.9451C110.076 30.6362 110.269 31.5001 109.71 32.076C109.306 32.4983 108.978 32.3256 108.361 32.6903C107.359 33.3046 107.205 34.706 107.166 35.0324C107.051 36.1074 107.436 36.8561 107.783 37.5856C108.034 38.0655 108.246 38.3151 108.515 38.4687C108.939 38.7182 109.363 38.7182 109.575 38.699Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M128.732 29.2378C128.019 30.7352 127.132 31.7526 126.381 32.4053C121.331 36.9167 113.334 34.3058 112.659 34.0755C112.601 33.8067 112.428 33.058 111.773 32.4629C111.445 32.175 111.117 32.0214 110.886 31.9446C111.079 31.0807 111.464 29.8713 112.197 28.5659C113.97 25.3791 116.61 23.8242 117.785 23.1523C121.967 20.7718 125.995 20.983 127.441 21.079C129.368 21.2133 131.834 21.3669 134.282 22.9987C137.712 25.2832 138.811 28.8922 139.35 30.7352C140.102 33.346 139.967 35.0737 139.717 39.7195C139.138 51.0074 139.331 53.5798 138.368 62.6985C137.886 67.2483 137.712 67.6322 137.635 67.6322C137.327 67.613 137.385 61.7003 137.481 56.4594C137.385 58.4559 137.173 60.6828 136.768 63.0633C136.46 64.9638 136.074 66.7107 135.65 68.3233C134.243 68.3041 132.586 68.1889 130.794 67.8818C129.406 67.6322 128.154 67.325 127.055 66.9795C126.959 65.4437 126.843 63.8887 126.747 62.353C126.419 63.8695 126.091 65.4053 125.764 66.9219C122.064 66.5572 119.212 65.6165 117.265 64.791C113.122 63.0249 110.154 60.5676 110.481 59.7997C110.578 59.5502 110.983 59.4926 111.098 59.0702C111.214 58.6671 110.79 58.4559 110.674 57.8224C110.501 57.88 110.25 57.9376 110.173 57.8416C110.038 57.6688 110.539 57.0929 110.732 56.8818C111.696 55.7875 114.085 54.0406 115.82 52.812C116.668 53.3687 118.672 54.5013 121.428 54.5397C124.415 54.5781 126.515 53.2919 127.537 52.6776C129.329 51.5641 130.312 50.2395 132.278 47.5903C135.13 43.7509 135.669 41.4856 135.824 40.6793C136.171 38.9324 135.997 37.9149 135.92 37.6078C135.747 36.7823 135.342 35.6688 133.357 33.442C132.297 32.2901 130.794 30.7736 128.732 29.2378Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.989 55.729C106.434 57.5527 108.573 58.8773 110.963 58.1862C111.31 58.0903 111.175 57.5335 110.809 57.6295C108.612 58.2822 106.704 56.9768 105.394 55.3259C105.162 55.0187 104.758 55.441 104.989 55.729Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M123.085 37.7617C123.066 37.9921 123.046 38.2225 123.046 38.472C122.777 38.4912 122.391 38.5488 122.025 38.7792C121.138 39.3551 120.734 40.6797 121.177 41.1596C121.447 41.4476 121.986 41.3708 122.333 41.2556C123.258 40.8909 123.625 39.6238 123.432 38.664C123.374 38.2608 123.22 37.9537 123.085 37.7617Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M133.029 41.3516C133.01 41.5819 132.991 41.8123 132.991 42.0619C132.721 42.0811 132.335 42.1386 131.969 42.369C131.083 42.9449 130.678 44.2695 131.121 44.7495C131.391 45.0374 131.931 44.9606 132.278 44.8455C133.203 44.4807 133.569 43.2137 133.376 42.2538C133.299 41.8507 133.145 41.5435 133.029 41.3516Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M118.787 39.6032C119.963 40.4095 120.618 41.6765 121.023 43.0011C121.08 43.1739 121.35 43.0971 121.292 42.9243C120.849 41.5229 120.175 40.1983 118.922 39.3536C118.787 39.2576 118.633 39.5072 118.787 39.6032Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M118.653 40.5434C119.269 41.1769 119.751 41.9064 120.06 42.7318C120.117 42.9046 120.407 42.8278 120.329 42.6551C119.983 41.7912 119.501 41.0041 118.846 40.3322C118.73 40.217 118.518 40.409 118.653 40.5434Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M112.697 27.4535C112.524 27.2424 112.235 27.1464 111.965 27.204C111.657 27.2807 111.464 27.5111 111.348 27.7991C111.233 28.087 111.175 28.4134 111.329 28.7013C111.483 28.9893 111.753 29.1045 112.08 29.0661C112.447 29.0085 112.292 28.4518 111.926 28.5094C111.734 28.5478 111.907 27.4151 112.292 27.8759C112.543 28.1446 112.948 27.7415 112.697 27.4535Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M112.119 28.7364C112.196 28.5637 112.292 28.4101 112.369 28.2373C112.447 28.0837 112.581 27.911 112.524 27.719C112.485 27.5846 112.369 27.5078 112.254 27.5078C112.177 27.5078 112.08 27.5462 112.023 27.6038C111.946 27.6998 111.907 27.8342 111.984 27.9493C111.984 27.9493 111.984 27.9493 111.984 27.9685C112.196 28.2757 112.697 27.9877 112.485 27.6806C112.485 27.6806 112.485 27.6806 112.485 27.6614C112.466 27.7766 112.447 27.8918 112.447 28.0069C112.447 28.0069 112.447 28.0069 112.466 27.9877C112.389 28.0069 112.331 28.0453 112.254 28.0645H112.273C112.177 27.9877 112.08 27.9302 112.003 27.8534V27.8726C112.003 27.815 112.003 27.7766 112.003 27.719C111.965 27.8342 111.888 27.9493 111.83 28.0453C111.772 28.1605 111.714 28.2949 111.637 28.4101C111.444 28.7748 111.946 29.0628 112.119 28.7364Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M112.678 25.0149C112.621 25.4948 113.257 25.6292 113.565 25.3604C113.873 25.0724 114.105 24.4965 113.95 24.0934C113.873 23.8822 113.526 23.767 113.43 24.0166C113.314 24.2662 113.16 24.4965 112.929 24.6501C112.621 24.8613 112.91 25.3604 113.218 25.1492C113.526 24.9381 113.777 24.6501 113.931 24.3046C113.758 24.2854 113.584 24.2662 113.411 24.2278C113.469 24.3813 113.411 24.5349 113.334 24.6693C113.314 24.7269 113.276 24.7845 113.237 24.8421C113.218 24.8613 113.199 24.8997 113.18 24.9189C113.218 24.8997 113.257 24.9381 113.276 24.9957C113.295 24.8421 113.122 24.7077 112.987 24.7077C112.794 24.7269 112.698 24.8613 112.678 25.0149Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.764 23.3807C116.667 23.1119 116.802 22.824 117.111 22.824C117.168 22.824 117.245 22.8816 117.284 22.8816C117.419 22.6704 117.419 22.5936 117.323 22.6512C117.284 22.6704 117.226 22.6896 117.188 22.7088C116.995 22.8048 116.802 22.8816 116.609 22.9775C116.764 23.0543 116.899 23.1503 117.053 23.2271C117.014 23.2655 116.976 23.2847 116.956 23.3231C117.323 23.3999 117.477 22.8432 117.111 22.7664C116.783 22.6896 116.532 22.9008 116.475 23.2271C116.436 23.4575 116.744 23.5535 116.918 23.4767C117.111 23.3807 117.303 23.3039 117.496 23.2079C117.65 23.1311 117.824 23.0735 117.862 22.8816C117.978 22.5168 117.515 22.2864 117.226 22.2481C116.532 22.1713 115.973 22.8624 116.224 23.5151C116.34 23.8798 116.899 23.7454 116.764 23.3807Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M119.308 20.27C119.578 21.3066 121.235 20.7499 121.158 19.79C121.139 19.5981 120.985 19.4637 120.792 19.5213C120.387 19.5981 120.021 19.7516 119.674 19.9628C119.366 20.1548 119.655 20.6539 119.963 20.4619C120.272 20.27 120.599 20.1548 120.946 20.078C120.831 19.982 120.696 19.886 120.58 19.8092C120.599 20.1164 119.944 20.4811 119.848 20.1356C119.79 19.7516 119.231 19.9052 119.308 20.27Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M121.89 21.2317C121.87 20.9245 122.275 20.8285 122.371 21.1357C122.468 21.0205 122.564 20.8861 122.641 20.7709C122.352 20.7709 122.063 20.7709 121.774 20.7901C121.523 20.8093 121.331 20.9053 121.311 21.1741C121.292 21.5388 121.87 21.5388 121.89 21.1741C121.89 21.1549 121.89 21.1549 121.89 21.1357C121.87 21.2125 121.832 21.2701 121.812 21.3469C121.755 21.3661 121.735 21.3853 121.793 21.3853C121.832 21.3853 121.87 21.3853 121.909 21.3853C121.986 21.3853 122.082 21.3853 122.159 21.3853C122.333 21.3853 122.487 21.3853 122.66 21.3853C122.853 21.3853 122.988 21.2125 122.93 21.0205C122.815 20.6174 122.429 20.3486 122.005 20.4062C121.6 20.4638 121.292 20.8669 121.311 21.2701C121.331 21.5964 121.909 21.5964 121.89 21.2317Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M125.744 18.0063C125.513 18.3519 125.397 18.6782 125.012 18.8894C124.646 19.0814 124.222 19.2157 123.817 19.3501C123.624 19.4077 123.566 19.5997 123.643 19.7725C123.759 20.022 124.01 20.0412 124.26 20.0604C124.684 20.118 125.147 20.1372 125.551 19.9836C126.129 19.7917 126.553 19.3117 126.573 18.6782C126.573 18.4287 126.264 18.3135 126.072 18.467C125.667 18.851 125.204 19.139 124.703 19.3501C124.8 19.5229 124.896 19.6765 124.992 19.8492C125.493 19.6189 125.937 19.3309 126.322 18.947C126.592 18.6782 126.187 18.2751 125.917 18.5438C125.551 18.8894 125.166 19.1581 124.703 19.3693C124.356 19.5229 124.665 20.0028 124.992 19.8684C125.551 19.6189 126.033 19.2925 126.476 18.8894C126.303 18.8126 126.149 18.755 125.975 18.6782C125.956 19.0814 125.648 19.3309 125.281 19.4461C125.185 19.4653 124.164 19.5997 124.106 19.4653C124.048 19.5997 123.99 19.7533 123.932 19.8876C124.414 19.7149 124.935 19.5805 125.378 19.3117C125.783 19.0622 125.937 18.659 126.187 18.2943C126.457 17.9871 125.956 17.6992 125.744 18.0063Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M135.225 12.9196C134.57 12.8812 134.05 13.5147 134.262 14.1483C134.358 14.4362 134.686 14.7626 134.975 14.4938C135.091 14.3786 135.129 14.1866 135.187 14.0523C135.264 13.8795 135.322 13.6875 135.399 13.5147C135.534 13.1692 134.975 13.0156 134.84 13.3612C134.782 13.5147 134.724 13.6683 134.667 13.8219C134.647 13.8603 134.57 14.0139 134.57 14.0523C134.801 14.1291 134.898 14.1099 134.821 14.0139C134.801 13.9947 134.801 13.9563 134.801 13.9371C134.744 13.6683 134.975 13.4955 135.225 13.5147C135.592 13.5147 135.592 12.9388 135.225 12.9196Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M132.239 15.9899C132.22 15.9131 132.22 15.8171 132.259 15.7595C132.316 15.7019 132.374 15.7019 132.451 15.6827C132.47 15.6827 132.49 15.7019 132.509 15.7019C132.47 15.6443 132.49 15.6059 132.548 15.5483C132.528 15.5483 132.49 15.5675 132.47 15.5675C132.336 15.6059 132.181 15.6443 132.047 15.6827C131.68 15.7787 131.835 16.3354 132.201 16.2394C132.47 16.1626 132.856 16.1434 133.01 15.8747C133.184 15.5675 132.952 15.2412 132.663 15.1452C132.047 14.9532 131.507 15.5675 131.68 16.1626C131.796 16.489 132.355 16.3546 132.239 15.9899Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M133.029 13.2267C133.048 13.2459 133.048 13.2843 133.048 13.3035C133.048 13.2651 133.068 13.2651 133.048 13.2843C133.068 13.2651 133.068 13.2459 133.087 13.2267C133.068 13.2459 133.087 13.2459 133.106 13.2075C133.125 13.1883 133.145 13.1499 133.164 13.1691C133.087 13.2267 133.01 13.1883 132.933 13.0539C132.933 13.0155 132.933 13.0155 132.933 13.0347C132.933 13.0539 132.933 13.0539 132.933 13.0347C132.933 13.0539 132.933 13.0731 132.913 13.0923C132.913 13.1115 132.894 13.1307 132.894 13.1499C132.913 13.1307 132.913 13.1307 132.894 13.1499C132.875 13.1691 132.875 13.1883 132.894 13.1499C132.856 13.1883 132.875 13.1691 132.933 13.1307C133.048 13.0923 133.145 13.2267 133.106 13.3419C133.145 13.1883 133.068 13.0347 132.913 12.9963C132.759 12.9579 132.586 13.0539 132.567 13.1883C132.489 13.5146 132.817 13.7642 133.125 13.6682C133.376 13.5914 133.53 13.2459 133.53 12.9963C133.53 12.8235 133.414 12.67 133.241 12.6124C133.087 12.574 132.933 12.6124 132.817 12.7084C132.567 12.9003 132.412 13.2075 132.567 13.4954C132.644 13.6298 132.836 13.6682 132.971 13.5914C133.068 13.5338 133.087 13.3611 133.029 13.2267Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M129.792 16.2792C129.83 16.2792 129.85 16.2984 129.888 16.2984C129.927 16.3368 129.965 16.3752 129.985 16.3944C129.946 16.356 130.004 16.4712 130.004 16.4712C130.004 16.4328 129.985 16.4904 129.985 16.5096C129.985 16.548 129.985 16.5096 130.004 16.4904C129.985 16.5096 130.023 16.452 130.004 16.4904C130.023 16.4712 130.042 16.4328 130.023 16.4712C130.023 16.4712 130.042 16.4712 130.042 16.452H130.023C130.023 16.4328 130.062 16.452 130.023 16.452H130.004C130.023 16.452 130.042 16.452 130.023 16.452C129.985 16.4328 129.965 16.4136 129.965 16.3752C129.965 16.356 129.965 16.3368 129.965 16.3176C129.946 16.3368 129.965 16.356 129.965 16.3176C130.004 16.3176 129.965 16.3176 129.946 16.3176C129.85 16.3368 129.965 16.3176 129.908 16.3176C129.888 16.3176 129.85 16.3176 129.83 16.3176C129.676 16.3176 129.541 16.452 129.541 16.6056C129.541 16.7592 129.676 16.8935 129.83 16.8935C130.1 16.8935 130.389 16.7976 130.486 16.548C130.601 16.2792 130.447 15.9721 130.158 15.9145C129.888 15.8569 129.638 16.0105 129.503 16.2408C129.349 16.4712 129.445 16.8935 129.792 16.8743C129.946 16.8743 130.081 16.74 130.081 16.5864C130.081 16.4136 129.946 16.26 129.792 16.2792Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.834 15.8003C113.815 16.4722 114.374 17.0482 115.029 17.0865C115.395 17.1057 115.395 16.5298 115.029 16.5106C114.663 16.4914 114.393 16.1651 114.413 15.8003C114.432 15.4164 113.854 15.4356 113.834 15.8003Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.128 16.4141C116.09 16.3373 116.186 16.2029 116.263 16.2029C116.34 16.2029 116.417 16.2797 116.437 16.3373C116.456 16.3565 116.456 16.3949 116.456 16.4141C116.456 16.4333 116.456 16.4525 116.456 16.4717C116.437 16.4909 116.456 16.4909 116.475 16.4717C116.494 16.4717 116.494 16.4717 116.514 16.4525C116.494 16.4333 116.456 16.4333 116.437 16.4141C116.417 16.3949 116.379 16.3373 116.359 16.3181C116.34 16.2797 116.34 16.2989 116.34 16.3373C116.167 16.3181 116.128 16.3373 116.205 16.3949C116.225 16.4333 116.263 16.4717 116.282 16.5101C116.302 16.5293 116.321 16.5676 116.34 16.606C116.359 16.5676 116.398 16.5101 116.417 16.4717C116.417 16.4717 116.302 16.4333 116.321 16.4333C116.186 16.3757 116.07 16.3181 115.916 16.3373C115.55 16.3565 115.55 16.9324 115.916 16.9132C116.032 16.9132 116.128 16.99 116.244 17.0284C116.359 17.0668 116.494 17.0668 116.61 17.0284C116.918 16.9324 116.976 16.5868 116.841 16.3373C116.726 16.1261 116.533 15.8573 116.263 15.8382C115.993 15.819 115.781 16.0685 115.781 16.3181C115.781 16.8364 116.61 17.3547 116.938 16.8172C117.227 16.3757 116.899 15.7422 116.398 15.6462C115.801 15.531 115.377 16.1837 115.627 16.702C115.801 17.0476 116.302 16.7596 116.128 16.4141Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M118.499 16.0114C118.576 15.9922 118.653 16.0114 118.672 16.0882C118.691 16.2034 118.672 16.1266 118.653 16.165C118.672 16.1266 118.691 16.1458 118.633 16.165C118.595 16.1842 118.672 16.165 118.614 16.165C118.633 16.165 118.653 16.165 118.672 16.165C118.653 16.165 118.653 16.165 118.633 16.165C118.653 16.165 118.672 16.165 118.653 16.165C118.633 16.165 118.633 16.165 118.653 16.165L118.633 16.1458C118.653 16.165 118.653 16.165 118.633 16.1458C118.633 16.1458 118.614 16.1266 118.614 16.1074C118.614 16.1266 118.614 16.1458 118.614 16.1266C118.614 16.1074 118.614 16.1074 118.614 16.1458V16.1266C118.614 16.1458 118.595 16.165 118.614 16.1458C118.614 16.1266 118.614 16.1266 118.614 16.165C118.614 16.165 118.614 16.1458 118.633 16.1458C118.614 16.165 118.614 16.165 118.633 16.1458H118.653C118.633 16.1458 118.614 16.1458 118.633 16.1458C118.653 16.1458 118.672 16.1458 118.691 16.1458C118.672 16.1266 118.653 16.1266 118.672 16.1458C118.691 16.165 118.691 16.1458 118.672 16.1266C118.691 16.165 118.691 16.165 118.691 16.1458C118.691 16.165 118.672 16.2226 118.691 16.165C118.73 16.0114 118.633 15.8579 118.499 15.8195C118.344 15.7811 118.19 15.8771 118.152 16.0114C118.036 16.3954 118.383 16.7793 118.768 16.7025C119.134 16.6449 119.327 16.2034 119.154 15.8963C118.98 15.5891 118.537 15.5315 118.287 15.7619C118.132 15.8963 118.075 16.1074 118.132 16.2994C118.209 16.5298 118.441 16.6257 118.672 16.5874C118.826 16.5682 118.903 16.3762 118.865 16.2418C118.826 16.0498 118.653 15.973 118.499 16.0114Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M119.944 17.4511C119.944 17.4319 119.982 17.4703 119.944 17.4511C119.924 17.4319 119.924 17.4127 119.944 17.3935C119.944 17.3743 119.924 17.3743 119.963 17.3551C120.002 17.3359 120.04 17.3359 120.079 17.3359C120.098 17.3359 120.136 17.3551 120.156 17.3743C120.194 17.3935 120.156 17.4127 120.175 17.3743V17.3359V17.3551C120.136 17.3359 120.117 17.3359 120.079 17.2975C119.982 17.1823 119.828 17.1055 119.674 17.2015C119.558 17.2783 119.481 17.4703 119.578 17.6047C119.809 17.9118 120.271 18.0846 120.599 17.7583C120.927 17.4319 120.715 16.9712 120.329 16.8176C119.982 16.6832 119.539 16.8368 119.423 17.2015C119.308 17.5279 119.481 17.9118 119.828 18.0078C120.156 18.123 120.31 17.5663 119.944 17.4511Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M122.237 18.5421C122.179 18.5421 122.275 18.5613 122.294 18.5613C122.237 18.5421 122.333 18.5996 122.352 18.5996C122.294 18.5613 122.41 18.6764 122.372 18.6188C122.391 18.6572 122.41 18.6764 122.429 18.7148C122.487 18.8492 122.699 18.8876 122.834 18.8108C122.988 18.734 123.007 18.5613 122.93 18.4077C122.815 18.1389 122.545 17.9853 122.256 17.9469C122.102 17.9277 121.967 18.0813 121.967 18.2349C121.967 18.4269 122.082 18.5421 122.237 18.5421Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M124.684 18.0848C124.626 18.0656 124.703 18.1232 124.684 18.0848C124.665 18.0848 124.703 18.1232 124.703 18.1232C124.703 18.1424 124.703 18.1424 124.703 18.1232C124.703 18.1424 124.703 18.1424 124.703 18.1616C124.723 18.1232 124.703 18.1616 124.703 18.1808C124.684 18.2192 124.723 18.1232 124.703 18.1808C124.703 18.1616 124.703 18.1616 124.703 18.1808C124.703 18.2 124.684 18.2 124.665 18.2192C124.646 18.2384 124.626 18.2384 124.607 18.2384C124.588 18.2384 124.588 18.2384 124.569 18.2384C124.588 18.2384 124.607 18.2384 124.569 18.2384C124.53 18.2384 124.588 18.2576 124.569 18.2384C124.549 18.2192 124.53 18.1808 124.549 18.2192C124.549 18.2 124.53 18.1808 124.53 18.1616C124.53 18.1424 124.549 18.0848 124.549 18.104C124.53 18.1232 124.569 18.0848 124.569 18.0848C124.588 18.0656 124.588 18.0656 124.569 18.0848C124.569 18.0848 124.588 18.0848 124.588 18.0656C124.511 18.0656 124.646 18.0848 124.569 18.0656C124.434 18.0081 124.241 18.1232 124.222 18.2576C124.183 18.4112 124.279 18.5648 124.414 18.6032C124.646 18.6992 124.935 18.5648 125.05 18.3344C125.185 18.0656 125.05 17.7777 124.78 17.6625C124.53 17.5473 124.222 17.6817 124.145 17.9505C124.067 18.1616 124.164 18.4496 124.376 18.5456C124.511 18.6032 124.684 18.584 124.78 18.4496C124.858 18.3536 124.819 18.1424 124.684 18.0848Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M117.206 14.1853V14.1661C117.187 14.0702 117.091 13.9934 117.014 13.9742C116.686 13.8782 116.513 14.2045 116.493 14.4733C116.474 14.7613 116.59 15.03 116.84 15.2028C117.303 15.5291 118.035 15.2028 117.958 14.5885C117.939 14.4541 117.862 14.3197 117.707 14.3005C117.572 14.2813 117.438 14.3581 117.399 14.5117L117.36 14.6077C117.36 14.6461 117.399 14.6653 117.495 14.6077C117.476 14.5885 117.476 14.5693 117.457 14.5693C117.38 14.4541 117.322 14.3581 117.283 14.2237C117.168 14.3389 117.052 14.4541 116.937 14.5693C117.014 14.6077 117.091 14.6653 117.149 14.7421C117.399 15.03 117.804 14.6077 117.553 14.3389C117.418 14.1853 117.264 14.0894 117.091 14.0318C116.879 13.955 116.686 14.1853 116.744 14.3773C116.821 14.6653 117.014 15.0684 117.322 15.1452C117.669 15.2412 117.881 14.9532 117.977 14.6653C117.784 14.6461 117.592 14.6077 117.418 14.5885C117.438 14.7037 117.36 14.7997 117.245 14.7421C117.187 14.7229 117.149 14.6845 117.129 14.6269C117.11 14.5885 117.11 14.5693 117.11 14.5309C117.11 14.5117 117.11 14.4925 117.11 14.4925C117.149 14.4157 117.11 14.4157 117.033 14.5117C116.975 14.5117 116.937 14.5117 116.879 14.5117H116.898C116.84 14.4541 116.763 14.3773 116.705 14.3197V14.3389C116.744 14.6845 117.283 14.5309 117.206 14.1853Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.434 13.3791L115.453 13.3599C115.415 13.3791 115.376 13.4175 115.319 13.4367C115.222 13.4751 115.261 13.3791 115.28 13.4751C115.28 13.5135 115.299 13.5327 115.299 13.5711C115.28 13.6671 115.184 13.6671 115.107 13.6671C115.184 13.8399 115.241 13.9934 115.319 14.1662C115.55 13.9358 115.685 13.6095 115.646 13.2831C115.627 13.1296 115.531 12.9952 115.357 12.9952C115.222 12.9952 115.049 13.1296 115.068 13.2831C115.087 13.4751 115.049 13.6287 114.914 13.7631C114.721 13.955 114.875 14.2238 115.126 14.2622C115.531 14.3006 115.916 13.955 115.897 13.5327C115.877 13.1488 115.415 12.6304 115.029 12.9952C114.76 13.2255 115.164 13.6287 115.434 13.3791Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M122.795 16.1247C123.354 16.2975 123.932 16.4703 124.491 16.643C124.433 16.5279 124.356 16.4127 124.298 16.2975C124.202 16.5279 124.086 16.739 123.951 16.931C124.125 16.9502 124.298 16.9694 124.472 17.0078C124.279 16.5471 124.009 16.2015 123.605 15.9135C123.296 15.7024 123.007 16.2015 123.315 16.4127C123.585 16.6046 123.797 16.8542 123.913 17.1614C124.009 17.3917 124.298 17.4493 124.433 17.2382C124.607 16.9886 124.722 16.739 124.838 16.4511C124.896 16.2975 124.78 16.1439 124.645 16.1055C124.086 15.9327 123.508 15.76 122.949 15.5872C122.602 15.4528 122.448 16.0095 122.795 16.1247Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M128.075 18.1231C130.985 19.083 134.107 20.6187 134.84 23.8823C134.917 24.247 135.476 24.0934 135.399 23.7287C134.628 20.2732 131.332 18.603 128.23 17.5664C127.883 17.4512 127.729 18.0079 128.075 18.1231Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M129.541 20.1767C129.483 20.1191 129.541 19.9847 129.598 19.9463C129.714 19.8888 129.887 19.9655 129.945 20.0999C129.984 20.1959 129.945 20.1959 129.907 20.2535C129.907 20.2727 129.887 20.2535 129.868 20.2535C129.945 20.2535 129.849 20.3111 129.887 20.2343C129.868 20.2535 129.83 20.3495 129.81 20.2727C129.791 20.1959 129.887 20.2727 129.849 20.1959C129.752 20.0807 129.541 20.0999 129.444 20.1959C129.329 20.3111 129.348 20.4839 129.444 20.5991C129.618 20.8102 129.945 20.8486 130.157 20.7142C130.388 20.5607 130.466 20.2151 130.311 19.9847C130.157 19.7544 129.83 19.6776 129.579 19.812C129.348 19.9463 129.271 20.2343 129.367 20.4647C129.598 21.0598 130.446 20.8678 130.543 20.2919C130.639 19.716 130.061 19.2361 129.521 19.3704C128.905 19.524 128.789 20.2919 129.271 20.6758C129.386 20.7718 129.598 20.695 129.675 20.5799C129.733 20.4263 129.656 20.2727 129.541 20.1767Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M132.894 20.3293C132.836 20.2909 132.778 20.2717 132.721 20.2333C132.566 20.1374 132.354 20.2333 132.297 20.4061C132.104 21.0396 132.489 21.8075 133.164 21.9419C133.511 22.0187 133.896 21.7883 133.838 21.4044C133.819 21.2124 133.665 21.1164 133.549 20.982C133.376 20.8285 133.202 20.6557 133.01 20.5021C132.74 20.2525 132.335 20.6557 132.605 20.9052C132.759 21.0396 132.913 21.1932 133.068 21.3276C133.106 21.366 133.164 21.4044 133.202 21.4428C133.28 21.5388 133.299 21.5196 133.28 21.366C133.26 21.3468 133.125 21.2892 133.087 21.27C132.856 21.0972 132.778 20.8093 132.856 20.5405C132.721 20.5981 132.566 20.6557 132.432 20.7133C132.489 20.7517 132.547 20.7709 132.605 20.8093C132.933 21.0204 133.222 20.5213 132.894 20.3293Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M110.866 49.0476C111.406 50.8329 112.234 52.4839 113.314 54.0197C113.41 54.154 113.564 54.1924 113.718 54.1156C114.316 53.8469 114.933 53.5781 115.53 53.2902C115.742 53.1942 115.703 52.887 115.53 52.791C114.123 51.9656 112.697 51.0825 111.945 49.5851C111.772 49.6811 111.618 49.7771 111.444 49.8731C112.196 51.0825 112.948 52.2727 113.718 53.4629C113.873 53.3478 114.027 53.2326 114.181 53.1174C113.622 52.5991 113.198 52.0231 112.87 51.3128C112.697 51.4088 112.543 51.5048 112.369 51.6008C112.793 52.4263 113.237 53.4053 114.297 53.2326C114.489 53.1942 114.547 52.9638 114.47 52.8102C114.297 52.5223 114.104 52.2535 113.892 52.0039C113.757 52.1383 113.622 52.2727 113.487 52.4071C113.776 52.6567 114.085 52.9062 114.374 53.1558C114.47 53.0022 114.566 52.8294 114.663 52.6758C114.451 52.5031 114.258 52.3303 114.046 52.1575C113.911 51.812 113.352 51.9656 113.487 52.3111C113.68 52.8102 113.988 53.0982 114.509 53.2326C114.778 53.2902 115.029 52.9446 114.798 52.7526C114.509 52.5031 114.2 52.2535 113.911 52.0039C113.622 51.7544 113.256 52.1191 113.506 52.4071C113.699 52.6183 113.873 52.8486 113.988 53.0982C114.046 52.9638 114.104 52.8102 114.162 52.6758C113.834 52.7334 113.391 52.1767 113.237 51.9464C113.102 51.7352 113.005 51.524 112.89 51.3128C112.716 50.9865 112.234 51.2745 112.389 51.6008C112.736 52.3303 113.198 52.9638 113.776 53.5205C114.007 53.7317 114.412 53.4629 114.239 53.175C113.468 51.9847 112.716 50.7945 111.965 49.5851C111.772 49.2587 111.309 49.5467 111.464 49.8731C112.254 51.4664 113.757 52.4071 115.26 53.2902C115.26 53.1174 115.26 52.9638 115.26 52.791C114.663 53.0598 114.046 53.3286 113.449 53.6165C113.584 53.6549 113.718 53.6933 113.853 53.7125C112.793 52.2343 112.003 50.6217 111.464 48.894C111.309 48.5484 110.751 48.702 110.866 49.0476Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M113.295 53.3111C113.199 53.5799 113.449 53.9254 113.738 53.887C113.95 53.8679 114.104 53.6567 113.989 53.4455C113.873 53.2535 113.757 53.0616 113.623 52.8696C113.43 52.5624 112.929 52.8504 113.121 53.1576C113.237 53.3495 113.353 53.5415 113.488 53.7335C113.565 53.5799 113.661 53.4455 113.738 53.2919C113.661 53.2919 113.796 53.2919 113.815 53.3495C113.835 53.3687 113.854 53.4263 113.835 53.4455C113.892 53.2919 113.777 53.1384 113.642 53.1C113.507 53.0616 113.353 53.1576 113.295 53.3111Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M192.181 37.4352C195.11 31.2921 198.541 25.3985 202.433 19.8121C206.114 14.5329 210.161 9.04249 215.211 4.95348C218.236 2.51544 222.283 0.0198003 226.33 0.691703C226.6 0.730097 226.716 0.326956 226.446 0.269364C223.15 -0.268158 219.951 1.19083 217.253 2.93778C214.517 4.70392 212.166 6.98839 210.026 9.40724C205.363 14.6481 201.277 20.4264 197.654 26.416C195.534 29.9291 193.607 33.5381 191.834 37.224C191.68 37.4736 192.046 37.6847 192.181 37.4352Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M226.234 0.767909C231.167 1.90054 230.589 8.33161 230.3 12.1902C229.568 21.4625 227.139 30.562 223.42 39.0855C221.05 44.5375 218.159 49.7592 214.902 54.7313C214.748 54.9616 215.133 55.1728 215.268 54.9424C220.78 46.5532 225.328 37.3386 227.987 27.644C229.336 22.7679 230.242 17.6231 230.685 12.5934C230.936 9.71381 231.129 6.54627 230.165 3.76267C229.529 1.91974 228.296 0.806303 226.33 0.364768C226.08 0.287979 225.964 0.710317 226.234 0.767909Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M209.274 32.6346C209.12 29.5631 209.987 26.5107 211.76 23.9767C212.685 22.6713 213.842 21.5002 215.171 20.598C216.636 19.5997 219.372 18.755 220.086 21.1163C220.509 22.5561 219.816 24.2262 219.392 25.5892C218.91 27.0866 218.351 28.5648 217.58 29.9278C216.79 31.3292 215.749 32.6538 214.4 33.5753C212.859 34.6503 209.679 35.1687 209.332 32.5578C209.293 32.2891 208.869 32.2891 208.889 32.5578C209.043 33.7289 209.891 34.5927 211.047 34.8615C212.415 35.1879 213.822 34.5543 214.882 33.7481C217.31 31.9243 218.659 29.0639 219.604 26.2612C220.278 24.2646 221.82 20.3484 218.929 19.3118C216.193 18.3135 213.225 21.3083 211.76 23.228C209.717 25.8964 208.657 29.2559 208.831 32.6154C208.85 32.9226 209.293 32.9226 209.274 32.6346Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M191.795 37.9538C190.87 43.3866 193.029 49.0689 197.384 52.4668C197.596 52.6396 197.904 52.3325 197.692 52.1597C193.472 48.8578 191.294 43.3482 192.2 38.0689C192.258 37.8002 191.853 37.685 191.795 37.9538Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M182.564 46.7644C183.855 43.3089 185.243 39.7574 188.056 37.2234C188.268 37.0314 187.96 36.7243 187.748 36.9162C184.896 39.5079 183.47 43.1169 182.159 46.6492C182.063 46.918 182.468 47.0332 182.564 46.7644Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M187.806 37.7618C189.039 37.781 190.272 37.8962 191.487 38.1074C191.756 38.165 191.872 37.7427 191.602 37.6851C190.35 37.4547 189.078 37.3395 187.806 37.3203C187.517 37.3203 187.517 37.7618 187.806 37.7618Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M188.192 37.5508C190.948 34.7672 193.704 31.9836 196.44 29.2C196.633 29.008 196.325 28.7008 196.132 28.8928C193.376 31.6764 190.62 34.46 187.884 37.2436C187.691 37.4548 187.98 37.7619 188.192 37.5508Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M188.596 37.5519C190.89 35.2866 193.125 32.9829 195.322 30.6409C195.207 30.5449 195.091 30.4681 194.975 30.3721C193.684 32.7334 192.451 35.0946 191.237 37.4943C191.102 37.7438 191.487 37.955 191.603 37.7054C192.817 35.3058 194.07 32.9445 195.341 30.5833C195.457 30.3721 195.168 30.1417 194.995 30.3145C192.798 32.6566 190.562 34.9602 188.269 37.2255C188.076 37.4367 188.384 37.7438 188.596 37.5519Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M188.346 37.6667C189.502 37.494 190.62 37.59 191.718 37.9163C191.834 37.9547 191.949 37.8779 191.988 37.7627C192.238 37.1676 192.47 36.5917 192.72 35.9966C192.817 35.747 192.412 35.6318 192.296 35.8814C192.046 36.4765 191.814 37.0524 191.564 37.6476C191.66 37.59 191.737 37.5516 191.834 37.494C190.639 37.1484 189.463 37.0716 188.23 37.2444C187.941 37.2828 188.056 37.7051 188.346 37.6667Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M189.039 37.4369C190.812 35.69 192.527 33.9047 194.184 32.0617C194.377 31.8506 194.069 31.5434 193.876 31.7546C192.219 33.5975 190.503 35.3828 188.73 37.1298C188.518 37.3218 188.827 37.6289 189.039 37.4369Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M189.502 37.6278C191.005 35.9 192.489 34.1723 193.992 32.4445C194.166 32.2334 193.877 31.9262 193.684 32.1374C192.181 33.8651 190.697 35.5929 189.194 37.3206C189.02 37.5318 189.329 37.839 189.502 37.6278Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M190.388 37.3776C191.448 36.0914 192.373 34.6516 193.491 33.4038C193.548 33.327 193.587 33.231 193.529 33.135C193.51 33.1158 193.51 33.0966 193.491 33.0774C193.433 33.0007 193.336 32.9623 193.24 32.9815C193.221 32.9815 193.202 33.0007 193.163 33.0007C193.028 33.0198 192.951 33.2118 193.028 33.327L193.047 33.3462C193.202 33.5766 193.587 33.3654 193.413 33.135L193.394 33.1158C193.356 33.231 193.317 33.327 193.259 33.4422C193.279 33.4422 193.298 33.423 193.336 33.423C193.259 33.3846 193.182 33.3654 193.086 33.327C193.105 33.3462 193.105 33.3654 193.124 33.3846C193.144 33.2886 193.144 33.2118 193.163 33.1158C192.064 34.3637 191.139 35.8034 190.06 37.0897C189.906 37.3008 190.195 37.608 190.388 37.3776Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M189.984 37.4151C191.082 36.0713 192.181 34.7275 193.298 33.3837C193.183 33.2877 193.067 33.2109 192.952 33.1149C192.316 34.5931 191.506 35.9561 190.523 37.2231C190.388 37.3959 190.504 37.6262 190.735 37.5878C191.448 37.4727 191.699 36.5896 191.969 36.0329C192.393 35.169 192.797 34.2859 193.164 33.3837C193.26 33.1533 192.894 33.0189 192.759 33.2109C191.911 34.4587 191.063 35.7257 190.196 36.9735C190.042 37.2039 190.408 37.4151 190.562 37.1847C191.41 35.9369 192.277 34.6891 193.125 33.4221C192.99 33.3645 192.855 33.3069 192.72 33.2493C192.431 33.9212 192.142 34.5931 191.834 35.2458C191.622 35.7065 191.159 37.0503 190.6 37.1463C190.678 37.2615 190.735 37.3959 190.812 37.5111C191.834 36.2248 192.663 34.8235 193.318 33.3261C193.414 33.1149 193.144 32.8461 192.971 33.0573C191.872 34.4011 190.774 35.7449 189.656 37.0887C189.502 37.3383 189.81 37.6454 189.984 37.4151Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M193.877 31.9623C193.087 33.2485 192.451 34.6115 191.95 36.0321C191.853 36.3009 192.277 36.416 192.374 36.1473C192.855 34.7651 193.491 33.4405 194.243 32.1927C194.397 31.9431 194.031 31.7319 193.877 31.9623Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M193.433 33.6335C194.281 37.7034 195.9 41.7348 199.157 44.48C199.369 44.6527 199.677 44.3456 199.465 44.1728C196.266 41.4852 194.686 37.5306 193.857 33.5184C193.799 33.2304 193.375 33.3456 193.433 33.6335Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M195.399 35.7473C196.691 38.5309 198.444 41.0266 200.641 43.1575C200.834 43.3494 201.142 43.0423 200.95 42.8503C198.791 40.7386 197.057 38.2622 195.785 35.517C195.669 35.2866 195.284 35.4978 195.399 35.7473Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M182.295 46.6507C180.734 41.9474 180.83 36.1498 183.432 31.8112C184.742 29.6228 187.305 28.5285 189.618 27.6646C192.104 26.7432 194.744 26.3016 197.346 26.9159C197.615 26.9735 197.731 26.5704 197.461 26.4936C194.84 25.8793 192.181 26.2824 189.656 27.1847C187.402 27.991 184.838 29.0276 183.412 31.0433C181.928 33.1166 181.254 35.8618 180.965 38.3575C180.656 41.1987 180.984 44.0591 181.871 46.7467C181.967 47.0346 182.391 46.9194 182.295 46.6507Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M200.987 45.0181C198.308 51.7755 195.63 58.5522 192.951 65.3096C192.893 65.4632 193.066 65.6167 193.221 65.5783C194.338 65.2136 195.186 64.4649 195.976 63.6202C196.979 62.5452 197.961 61.4509 198.925 60.3375C200.833 58.1106 202.664 55.8262 204.417 53.4649C204.591 53.2345 204.205 53.0234 204.051 53.2537C202.394 55.4806 200.659 57.6499 198.848 59.7616C198 60.7598 197.133 61.7389 196.246 62.6988C195.341 63.697 194.435 64.7145 193.105 65.156C193.201 65.252 193.278 65.3288 193.375 65.4248C196.054 58.6673 198.732 51.8907 201.411 45.1333C201.507 44.8837 201.083 44.7686 200.987 45.0181Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M201.162 45.3826C201.489 44.2116 203.127 43.7893 204.226 43.8852C206.037 44.0388 206.307 46.0353 206.037 47.4559C205.575 49.798 204.553 52.0441 203.339 54.0982C203.204 54.3477 203.571 54.5589 203.706 54.3093C204.611 52.7927 205.363 51.1802 205.902 49.4908C206.365 48.0702 206.943 46.3617 206.269 44.9027C205.69 43.6741 204.573 43.3093 203.282 43.5013C202.202 43.6549 201.046 44.1156 200.718 45.2482C200.68 45.5362 201.085 45.6514 201.162 45.3826Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M202.722 55.2879C203.281 55.9406 204.457 56.0942 205.247 56.2286C206.249 56.4013 207.27 56.4589 208.273 56.4013C210.566 56.2861 212.821 55.691 215.018 55.0959C215.287 55.0191 215.172 54.616 214.902 54.6736C212.956 55.1919 210.99 55.7294 208.966 55.9214C208.099 55.9982 207.213 56.0174 206.326 55.9406C205.44 55.8638 203.647 55.7102 203.011 54.9807C202.857 54.7696 202.549 55.0767 202.722 55.2879Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M207.02 48.6082C206.924 49.1265 207.463 49.2609 207.868 49.4145C208.986 49.856 210.161 50.2016 211.337 50.4319C212.378 50.6431 213.418 50.7583 214.478 50.7967C215.423 50.8351 216.617 50.9695 217.485 50.5279C217.735 50.3935 217.504 50.0288 217.273 50.1632C216.521 50.5663 215.326 50.4127 214.497 50.3743C213.65 50.336 212.821 50.2592 211.973 50.1056C211.53 50.0288 207.367 49.1649 207.444 48.7234C207.483 48.4354 207.059 48.3202 207.02 48.6082Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M210.913 48.3758C213.264 48.8941 215.635 49.2013 218.025 49.2781C218.294 49.2973 218.294 48.8557 218.025 48.8365C215.654 48.7597 213.322 48.4526 211.029 47.9343C210.759 47.9151 210.644 48.3182 210.913 48.3758Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M215.885 54.1173C215.885 54.0981 215.904 54.0789 215.904 54.0789C215.942 54.0021 215.942 53.887 215.865 53.8102C215.75 53.7142 215.692 53.695 215.538 53.7334C215.441 53.7526 215.384 53.8486 215.384 53.9446C215.364 54.1365 215.422 54.1557 215.499 54.3285C215.731 54.7892 216.154 55.2116 216.424 55.6339C216.925 56.421 217.349 57.2273 217.715 58.0912C217.831 58.3407 218.197 58.1295 218.082 57.88C217.773 57.1505 217.426 56.4594 217.022 55.7875C216.829 55.4803 216.636 55.154 216.424 54.866C216.328 54.7316 216.232 54.5397 216.097 54.4245C216.058 54.3861 216.039 54.3285 216 54.2901C215.904 54.1557 215.769 54.1173 215.576 54.1557C215.557 54.0597 215.557 53.983 215.538 53.887C215.538 53.9062 215.519 53.9254 215.519 53.9254C215.403 54.1557 215.769 54.3669 215.885 54.1173Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M191.006 37.2632C190.62 37.3976 190.852 37.9543 191.237 37.8199C191.43 37.7431 191.565 37.4744 191.68 37.3016C191.854 37.052 192.027 36.8025 192.201 36.5529C192.355 36.3225 191.989 36.1114 191.834 36.3417C191.699 36.5337 191.565 36.7065 191.449 36.8985C191.391 36.9944 191.333 37.0712 191.256 37.1672C191.218 37.2248 191.179 37.2632 191.16 37.3208C191.064 37.4168 191.083 37.5128 191.237 37.6087C191.198 37.6471 191.16 37.6663 191.102 37.7047C191.121 37.7047 191.121 37.7047 191.141 37.6855C191.391 37.5896 191.275 37.1672 191.006 37.2632Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M217.793 57.9394C216.945 61.414 215.461 64.6584 213.418 67.5956C213.264 67.8259 213.63 68.0371 213.784 67.8067C215.846 64.8504 217.349 61.5484 218.197 58.0353C218.274 57.7858 217.85 57.6706 217.793 57.9394Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M220.606 45.2288C222.283 47.0141 223.247 49.2986 224.056 51.5831C224.499 52.8309 224.885 54.1171 224.885 55.4417C224.885 56.8047 224.422 58.0909 223.825 59.3003C222.861 61.2009 221.512 62.9094 219.951 64.3492C219.122 65.1171 218.217 65.789 217.253 66.4033C216.829 66.6721 216.405 66.9216 215.943 67.152C215.673 67.2864 215.403 67.4208 215.133 67.5359C214.921 67.6319 213.9 67.8815 213.881 67.9775C213.977 67.7279 213.572 67.6127 213.457 67.8623C213.437 67.9007 213.418 67.9391 213.399 67.9775C213.38 68.0543 213.399 68.1311 213.457 68.1887C214.093 68.7646 215.287 67.9583 215.885 67.6511C216.983 67.1136 218.005 66.4609 218.968 65.7122C220.992 64.1572 222.707 62.1799 223.94 59.9339C225.347 57.3806 225.578 54.9042 224.673 52.1206C223.825 49.5482 222.746 46.899 220.876 44.9024C220.722 44.7297 220.414 45.0368 220.606 45.2288Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M204.187 16.6822C205.247 20.3297 207.193 23.6124 209.872 26.3192C210.065 26.5112 210.373 26.204 210.181 26.0121C207.56 23.3628 205.652 20.1377 204.611 16.567C204.534 16.2983 204.11 16.4135 204.187 16.6822Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M218.024 29.8501C221.165 30.5412 224.364 30.1573 227.236 28.7367C227.486 28.6215 227.274 28.2375 227.024 28.3719C224.248 29.7349 221.165 30.0997 218.139 29.447C217.87 29.3702 217.754 29.7925 218.024 29.8501Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M203.666 19.8887C203.666 19.8503 203.666 19.8695 203.666 19.8887C203.647 19.8695 203.685 19.8695 203.666 19.8887C203.666 19.8695 203.647 19.8887 203.666 19.8887C203.647 19.8887 203.666 19.8695 203.685 19.8695C203.685 19.8695 203.685 19.8695 203.705 19.8695C203.685 19.8503 203.724 19.8695 203.705 19.8695C203.743 19.8887 203.666 19.8503 203.724 19.8887C203.685 19.8503 203.666 19.8119 203.628 19.7543C203.628 19.7159 203.647 19.6967 203.666 19.6967C203.685 19.6967 203.705 19.6967 203.724 19.7159C203.743 19.7351 203.724 19.7927 203.743 19.7543C203.82 19.4855 203.416 19.3704 203.319 19.6391C203.242 19.8695 203.416 20.119 203.647 20.1382C203.878 20.1574 204.071 19.9655 204.052 19.7351C204.032 19.4855 203.763 19.4087 203.57 19.4855C203.377 19.5431 203.242 19.7159 203.242 19.9271C203.242 20.0423 203.339 20.1382 203.454 20.1382C203.57 20.0998 203.685 20.0039 203.666 19.8887Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M204.649 22.518C204.668 22.518 204.687 22.5372 204.707 22.5372C204.687 22.518 204.687 22.518 204.707 22.5372C204.707 22.5372 204.707 22.518 204.687 22.518C204.707 22.5564 204.687 22.4988 204.687 22.4988C204.707 22.5564 204.687 22.4604 204.687 22.518C204.687 22.4988 204.687 22.4988 204.687 22.4988C204.687 22.518 204.687 22.518 204.687 22.4988C204.668 22.4988 204.649 22.5372 204.649 22.518C204.63 22.5372 204.63 22.5372 204.649 22.518C204.649 22.5372 204.649 22.5372 204.649 22.518C204.707 22.5564 204.61 22.4988 204.687 22.5372C204.668 22.518 204.726 22.5564 204.687 22.5372C204.668 22.5564 204.726 22.5564 204.687 22.5372C204.687 22.5372 204.687 22.5372 204.687 22.518C204.687 22.5372 204.687 22.5372 204.687 22.518C204.687 22.518 204.687 22.518 204.707 22.4988C204.687 22.518 204.687 22.518 204.707 22.4988C204.707 22.4988 204.649 22.5372 204.687 22.518C204.649 22.5372 204.687 22.518 204.668 22.518C204.649 22.518 204.649 22.518 204.63 22.518C204.649 22.518 204.649 22.518 204.63 22.518C204.61 22.518 204.61 22.518 204.63 22.518C204.61 22.4988 204.61 22.4988 204.63 22.518C204.418 22.3261 204.109 22.6332 204.321 22.8252C204.514 22.998 204.822 22.998 204.996 22.806C205.208 22.5948 205.111 22.2493 204.88 22.1149C204.649 21.9805 204.321 22.0957 204.263 22.3645C204.206 22.6332 204.379 22.8828 204.649 22.902C204.764 22.9212 204.861 22.7868 204.861 22.6908C204.861 22.614 204.764 22.5372 204.649 22.518Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M206.345 25.5134C206.364 25.5134 206.384 25.5518 206.364 25.5326C206.364 25.5134 206.364 25.571 206.364 25.5326C206.364 25.571 206.345 25.6094 206.287 25.6094H206.249C206.249 25.6094 206.287 25.6286 206.268 25.6286C206.249 25.667 206.307 25.6286 206.268 25.6286L206.287 25.6094C206.268 25.6286 206.268 25.6286 206.268 25.6094C206.287 25.6094 206.191 25.6286 206.249 25.6094C206.229 25.6094 206.191 25.5902 206.229 25.6094C206.21 25.6094 206.21 25.6094 206.21 25.6094C206.229 25.6094 206.21 25.6094 206.191 25.6094C206.21 25.6478 206.21 25.6094 206.21 25.6094C206.21 25.5902 206.21 25.6094 206.21 25.5902C206.21 25.6286 206.229 25.571 206.229 25.5518C206.21 25.5902 206.249 25.5326 206.229 25.5518C206.249 25.5326 206.229 25.5326 206.287 25.5134C206.384 25.4558 206.422 25.3214 206.364 25.2254C206.307 25.1102 206.172 25.091 206.075 25.1486C205.786 25.283 205.69 25.7054 205.921 25.9357C206.133 26.1469 206.519 26.0893 206.653 25.8397C206.808 25.5326 206.499 25.1486 206.152 25.2254C205.979 25.2638 205.902 25.4366 205.902 25.6094C205.921 25.7821 206.017 25.9165 206.191 25.9549C206.499 26.0125 206.615 25.5902 206.345 25.5134Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M218.332 31.6759C218.352 31.7334 218.313 31.7718 218.275 31.8102C218.236 31.8294 218.313 31.791 218.275 31.8102C218.236 31.8102 218.255 31.8102 218.275 31.8102C218.294 31.8102 218.313 31.8102 218.275 31.8102H218.294C218.313 31.8102 218.313 31.8102 218.294 31.8102C218.275 31.8102 218.275 31.8102 218.294 31.8102L218.275 31.791C218.294 31.8294 218.255 31.7526 218.255 31.7526V31.7334C218.255 31.7526 218.255 31.7526 218.255 31.7526C218.236 31.7718 218.275 31.7334 218.255 31.7526C218.275 31.7334 218.236 31.7718 218.217 31.7718C218.236 31.7526 218.178 31.791 218.178 31.791H218.159C218.178 31.791 218.178 31.791 218.159 31.791C218.101 31.791 218.101 31.791 218.063 31.791C218.12 31.8486 218.159 31.887 218.217 31.9446C218.198 31.8678 218.217 31.7718 218.275 31.7526C218.39 31.7142 218.467 31.5991 218.429 31.4839C218.39 31.3687 218.275 31.2919 218.159 31.3303C217.87 31.4263 217.677 31.7526 217.793 32.0598C217.87 32.2518 218.082 32.2518 218.255 32.2134C218.39 32.1942 218.525 32.1174 218.602 32.0022C218.776 31.7718 218.679 31.4647 218.39 31.3879C218.14 31.3303 217.851 31.5031 217.928 31.791C217.966 32.079 218.39 31.9638 218.332 31.6759Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M221.665 32.176C221.646 32.1568 221.646 32.1568 221.665 32.176C221.646 32.1952 221.646 32.2144 221.665 32.176C221.646 32.1568 221.646 32.1568 221.665 32.176C221.646 32.1952 221.646 32.176 221.665 32.176C221.646 32.176 221.646 32.176 221.665 32.176C221.665 32.1568 221.665 32.1568 221.665 32.1376C221.685 32.0992 221.646 32.1568 221.685 32.1184C221.665 32.1184 221.665 32.1184 221.685 32.1184C221.665 32.1184 221.665 32.1184 221.646 32.1184C221.627 32.1184 221.627 32.1184 221.646 32.1184C221.646 32.1184 221.627 32.1184 221.627 32.0992C221.608 32.08 221.608 32.0992 221.627 32.0992C221.627 32.0992 221.627 32.08 221.608 32.08C221.627 32.0992 221.627 32.0992 221.608 32.08V32.0992C221.588 32.08 221.608 32.08 221.608 32.1184C221.627 32.0608 221.608 32.1376 221.608 32.1376C221.588 32.1952 221.627 32.0992 221.608 32.1568C221.588 32.1952 221.627 32.1568 221.588 32.176C221.627 32.1568 221.569 32.176 221.608 32.176C221.627 32.176 221.627 32.176 221.608 32.176C221.627 32.1568 221.646 32.1568 221.665 32.176C221.55 32.1376 221.434 32.1952 221.396 32.3104C221.376 32.4064 221.434 32.56 221.55 32.5791C221.781 32.6175 221.974 32.5024 222.051 32.272C222.109 32.08 222.07 31.8497 221.897 31.7537C221.473 31.5041 220.991 32.176 221.376 32.4832C221.473 32.56 221.588 32.5791 221.685 32.4832C221.743 32.4064 221.743 32.2528 221.665 32.176Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M224.807 31.6583C224.769 31.6775 224.846 31.6583 224.884 31.6775C224.865 31.6583 224.865 31.6583 224.884 31.6775C224.884 31.6967 224.884 31.6967 224.884 31.6775C224.884 31.7159 224.865 31.7159 224.846 31.7543C224.807 31.8119 224.884 31.7159 224.904 31.7159L224.884 31.7351C224.904 31.7351 224.904 31.7351 224.884 31.7351C224.904 31.7351 224.904 31.7351 224.923 31.7351C224.904 31.7351 224.904 31.7351 224.923 31.7351C224.961 31.7351 224.904 31.7159 224.942 31.7351C224.961 31.7543 224.961 31.7543 224.942 31.7351C224.961 31.7351 224.961 31.7543 224.981 31.7543C224.961 31.7351 224.961 31.7351 224.981 31.7543C224.981 31.7351 224.981 31.7351 224.981 31.7543C224.981 31.7543 224.981 31.6967 224.981 31.7351C224.923 31.7543 225.019 31.6967 224.981 31.7351C224.961 31.7351 224.942 31.7543 224.923 31.7543C224.846 31.7543 224.981 31.7351 224.923 31.7543C224.904 31.7543 224.904 31.7543 224.884 31.7351C224.904 31.7351 224.904 31.7543 224.884 31.7351C224.749 31.4855 224.383 31.7159 224.518 31.9462C224.653 32.1958 225 32.2342 225.212 32.0806C225.462 31.9078 225.482 31.5623 225.25 31.3895C225.135 31.2935 225 31.2551 224.865 31.2743C224.788 31.2743 224.73 31.2935 224.672 31.3319C224.672 31.3319 224.576 31.4087 224.614 31.3895C224.576 31.4279 224.557 31.4471 224.518 31.4855C224.345 31.7543 224.614 32.1766 224.942 32.0614C225.058 32.023 225.135 31.9078 225.096 31.7927C225.038 31.6967 224.923 31.6199 224.807 31.6583Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M209.679 28.7593C212.839 25.9374 216.019 23.1154 219.18 20.2742C219.392 20.0822 219.083 19.7751 218.871 19.967C215.711 22.789 212.531 25.611 209.371 28.4522C209.178 28.6442 209.486 28.9321 209.679 28.7593Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M209.352 31.5595C211.299 29.6973 213.245 27.816 215.192 25.9539C215.384 25.7619 215.095 25.4547 214.883 25.6467C212.937 27.5088 210.99 29.3902 209.044 31.2523C208.832 31.4635 209.14 31.7514 209.352 31.5595Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M216.714 24.6885C217.966 23.6134 219.219 22.5384 220.472 21.4441C220.684 21.2714 220.375 20.9642 220.163 21.137C218.911 22.212 217.658 23.2871 216.405 24.3813C216.193 24.5733 216.502 24.8612 216.714 24.6885Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M220.51 45.5553C219.219 49.222 218.217 52.9654 217.523 56.7857C217.465 57.0544 217.889 57.1696 217.947 56.9009C218.641 53.0806 219.643 49.3372 220.934 45.6705C221.011 45.4017 220.606 45.2866 220.51 45.5553Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M216.02 54.3279C217.272 52.101 218.506 49.8742 219.758 47.6473C219.893 47.3977 219.527 47.1865 219.392 47.4361C218.139 49.663 216.906 51.8899 215.653 54.1167C215.518 54.3471 215.885 54.5583 216.02 54.3279Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M219.855 46.8053C218.93 50.0112 218.043 53.2556 217.214 56.4807C217.137 56.7495 217.561 56.8646 217.638 56.5959C218.467 53.3516 219.354 50.1264 220.279 46.9205C220.356 46.6517 219.932 46.5366 219.855 46.8053Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M215.692 54.1738C216.116 54.9801 216.617 55.7096 217.196 56.4007C217.369 56.6118 217.677 56.3047 217.504 56.0935C216.945 55.4216 216.463 54.7113 216.059 53.9434C215.924 53.6939 215.558 53.9242 215.692 54.1738Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M215.866 53.8496C216.329 54.6367 216.83 55.3854 217.408 56.0956C217.504 55.9805 217.581 55.8653 217.678 55.7501C217.215 55.4621 216.772 54.6942 216.733 54.1567C216.676 53.3696 217.157 52.7361 217.504 52.0834C218.102 51.0084 218.699 49.9525 219.316 48.8775C219.181 48.8199 219.046 48.7623 218.911 48.7047C218.391 50.9124 217.793 53.0817 217.119 55.2318C217.042 55.5005 217.446 55.6157 217.543 55.347C218.217 53.1969 218.815 51.0084 219.335 48.8199C219.393 48.5895 219.065 48.436 218.93 48.6471C218.449 49.511 217.967 50.3557 217.485 51.2196C217.1 51.8915 216.56 52.6018 216.329 53.3504C216.04 54.2911 216.618 55.6157 217.446 56.134C217.678 56.2684 217.851 55.9805 217.716 55.7885C217.157 55.0974 216.676 54.3871 216.252 53.6192C216.097 53.3888 215.731 53.6 215.866 53.8496Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M219.218 48.0302C218.39 50.1419 217.503 52.2344 216.559 54.3077C216.694 54.3653 216.829 54.4228 216.964 54.4804C217.233 53.1942 217.869 52.0616 218.544 50.929C218.679 50.6794 218.313 50.4874 218.178 50.7178C217.311 52.0424 216.829 53.5014 216.732 55.0755C216.713 55.2867 217.041 55.3635 217.137 55.1907C217.503 54.5188 217.773 53.8277 218.004 53.079C218.081 52.8487 217.715 52.6951 217.6 52.9063C217.291 53.559 217.06 54.1925 216.887 54.9028C216.829 55.1715 217.214 55.2675 217.311 55.018C217.869 53.5398 218.178 51.9656 218.563 50.4298C218.428 50.3914 218.293 50.353 218.139 50.3146C217.792 51.8888 217.445 53.463 217.079 55.0372C217.021 55.3059 217.445 55.4211 217.503 55.1523C217.85 53.5782 218.197 52.004 218.563 50.4298C218.621 50.1611 218.216 50.0459 218.139 50.3146C217.754 51.8504 217.445 53.4246 216.887 54.9028C217.021 54.9412 217.156 54.9796 217.311 55.018C217.465 54.3653 217.677 53.7317 217.966 53.1366C217.831 53.079 217.696 53.0214 217.561 52.9639C217.349 53.655 217.079 54.3269 216.732 54.9604C216.867 54.9988 217.002 55.0372 217.137 55.0755C217.233 53.5782 217.696 52.196 218.525 50.929C218.409 50.8522 218.274 50.7754 218.158 50.7178C217.465 51.8888 216.829 53.0406 216.54 54.3653C216.482 54.5956 216.829 54.7684 216.944 54.538C217.908 52.4455 218.814 50.3146 219.642 48.1646C219.739 47.8766 219.315 47.7806 219.218 48.0302Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M206.075 46.9191C205.748 49.7795 205.594 53.2158 204.013 55.7306C203.859 55.961 204.245 56.1913 204.38 55.9418C205.998 53.3694 206.152 49.8563 206.499 46.9191C206.538 46.6311 206.114 46.6311 206.075 46.9191Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M203.493 55.3652C204.437 53.8486 205.169 52.2361 205.67 50.5275C205.536 50.4891 205.401 50.4507 205.247 50.4124C204.88 52.1401 204.514 53.8487 203.512 55.3268C203.647 55.3844 203.782 55.442 203.917 55.4996C204.399 54.2518 204.957 53.0424 205.613 51.8713C205.497 51.7946 205.362 51.7178 205.247 51.6602C204.668 52.8312 204.167 54.0214 203.763 55.2692C203.685 55.4996 204.032 55.6532 204.167 55.442C205.054 53.8678 205.651 52.1785 205.921 50.3932C205.96 50.1244 205.555 50.0092 205.497 50.278C205.227 52.0249 204.649 53.6759 203.782 55.2117C203.917 55.2692 204.052 55.3268 204.187 55.3844C204.591 54.175 205.073 53.0232 205.632 51.8905C205.748 51.641 205.401 51.4298 205.266 51.6794C204.591 52.8888 204.013 54.1174 203.512 55.4036C203.416 55.634 203.782 55.7684 203.917 55.5764C204.919 54.0598 205.324 52.3129 205.69 50.5467C205.748 50.278 205.343 50.1628 205.266 50.4316C204.765 52.1017 204.052 53.6759 203.127 55.1541C202.972 55.3844 203.358 55.5956 203.493 55.3652Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M192.084 50.3149C189.155 53.1561 186.765 56.4772 185.012 60.1439C184.896 60.3934 185.262 60.6046 185.378 60.355C187.131 56.7076 189.483 53.4248 192.393 50.6029C192.585 50.4301 192.277 50.1229 192.084 50.3149Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M193.53 57.0749C189.887 61.5286 187.016 66.5391 185.031 71.9143C184.934 72.1831 185.358 72.2791 185.455 72.0295C187.42 66.7119 190.253 61.7782 193.838 57.382C194.011 57.1709 193.703 56.8637 193.53 57.0749Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M186.013 65.4434C180.887 73.775 176.994 82.8361 174.469 92.2811C174.392 92.5499 174.816 92.6651 174.893 92.3963C177.418 82.9897 181.291 73.9862 186.398 65.6738C186.533 65.4242 186.148 65.1939 186.013 65.4434Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M177.573 92.1868C173.468 101.459 170.539 111.192 168.862 121.175C168.823 121.443 169.228 121.559 169.286 121.29C170.943 111.346 173.853 101.632 177.958 92.398C178.074 92.1484 177.688 91.9181 177.573 92.1868Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M191.198 69.2636C186.496 78.2479 182.738 87.7122 179.982 97.4643C179.905 97.7331 180.329 97.8483 180.406 97.5795C183.162 87.8657 186.92 78.4399 191.583 69.494C191.699 69.2252 191.333 69.0141 191.198 69.2636Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M203.956 59.2047C199.504 65.0022 195.746 71.2605 192.701 77.8835C192.585 78.1331 192.952 78.3635 193.067 78.0947C196.112 71.4717 199.889 65.1942 204.322 59.4158C204.495 59.2047 204.129 58.9935 203.956 59.2047Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M190.62 84.4128C186.65 93.6466 183.489 103.226 181.196 113.017C181.138 113.285 181.543 113.401 181.62 113.132C183.913 103.38 187.055 93.8386 191.005 84.6431C191.102 84.3744 190.736 84.144 190.62 84.4128Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M207.328 19.1776C207.328 19.1584 207.328 19.1392 207.328 19.12C207.328 18.9664 207.193 18.832 207.039 18.832C206.885 18.832 206.75 18.9664 206.75 19.12C206.75 19.1392 206.75 19.1584 206.75 19.1776C206.75 19.3312 206.885 19.4655 207.039 19.4655C207.193 19.4655 207.328 19.3504 207.328 19.1776Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M208.427 18.1033C208.793 18.1033 208.793 17.5273 208.427 17.5273C208.041 17.5273 208.041 18.1033 208.427 18.1033Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M210.142 16.5096C210.142 16.4904 210.142 16.4712 210.142 16.452C210.142 16.2984 210.007 16.1641 209.853 16.1641C209.698 16.1641 209.563 16.2984 209.563 16.452C209.563 16.4712 209.563 16.4904 209.563 16.5096C209.563 16.6632 209.698 16.7976 209.853 16.7976C210.007 16.7784 210.142 16.6632 210.142 16.5096Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M211.163 15.3572C211.529 15.3572 211.529 14.7812 211.163 14.7812C210.797 14.7812 210.797 15.3572 211.163 15.3572Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M205.671 18.1619C206.037 18.1619 206.037 17.5859 205.671 17.5859C205.304 17.5859 205.285 18.1619 205.671 18.1619Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M207.367 16.3002C207.347 16.281 207.328 16.2618 207.309 16.2426C207.193 16.1275 207.02 16.1275 206.904 16.2426C206.788 16.3578 206.788 16.5306 206.904 16.6458C206.923 16.665 206.943 16.6842 206.962 16.7034C207.078 16.8186 207.251 16.8186 207.367 16.7034C207.463 16.6074 207.463 16.4154 207.367 16.3002Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M208.677 15.2229C208.696 15.2037 208.716 15.1845 208.735 15.1653C208.85 15.0501 208.85 14.8774 208.735 14.7622C208.619 14.647 208.446 14.647 208.33 14.7622C208.311 14.7814 208.292 14.8006 208.272 14.8198C208.157 14.9349 208.157 15.1077 208.272 15.2229C208.388 15.3381 208.561 15.3381 208.677 15.2229Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M210.142 13.8221C210.142 13.8029 210.142 13.7837 210.142 13.7645C210.142 13.6109 210.007 13.4766 209.853 13.4766C209.698 13.4766 209.563 13.6109 209.563 13.7645C209.563 13.7837 209.563 13.8029 209.563 13.8221C209.563 13.9757 209.698 14.1101 209.853 14.1101C210.007 14.1101 210.142 13.9757 210.142 13.8221Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M206.982 13.418C206.962 13.418 206.943 13.418 206.924 13.418C206.77 13.418 206.635 13.5523 206.635 13.7059C206.635 13.8595 206.77 13.9939 206.924 13.9939C206.943 13.9939 206.962 13.9939 206.982 13.9939C207.136 13.9939 207.271 13.8595 207.271 13.7059C207.271 13.5523 207.155 13.418 206.982 13.418Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M208.504 12.631C208.542 12.6118 208.581 12.5926 208.619 12.5734C208.754 12.4966 208.793 12.3047 208.716 12.1703C208.638 12.0359 208.465 11.9975 208.311 12.0743C208.272 12.0935 208.234 12.1127 208.195 12.1319C208.06 12.2087 208.022 12.4006 208.099 12.535C208.195 12.6694 208.369 12.7078 208.504 12.631Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M209.738 11.2517C210.104 11.2517 210.104 10.6758 209.738 10.6758C209.371 10.6758 209.371 11.2517 209.738 11.2517Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M211.201 10.0198C211.221 10.0006 211.24 9.98138 211.259 9.96219C211.375 9.847 211.375 9.67423 211.259 9.55904C211.144 9.44386 210.97 9.44386 210.854 9.55904C210.835 9.57824 210.816 9.59744 210.797 9.61664C210.681 9.73182 210.681 9.90459 210.797 10.0198C210.893 10.135 211.086 10.135 211.201 10.0198Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M212.609 7.94922C212.589 7.94922 212.57 7.94922 212.551 7.94922C212.397 7.94922 212.262 8.0836 212.262 8.23718C212.262 8.39075 212.397 8.52513 212.551 8.52513C212.57 8.52513 212.589 8.52513 212.609 8.52513C212.763 8.52513 212.898 8.39075 212.898 8.23718C212.878 8.0836 212.763 7.94922 212.609 7.94922Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M213.977 6.67969C213.957 6.67969 213.938 6.67969 213.919 6.67969C213.765 6.67969 213.63 6.81407 213.63 6.96765C213.63 7.12122 213.765 7.2556 213.919 7.2556C213.938 7.2556 213.957 7.2556 213.977 7.2556C214.131 7.2556 214.266 7.12122 214.266 6.96765C214.266 6.81407 214.131 6.67969 213.977 6.67969Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M215.461 5.66196C215.461 5.64276 215.461 5.62356 215.461 5.60436C215.461 5.45079 215.326 5.31641 215.172 5.31641C215.018 5.31641 214.883 5.45079 214.883 5.60436C214.883 5.62356 214.883 5.64276 214.883 5.66196C214.883 5.81553 215.018 5.94991 215.172 5.94991C215.326 5.93072 215.461 5.81553 215.461 5.66196Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M217.253 4.07211C217.253 4.05292 217.253 4.03372 217.253 4.01452C217.253 3.86094 217.118 3.72656 216.964 3.72656C216.81 3.72656 216.675 3.86094 216.675 4.01452C216.675 4.03372 216.675 4.05292 216.675 4.07211C216.675 4.22569 216.81 4.36007 216.964 4.36007C217.118 4.34087 217.253 4.22569 217.253 4.07211Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M220.741 3.15013C221.107 3.15013 221.107 2.57422 220.741 2.57422C220.356 2.57422 220.356 3.15013 220.741 3.15013Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M222.341 1.72826C222.707 1.72826 222.707 1.15234 222.341 1.15234C221.975 1.15234 221.975 1.72826 222.341 1.72826Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M223.593 3.03295C223.959 3.03295 223.959 2.45703 223.593 2.45703C223.227 2.45703 223.227 3.03295 223.593 3.03295Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M224.866 1.66967C225.232 1.66967 225.232 1.09375 224.866 1.09375C224.5 1.09375 224.48 1.66967 224.866 1.66967Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M226.465 2.86107C226.831 2.86107 226.831 2.28516 226.465 2.28516C226.099 2.28516 226.099 2.86107 226.465 2.86107Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M227.39 3.89733C227.39 3.91653 227.39 3.93573 227.39 3.95492C227.39 4.1085 227.525 4.24288 227.679 4.24288C227.833 4.24288 227.968 4.1085 227.968 3.95492C227.968 3.93573 227.968 3.91653 227.968 3.89733C227.968 3.74376 227.833 3.60938 227.679 3.60938C227.505 3.60938 227.39 3.72456 227.39 3.89733Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M229.336 5.54857C229.702 5.54857 229.702 4.97266 229.336 4.97266C228.951 4.97266 228.951 5.54857 229.336 5.54857Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M229.105 3.20482C229.471 3.20482 229.471 2.62891 229.105 2.62891C228.739 2.62891 228.739 3.20482 229.105 3.20482Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M229.221 8.46654C229.587 8.46654 229.587 7.89062 229.221 7.89062C228.835 7.89062 228.835 8.46654 229.221 8.46654Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M228.218 6.7182C228.199 6.699 228.18 6.6798 228.16 6.66061C228.045 6.54542 227.871 6.54542 227.756 6.66061C227.64 6.77579 227.64 6.94856 227.756 7.06375C227.775 7.08294 227.794 7.10214 227.813 7.12134C227.929 7.23652 228.103 7.23652 228.218 7.12134C228.334 7.00616 228.334 6.81418 228.218 6.7182Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M229.336 11.1931C229.702 11.1931 229.702 10.6172 229.336 10.6172C228.951 10.6172 228.951 11.1931 229.336 11.1931Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M227.775 9.82982C228.141 9.82982 228.141 9.25391 227.775 9.25391C227.408 9.25391 227.408 9.82982 227.775 9.82982Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M227.988 12.594C228.007 12.5748 228.026 12.5556 228.045 12.5364C228.161 12.4212 228.161 12.2484 228.045 12.1333C227.93 12.0181 227.756 12.0181 227.641 12.1333C227.621 12.1525 227.602 12.1717 227.583 12.1909C227.467 12.306 227.467 12.4788 227.583 12.594C227.698 12.7092 227.872 12.7092 227.988 12.594Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M229.567 13.7635C229.567 13.7443 229.567 13.7251 229.567 13.7059C229.567 13.5523 229.433 13.418 229.278 13.418C229.124 13.418 228.989 13.5523 228.989 13.7059C228.989 13.7251 228.989 13.7443 228.989 13.7635C228.989 13.9171 229.124 14.0515 229.278 14.0515C229.433 14.0515 229.567 13.9171 229.567 13.7635Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M227.891 15.4744C228.257 15.4744 228.257 14.8984 227.891 14.8984C227.525 14.8984 227.525 15.4744 227.891 15.4744Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M228.874 16.5692C228.874 16.5884 228.874 16.6076 228.874 16.6268C228.874 16.7804 229.009 16.9148 229.163 16.9148C229.317 16.9148 229.452 16.7804 229.452 16.6268C229.452 16.6076 229.452 16.5884 229.452 16.5692C229.452 16.4156 229.317 16.2812 229.163 16.2812C229.009 16.2812 228.874 16.3964 228.874 16.5692Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M227.64 18.1419C227.66 18.1611 227.679 18.1803 227.698 18.1995C227.814 18.3146 227.987 18.3146 228.103 18.1995C228.219 18.0843 228.219 17.9115 228.103 17.7963C228.084 17.7771 228.064 17.7579 228.045 17.7387C227.93 17.6235 227.756 17.6235 227.64 17.7387C227.525 17.8347 227.525 18.0267 227.64 18.1419Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M229.105 19.7556C229.471 19.7556 229.471 19.1797 229.105 19.1797C228.739 19.1797 228.739 19.7556 229.105 19.7556Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M226.176 19.2372C226.176 19.2756 226.176 19.314 226.176 19.3524C226.176 19.5059 226.311 19.6403 226.465 19.6403C226.619 19.6403 226.754 19.5059 226.754 19.3524C226.754 19.314 226.754 19.2756 226.754 19.2372C226.754 19.0836 226.619 18.9492 226.465 18.9492C226.311 18.9684 226.176 19.0836 226.176 19.2372Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M227.968 20.907C227.968 20.8687 227.968 20.8303 227.968 20.7919C227.968 20.6383 227.833 20.5039 227.679 20.5039C227.525 20.5039 227.39 20.6383 227.39 20.7919C227.39 20.8303 227.39 20.8687 227.39 20.907C227.39 21.0606 227.525 21.195 227.679 21.195C227.833 21.1758 227.968 21.0606 227.968 20.907Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M226.638 22.5564C227.004 22.5564 227.004 21.9805 226.638 21.9805C226.272 21.9805 226.272 22.5564 226.638 22.5564Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M227.717 23.8611C228.083 23.8611 228.083 23.2852 227.717 23.2852C227.351 23.2852 227.351 23.8611 227.717 23.8611Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M224.75 20.62C224.75 20.6392 224.75 20.6584 224.75 20.6776C224.75 20.8312 224.885 20.9655 225.039 20.9655C225.193 20.9655 225.328 20.8312 225.328 20.6776C225.328 20.6584 225.328 20.6392 225.328 20.62C225.328 20.4664 225.193 20.332 225.039 20.332C224.885 20.332 224.75 20.4472 224.75 20.62Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M225.097 18.2165C225.463 18.2165 225.463 17.6406 225.097 17.6406C224.711 17.6406 224.711 18.2165 225.097 18.2165Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M226.234 16.9704C226.6 16.9704 226.6 16.3945 226.234 16.3945C225.867 16.3945 225.867 16.9704 226.234 16.9704Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M223.593 19.4275C223.959 19.4275 223.959 18.8516 223.593 18.8516C223.227 18.8516 223.227 19.4275 223.593 19.4275Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M222.167 21.0212C222.533 21.0212 222.533 20.4453 222.167 20.4453C221.801 20.4453 221.801 21.0212 222.167 21.0212Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M220.856 19.8103C221.223 19.8103 221.223 19.2344 220.856 19.2344C220.471 19.2344 220.471 19.8103 220.856 19.8103Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M222.399 17.6992C222.379 17.6992 222.36 17.6992 222.341 17.6992C222.187 17.6992 222.052 17.8336 222.052 17.9872C222.052 18.1408 222.187 18.2751 222.341 18.2751C222.36 18.2751 222.379 18.2751 222.399 18.2751C222.553 18.2751 222.688 18.1408 222.688 17.9872C222.688 17.8336 222.553 17.6992 222.399 17.6992Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M223.593 16.9119C223.959 16.9119 223.959 16.3359 223.593 16.3359C223.227 16.3359 223.227 16.9119 223.593 16.9119Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M225.154 15.3026C225.154 15.2834 225.154 15.2642 225.154 15.245C225.154 15.0914 225.019 14.957 224.865 14.957C224.711 14.957 224.576 15.0914 224.576 15.245C224.576 15.2642 224.576 15.2834 224.576 15.3026C224.576 15.4562 224.711 15.5905 224.865 15.5905C225.019 15.5905 225.154 15.4754 225.154 15.3026Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M226.35 14.2244C226.716 14.2244 226.716 13.6484 226.35 13.6484C225.984 13.6484 225.984 14.2244 226.35 14.2244Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M223.651 13.9392C224.017 13.9392 224.017 13.3633 223.651 13.3633C223.284 13.3633 223.284 13.9392 223.651 13.9392Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M224.98 12.6306C225.347 12.6306 225.347 12.0547 224.98 12.0547C224.595 12.0547 224.595 12.6306 224.98 12.6306Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M226.35 11.2517C226.716 11.2517 226.716 10.6758 226.35 10.6758C225.984 10.6758 225.984 11.2517 226.35 11.2517Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M225.501 9.65805C225.501 9.63885 225.501 9.61966 225.501 9.60046C225.501 9.44688 225.366 9.3125 225.212 9.3125C225.058 9.3125 224.923 9.44688 224.923 9.60046C224.923 9.61966 224.923 9.63885 224.923 9.65805C224.923 9.81163 225.058 9.94601 225.212 9.94601C225.366 9.94601 225.501 9.81163 225.501 9.65805Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M226.58 8.23618C226.58 8.21698 226.58 8.19778 226.58 8.17858C226.58 8.02501 226.445 7.89062 226.291 7.89062C226.137 7.89062 226.002 8.02501 226.002 8.17858C226.002 8.19778 226.002 8.21698 226.002 8.23618C226.002 8.38975 226.137 8.52413 226.291 8.52413C226.445 8.50494 226.58 8.38975 226.58 8.23618Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M223.709 8.58373C224.075 8.58373 224.075 8.00781 223.709 8.00781C223.343 8.00781 223.343 8.58373 223.709 8.58373Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M225.097 7.08373C225.463 7.08373 225.463 6.50781 225.097 6.50781C224.711 6.50781 224.711 7.08373 225.097 7.08373Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M226.099 5.27902C226.079 5.29822 226.06 5.31742 226.041 5.33661C225.925 5.4518 225.925 5.62457 226.041 5.73975C226.156 5.85494 226.33 5.85494 226.446 5.73975C226.465 5.72056 226.484 5.70136 226.503 5.68216C226.619 5.56698 226.619 5.3942 226.503 5.27902C226.388 5.18303 226.195 5.18303 226.099 5.27902Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M224.982 3.99219C224.962 3.99219 224.943 3.99219 224.924 3.99219C224.77 3.99219 224.635 4.12657 224.635 4.28015C224.635 4.43372 224.77 4.5681 224.924 4.5681C224.943 4.5681 224.962 4.5681 224.982 4.5681C225.136 4.5681 225.271 4.43372 225.271 4.28015C225.251 4.12657 225.136 3.99219 224.982 3.99219Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M223.651 5.89232C224.017 5.89232 224.017 5.31641 223.651 5.31641C223.284 5.31641 223.284 5.89232 223.651 5.89232Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M221.994 6.79577C221.994 6.81497 221.994 6.83416 221.994 6.85336C221.994 7.00694 222.129 7.14132 222.283 7.14132C222.437 7.14132 222.572 7.00694 222.572 6.85336C222.572 6.83416 222.572 6.81497 222.572 6.79577C222.572 6.64219 222.437 6.50781 222.283 6.50781C222.129 6.52701 221.994 6.64219 221.994 6.79577Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M221.146 5.66196C221.146 5.64276 221.146 5.62356 221.146 5.60436C221.146 5.45079 221.011 5.31641 220.856 5.31641C220.702 5.31641 220.567 5.45079 220.567 5.60436C220.567 5.62356 220.567 5.64276 220.567 5.66196C220.567 5.81553 220.702 5.94991 220.856 5.94991C221.011 5.93072 221.146 5.81553 221.146 5.66196Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M222.225 4.5681C222.591 4.5681 222.591 3.99219 222.225 3.99219C221.859 3.99219 221.859 4.5681 222.225 4.5681Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M219.759 3.60938C219.74 3.60938 219.72 3.60938 219.701 3.60938C219.547 3.60938 219.412 3.74376 219.412 3.89733C219.412 4.05091 219.547 4.18529 219.701 4.18529C219.72 4.18529 219.74 4.18529 219.759 4.18529C219.913 4.18529 220.048 4.05091 220.048 3.89733C220.048 3.74376 219.932 3.60938 219.759 3.60938Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M218.043 5.89232C218.409 5.89232 218.409 5.31641 218.043 5.31641C217.677 5.31641 217.677 5.89232 218.043 5.89232Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M219.527 6.79477C219.527 6.77557 219.527 6.75637 219.527 6.73718C219.527 6.5836 219.392 6.44922 219.238 6.44922C219.084 6.44922 218.949 6.5836 218.949 6.73718C218.949 6.75637 218.949 6.77557 218.949 6.79477C218.949 6.94835 219.084 7.08273 219.238 7.08273C219.412 7.08273 219.527 6.96754 219.527 6.79477Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M216.675 7.20092C217.041 7.20092 217.041 6.625 216.675 6.625C216.289 6.625 216.289 7.20092 216.675 7.20092Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M218.043 8.34935C218.409 8.34935 218.409 7.77344 218.043 7.77344C217.677 7.77344 217.677 8.34935 218.043 8.34935Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M215.634 8.52513C216 8.52513 216 7.94922 215.634 7.94922C215.268 7.94922 215.268 8.52513 215.634 8.52513Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M216.675 9.9431C217.041 9.9431 217.041 9.36719 216.675 9.36719C216.289 9.36719 216.289 9.9431 216.675 9.9431Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M213.957 9.3886C213.803 9.42699 213.707 9.58057 213.726 9.73415C213.745 9.90692 213.88 9.98371 214.034 10.0029C214.189 10.0221 214.323 9.84933 214.323 9.71495C214.323 9.54217 214.189 9.44619 214.034 9.42699C214.034 9.42699 214.034 9.42699 214.015 9.42699C214.092 9.44619 214.15 9.48458 214.227 9.50378C214.246 9.54217 214.285 9.58057 214.304 9.63816C214.304 9.63816 214.304 9.63816 214.304 9.61896C214.304 9.67655 214.304 9.71495 214.304 9.77254C214.304 9.79174 214.285 9.81093 214.285 9.81093C214.227 9.84933 214.169 9.90692 214.112 9.94531C214.112 9.94531 214.112 9.94531 214.131 9.94531C214.285 9.90692 214.381 9.73415 214.323 9.59976C214.266 9.42699 214.112 9.3502 213.957 9.3886Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M215.461 11.1346C215.461 11.1154 215.461 11.0962 215.461 11.077C215.461 10.9234 215.326 10.7891 215.172 10.7891C215.018 10.7891 214.883 10.9234 214.883 11.077C214.883 11.0962 214.883 11.1154 214.883 11.1346C214.883 11.2882 215.018 11.4226 215.172 11.4226C215.326 11.4226 215.461 11.3074 215.461 11.1346Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M212.801 11.2307C212.82 11.2115 212.84 11.1923 212.859 11.1731C212.974 11.0579 212.974 10.8852 212.859 10.77C212.743 10.6548 212.57 10.6548 212.454 10.77C212.435 10.7892 212.416 10.8084 212.396 10.8276C212.281 10.9428 212.281 11.1155 212.396 11.2307C212.512 11.3459 212.685 11.3459 212.801 11.2307Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M213.572 12.4012C213.572 12.4204 213.572 12.4396 213.572 12.4588C213.572 12.6124 213.707 12.7468 213.861 12.7468C214.016 12.7468 214.15 12.6124 214.15 12.4588C214.15 12.4396 214.15 12.4204 214.15 12.4012C214.15 12.2477 214.016 12.1133 213.861 12.1133C213.707 12.1133 213.572 12.2285 213.572 12.4012Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M212.955 13.6502C212.955 13.631 212.955 13.6118 212.955 13.5926C212.955 13.4391 212.82 13.3047 212.666 13.3047C212.512 13.3047 212.377 13.4391 212.377 13.5926C212.377 13.6118 212.377 13.631 212.377 13.6502C212.377 13.8038 212.512 13.9382 212.666 13.9382C212.82 13.9382 212.955 13.8038 212.955 13.6502Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M211.568 12.7478C211.934 12.7478 211.934 12.1719 211.568 12.1719C211.201 12.1719 211.201 12.7478 211.568 12.7478Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M215.23 14.0525C215.596 14.0525 215.596 13.4766 215.23 13.4766C214.864 13.4766 214.864 14.0525 215.23 14.0525Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M216.732 12.5759C217.099 12.5759 217.099 12 216.732 12C216.347 12 216.347 12.5759 216.732 12.5759Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M218.101 11.365C218.467 11.365 218.467 10.7891 218.101 10.7891C217.735 10.7891 217.735 11.365 218.101 11.365Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M219.411 9.82982C219.778 9.82982 219.778 9.25391 219.411 9.25391C219.045 9.25391 219.045 9.82982 219.411 9.82982Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M220.856 8.52513C220.876 8.52513 220.895 8.52513 220.914 8.52513C221.068 8.52513 221.203 8.39075 221.203 8.23718C221.203 8.0836 221.068 7.94922 220.914 7.94922C220.895 7.94922 220.876 7.94922 220.856 7.94922C220.702 7.94922 220.567 8.0836 220.567 8.23718C220.567 8.39075 220.683 8.52513 220.856 8.52513Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M222.341 9.25391C222.322 9.25391 222.302 9.25391 222.283 9.25391C222.129 9.25391 221.994 9.38829 221.994 9.54186C221.994 9.69544 222.129 9.82982 222.283 9.82982C222.302 9.82982 222.322 9.82982 222.341 9.82982C222.495 9.82982 222.63 9.69544 222.63 9.54186C222.63 9.38829 222.495 9.25391 222.341 9.25391Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M224.056 11.0213C224.056 11.0021 224.056 10.9829 224.056 10.9637C224.056 10.8102 223.921 10.6758 223.767 10.6758C223.612 10.6758 223.478 10.8102 223.478 10.9637C223.478 10.9829 223.478 11.0021 223.478 11.0213C223.478 11.1749 223.612 11.3093 223.767 11.3093C223.921 11.3093 224.056 11.1941 224.056 11.0213Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M222.11 12.8611C222.476 12.8611 222.476 12.2852 222.11 12.2852C221.743 12.2852 221.743 12.8611 222.11 12.8611Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M221.377 11.3065C221.377 11.2873 221.377 11.2681 221.377 11.2489C221.377 11.0953 221.242 10.9609 221.088 10.9609C220.934 10.9609 220.799 11.0953 220.799 11.2489C220.799 11.2681 220.799 11.2873 220.799 11.3065C220.799 11.4601 220.934 11.5944 221.088 11.5944C221.242 11.5944 221.377 11.4793 221.377 11.3065Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M219.682 12.6526C219.701 12.6334 219.72 12.6142 219.74 12.595C219.855 12.4798 219.855 12.307 219.74 12.1919C219.624 12.0767 219.451 12.0767 219.335 12.1919C219.316 12.2111 219.296 12.2303 219.277 12.2494C219.162 12.3646 219.162 12.5374 219.277 12.6526C219.374 12.7678 219.566 12.7678 219.682 12.6526Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M220.799 13.9939C221.165 13.9939 221.165 13.418 220.799 13.418C220.413 13.418 220.413 13.9939 220.799 13.9939Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M222.225 15.4158C222.591 15.4158 222.591 14.8398 222.225 14.8398C221.859 14.8398 221.859 15.4158 222.225 15.4158Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M220.857 16.8572C220.877 16.8572 220.896 16.8572 220.915 16.8572C221.069 16.8572 221.204 16.7228 221.204 16.5692C221.204 16.4156 221.069 16.2812 220.915 16.2812C220.896 16.2812 220.877 16.2812 220.857 16.2812C220.703 16.2812 220.568 16.4156 220.568 16.5692C220.568 16.7228 220.684 16.8572 220.857 16.8572Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M219.566 18.0862C219.585 18.067 219.604 18.0478 219.623 18.0286C219.739 17.9134 219.739 17.7406 219.623 17.6254C219.508 17.5103 219.334 17.5103 219.219 17.6254C219.199 17.6446 219.18 17.6638 219.161 17.683C219.045 17.7982 219.045 17.971 219.161 18.0862C219.277 18.1822 219.45 18.1822 219.566 18.0862Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M219.411 15.5329C219.778 15.5329 219.778 14.957 219.411 14.957C219.045 14.957 219.045 15.5329 219.411 15.5329Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M218.101 16.74C218.467 16.74 218.467 16.1641 218.101 16.1641C217.735 16.1641 217.735 16.74 218.101 16.74Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M217.022 15.244C217.022 15.2248 217.022 15.2056 217.022 15.1864C217.022 15.0328 216.887 14.8984 216.732 14.8984C216.578 14.8984 216.443 15.0328 216.443 15.1864C216.443 15.2056 216.443 15.2248 216.443 15.244C216.443 15.3976 216.578 15.5319 216.732 15.5319C216.887 15.5319 217.022 15.4168 217.022 15.244Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M217.927 14.0525C218.293 14.0525 218.293 13.4766 217.927 13.4766C217.561 13.4766 217.561 14.0525 217.927 14.0525Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M221.03 22.3845C221.396 22.3845 221.396 21.8086 221.03 21.8086C220.645 21.8086 220.645 22.3845 221.03 22.3845Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M222.514 23.4588C222.514 23.4396 222.514 23.4204 222.514 23.4012C222.514 23.2477 222.379 23.1133 222.225 23.1133C222.07 23.1133 221.936 23.2477 221.936 23.4012C221.936 23.4204 221.936 23.4396 221.936 23.4588C221.936 23.6124 222.07 23.7468 222.225 23.7468C222.379 23.7468 222.514 23.6316 222.514 23.4588Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M223.517 24.5173C223.497 24.5365 223.478 24.5557 223.459 24.5749C223.343 24.6901 223.343 24.8629 223.459 24.978C223.574 25.0932 223.748 25.0932 223.863 24.978C223.883 24.9588 223.902 24.9396 223.921 24.9204C224.037 24.8053 224.037 24.6325 223.921 24.5173C223.806 24.4213 223.632 24.4213 223.517 24.5173Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M225.038 26.0312C225.019 26.0312 225 26.0312 224.98 26.0312C224.826 26.0312 224.691 26.1656 224.691 26.3192C224.691 26.4728 224.826 26.6072 224.98 26.6072C225 26.6072 225.019 26.6072 225.038 26.6072C225.192 26.6072 225.327 26.4728 225.327 26.3192C225.308 26.1656 225.192 26.0312 225.038 26.0312Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M226.291 27.9314C226.657 27.9314 226.657 27.3555 226.291 27.3555C225.925 27.3555 225.925 27.9314 226.291 27.9314Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M227.429 26.2606C227.429 26.2798 227.429 26.299 227.429 26.3182C227.429 26.4718 227.564 26.6062 227.718 26.6062C227.872 26.6062 228.007 26.4718 228.007 26.3182C228.007 26.299 228.007 26.2798 228.007 26.2606C228.007 26.107 227.872 25.9727 227.718 25.9727C227.564 25.9919 227.429 26.107 227.429 26.2606Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M225.039 29.3533C225.405 29.3533 225.405 28.7773 225.039 28.7773C224.654 28.7773 224.654 29.3533 225.039 29.3533Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M223.709 28.029C224.075 28.029 224.075 27.4531 223.709 27.4531C223.343 27.4531 223.343 28.029 223.709 28.029Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M222.167 26.5486C222.533 26.5486 222.533 25.9727 222.167 25.9727C221.801 25.9727 221.801 26.5486 222.167 26.5486Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M220.914 24.668C220.895 24.668 220.876 24.668 220.856 24.668C220.702 24.668 220.567 24.8023 220.567 24.9559C220.567 25.1095 220.702 25.2439 220.856 25.2439C220.876 25.2439 220.895 25.2439 220.914 25.2439C221.068 25.2439 221.203 25.1095 221.203 24.9559C221.184 24.8023 221.068 24.668 220.914 24.668Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M220.799 27.4531C220.78 27.4531 220.76 27.4531 220.741 27.4531C220.587 27.4531 220.452 27.5875 220.452 27.7411C220.452 27.8947 220.587 28.029 220.741 28.029C220.76 28.029 220.78 28.029 220.799 28.029C220.953 28.029 221.088 27.8947 221.088 27.7411C221.069 27.5875 220.953 27.4531 220.799 27.4531Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M222.341 29.4119C222.707 29.4119 222.707 28.8359 222.341 28.8359C221.975 28.8359 221.975 29.4119 222.341 29.4119Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M219.585 28.7773C219.566 28.7773 219.547 28.7773 219.527 28.7773C219.373 28.7773 219.238 28.9117 219.238 29.0653C219.238 29.2189 219.373 29.3533 219.527 29.3533C219.547 29.3533 219.566 29.3533 219.585 29.3533C219.739 29.3533 219.874 29.2189 219.874 29.0653C219.874 28.9117 219.759 28.7773 219.585 28.7773Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M209.738 25.2439C210.104 25.2439 210.104 24.668 209.738 24.668C209.371 24.668 209.371 25.2439 209.738 25.2439Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M208.465 23.7478C208.831 23.7478 208.831 23.1719 208.465 23.1719C208.099 23.1719 208.099 23.7478 208.465 23.7478Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M206.923 22.3259C207.289 22.3259 207.289 21.75 206.923 21.75C206.557 21.75 206.557 22.3259 206.923 22.3259Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M208.426 20.7909C208.426 20.7717 208.426 20.7525 208.426 20.7333C208.446 20.5797 208.272 20.4453 208.137 20.4453C207.964 20.4453 207.867 20.5797 207.848 20.7333C207.848 20.7525 207.848 20.7717 207.848 20.7909C207.829 20.9444 208.002 21.0788 208.137 21.0788C208.311 21.0596 208.407 20.9444 208.426 20.7909Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M209.679 19.6384C210.045 19.6384 210.045 19.0625 209.679 19.0625C209.313 19.0625 209.313 19.6384 209.679 19.6384Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M211.163 18.1619C211.529 18.1619 211.529 17.5859 211.163 17.5859C210.797 17.5859 210.797 18.1619 211.163 18.1619Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M212.686 16.7581C212.705 16.7389 212.724 16.7197 212.744 16.7005C212.859 16.5853 212.859 16.4125 212.744 16.2973C212.628 16.1821 212.455 16.1821 212.339 16.2973C212.32 16.3165 212.3 16.3357 212.281 16.3549C212.165 16.4701 212.165 16.6429 212.281 16.7581C212.397 16.8732 212.57 16.8732 212.686 16.7581Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M214.034 15.4744C214.401 15.4744 214.401 14.8984 214.034 14.8984C213.668 14.8984 213.668 15.4744 214.034 15.4744Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M215.345 16.9119C215.711 16.9119 215.711 16.3359 215.345 16.3359C214.979 16.3359 214.979 16.9119 215.345 16.9119Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M216.578 17.5083C216.559 17.5275 216.54 17.5467 216.52 17.5659C216.405 17.681 216.405 17.8538 216.52 17.969C216.636 18.0842 216.809 18.0842 216.925 17.969C216.944 17.9498 216.964 17.9306 216.983 17.9114C217.098 17.7962 217.098 17.6234 216.983 17.5083C216.867 17.3931 216.694 17.3931 216.578 17.5083Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M215.287 19.697C215.653 19.697 215.653 19.1211 215.287 19.1211C214.921 19.1211 214.921 19.697 215.287 19.697Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M214.034 18.3923C214.401 18.3923 214.401 17.8164 214.034 17.8164C213.668 17.8164 213.668 18.3923 214.034 18.3923Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M212.551 19.7556C212.917 19.7556 212.917 19.1797 212.551 19.1797C212.165 19.1797 212.165 19.7556 212.551 19.7556Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M213.63 20.6747C213.63 20.6939 213.63 20.7131 213.63 20.7323C213.63 20.8858 213.765 21.0202 213.919 21.0202C214.073 21.0202 214.208 20.8858 214.208 20.7323C214.208 20.7131 214.208 20.6939 214.208 20.6747C214.208 20.5211 214.073 20.3867 213.919 20.3867C213.765 20.3867 213.63 20.5019 213.63 20.6747Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M211.28 20.9626C211.646 20.9626 211.646 20.3867 211.28 20.3867C210.913 20.3867 210.913 20.9626 211.28 20.9626Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M212.493 22.3259C212.859 22.3259 212.859 21.75 212.493 21.75C212.108 21.75 212.108 22.3259 212.493 22.3259Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M209.911 22.3845C210.277 22.3845 210.277 21.8086 209.911 21.8086C209.545 21.8086 209.525 22.3845 209.911 22.3845Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M210.989 23.5954C211.356 23.5954 211.356 23.0195 210.989 23.0195C210.623 23.0195 210.623 23.5954 210.989 23.5954Z"
        fill="#1C2A3C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M198.021 24.6115C195.477 23.0566 194.552 19.889 195.516 17.1438C196.46 14.437 198.85 12.5365 201.567 11.7878C207.233 10.2328 212.687 13.1892 216.926 16.7023C221.359 20.369 225.175 24.9379 230.436 27.4719C232.825 28.6046 235.466 29.3341 238.125 29.1805C240.052 29.0653 242.75 28.5086 242.847 26.1281C242.943 23.5941 240.303 21.444 238.414 20.1386C236.063 18.4876 233.346 17.4702 230.494 17.1054C230.127 17.0479 230.127 17.643 230.494 17.6814C233.23 18.0461 235.851 19.0636 238.125 20.6377C239.86 21.8472 244.388 25.7442 241.286 27.7983C240.091 28.5854 238.395 28.6622 237.007 28.6238C235.581 28.5854 234.155 28.2782 232.806 27.8175C229.935 26.8384 227.391 25.1299 225.078 23.2102C220.8 19.6395 217.081 15.2817 212.051 12.7093C207.888 10.5784 202.492 9.88729 198.426 12.6133C196.344 14.0147 194.822 16.28 194.591 18.814C194.379 21.3288 195.573 23.8053 197.751 25.1299C198.059 25.3027 198.349 24.8035 198.021 24.6115Z"
        fill="#1A72F6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M206.455 11.4795C206.84 10.9612 207.341 10.5581 207.919 10.2893C208.343 10.0973 210.27 9.63662 209.519 10.7884C209.153 11.3452 208.536 11.8251 207.977 12.1515C207.765 12.2858 207.553 12.401 207.322 12.5162C206.898 12.8234 206.57 12.6506 206.339 11.9787C206.416 11.7099 206.57 11.4987 206.763 11.3068C207.013 11.038 206.609 10.6157 206.358 10.9036C205.78 11.5371 205.318 13.0729 206.609 13.2841C207.129 13.3609 207.746 12.9769 208.15 12.7274C208.767 12.3626 209.365 11.8827 209.808 11.326C210.463 10.5389 210.405 9.40625 209.172 9.40625C207.861 9.40625 206.667 10.1933 205.915 11.1916C205.722 11.4795 206.223 11.7675 206.455 11.4795Z"
        fill="#1A72F6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.186 19.7521C105.298 17.4293 101.251 17.8708 98.8033 18.8883C96.0089 20.0593 93.9854 22.6701 94.0432 25.7609C94.101 28.89 96.4522 31.0593 99.4007 31.712C103.024 32.5183 106.416 31.2705 109.403 29.2739C110.944 28.2565 112.448 27.1239 114.182 26.4712C116.263 25.6649 118.615 25.5881 120.754 26.2408C124.396 27.335 126.94 30.3874 129.715 32.7678C132.471 35.1291 135.574 37.0296 138.927 38.431C142.222 39.8132 146.308 41.2338 149.892 40.1972C151.261 39.794 152.667 38.8726 152.533 37.2792C152.398 35.6474 150.875 34.246 149.661 33.2862C146.809 31.0401 143.07 30.1378 139.524 30.7905C139.158 30.8481 139.312 31.4048 139.678 31.3472C142.743 30.7905 145.922 31.4624 148.524 33.171C149.777 33.9965 151.376 35.2827 151.839 36.7801C152.571 39.1029 149.7 39.8324 147.984 39.9476C144.612 40.178 140.97 38.7766 137.963 37.3752C134.995 35.993 132.24 34.2076 129.792 32.0575C127.614 30.157 125.61 27.9493 123.028 26.5671C120.33 25.1082 117.092 24.8202 114.201 25.8568C111.349 26.8935 109.152 29.1012 106.416 30.349C103.428 31.7312 99.2465 31.9616 96.5678 29.7923C93.6385 27.431 94.2745 22.9389 96.9532 20.6736C98.283 19.541 100.017 18.9075 101.752 18.7347C103.506 18.5619 105.606 18.6963 106.782 20.1553C107.013 20.4432 107.418 20.0401 107.186 19.7521Z"
        fill="#1A72F6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.4073 57.1318C81.8827 55.0201 78.5873 54.4826 75.3689 54.617C71.7651 54.7706 68.1228 55.5769 64.6732 56.5751C57.427 58.6484 50.5856 62.1039 44.6114 66.692C41.9134 68.7653 39.2924 71.1074 37.5387 74.0638C35.8813 76.8282 34.9756 80.418 36.2668 83.5088C37.4616 86.3692 40.3524 87.521 43.2816 87.6554C46.9047 87.8282 50.6241 86.8875 54.1508 86.1196C62.1293 84.3919 70.6088 82.0882 78.6258 84.9294C85.1011 87.2139 90.2273 92.0516 96.4521 94.8543C99.6511 96.2941 103.043 97.0236 106.57 96.8509C110.597 96.6397 114.51 95.4687 118.325 94.2592C122.353 92.9922 126.362 91.8212 130.505 91.0725C134.687 90.3238 138.927 89.8055 143.089 88.9608C148.196 87.9433 157.273 85.7165 156.425 78.7479C156.078 75.8683 153.824 73.5262 151.28 72.3168C147.984 70.7427 144.188 71.2418 140.815 72.3168C138.946 72.9119 137.154 73.6798 135.361 74.4669C135.015 74.6205 135.323 75.1196 135.651 74.966C139.274 73.3919 143.147 71.7217 147.194 71.9137C150.451 72.0673 153.766 73.8334 155.25 76.8282C156.753 79.8613 155.365 83.0289 152.764 84.9102C150.162 86.7915 146.924 87.5786 143.822 88.2313C140.006 89.0376 136.152 89.5559 132.317 90.1894C128.443 90.8229 124.646 91.6868 120.888 92.8578C113.816 95.0655 106.454 97.7339 99.0537 95.2767C93.0602 93.2802 88.2038 88.9992 82.6728 86.1004C79.8592 84.6414 76.8721 83.5856 73.7115 83.2208C70.1077 82.7793 66.4654 83.1249 62.9194 83.7392C59.1037 84.3919 55.3457 85.3517 51.5492 86.1004C48.273 86.7531 44.6499 87.5978 41.3159 86.8299C39.6971 86.4652 38.2132 85.6589 37.2882 84.2383C36.2668 82.6833 36.0741 80.7252 36.3246 78.9207C36.8257 75.4844 38.9648 72.5472 41.393 70.1859C46.3844 65.3098 52.7633 61.6048 59.2386 59.0323C62.4762 57.7461 65.8294 56.7479 69.2405 56.0376C72.536 55.3657 76.082 54.7898 79.4352 55.4425C81.1118 55.7688 82.6728 56.4407 83.9833 57.535C84.2917 57.7653 84.6964 57.3622 84.4073 57.1318Z"
        fill="#1A72F6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.1205 59.1099C48.7929 57.8237 50.5273 56.6335 51.4716 56.1151C51.9727 55.8464 52.493 55.6352 53.0326 55.4432C53.2639 55.3665 53.4952 55.2897 53.7264 55.2129C54.0926 55.1169 55.8463 54.637 55.3645 55.9616C55.2103 56.3839 54.4202 56.8446 54.0733 57.1134C53.5915 57.4973 53.0905 57.8813 52.5509 58.2076C51.7414 58.726 49.7757 59.993 48.9278 58.8987C48.6965 58.6108 48.1955 58.8987 48.4267 59.1867C49.4867 60.5497 51.4138 59.5898 52.5701 58.8795C53.4759 58.342 54.3046 57.6701 55.114 56.9982C55.6343 56.5567 56.251 56 55.9619 55.2513C55.326 53.5811 52.5701 54.9057 51.568 55.4049C50.219 56.0384 48.1184 57.4973 48.5424 59.2443C48.658 59.6282 49.2169 59.4747 49.1205 59.1099Z"
        fill="#1A72F6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72.3048 95.8719C69.0865 94.3169 65.791 92.9347 62.3992 91.8213C58.9881 90.7078 55.4229 89.8248 51.8191 89.9783C46.1532 90.2279 40.1983 93.4722 39.3118 99.5194C38.4253 105.72 44.4573 108.676 46.9048 113.533C48.5815 116.854 47.8299 120.655 47.3866 124.169C46.9626 127.566 46.8277 131.041 47.5215 134.42C48.6393 139.872 52.4551 145.228 58.3136 146.092C61.532 146.553 64.866 145.765 67.8531 144.633C70.6667 143.577 73.2877 142.118 75.6966 140.333C78.1249 138.547 80.3218 136.455 82.2683 134.17C84.3881 131.655 86.007 128.757 88.2232 126.319C90.5743 123.727 93.9276 121.865 97.4736 123.036C99.0538 123.554 100.461 124.476 102.002 125.09C103.448 125.666 104.97 125.954 106.531 125.858C112.178 125.551 117.227 120.483 117.015 114.743C116.919 112.266 115.454 110.193 112.891 109.886C110.983 109.655 109.056 110.251 107.668 111.575C107.167 112.055 106.743 112.593 106.416 113.188C106.242 113.514 106.743 113.802 106.917 113.476C107.745 111.959 109.21 110.827 110.925 110.5C111.947 110.308 113.084 110.347 114.047 110.75C115.55 111.383 116.283 112.881 116.398 114.436C116.88 120.694 110.732 125.973 104.662 125.205C101.656 124.821 99.3237 122.652 96.3558 122.153C93.8312 121.711 91.3259 122.786 89.3988 124.341C87.0476 126.223 85.5059 128.872 83.7522 131.272C82.0756 133.594 80.1484 135.744 78.0092 137.645C73.7309 141.465 68.412 144.479 62.669 145.401C59.4507 145.919 56.213 145.439 53.5535 143.481C51.3373 141.83 49.6799 139.43 48.7549 136.858C47.6372 133.786 47.4252 130.484 47.6179 127.259C47.7913 124.073 48.5815 120.924 48.4466 117.738C48.3309 115.088 47.3866 112.861 45.7485 110.807C44.1297 108.772 42.1062 107.025 40.8343 104.741C39.3696 102.13 39.466 99.097 40.8728 96.4862C42.3182 93.7986 44.9584 92.0132 47.8491 91.1686C54.2473 89.2872 61.1851 91.7253 67.1015 94.1633C68.7396 94.8352 70.3584 95.5647 71.9579 96.3518C72.3434 96.5246 72.6517 96.0255 72.3048 95.8719Z"
        fill="#1A72F6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.705 122.342C105.799 126.431 105.433 136.413 112.14 135.645C114.992 135.319 116.996 133.13 118.499 130.904C120.272 128.293 121.737 125.509 124.416 123.685C127.48 121.593 131.758 121.171 134.707 123.743C134.976 123.993 135.4 123.589 135.111 123.34C130.852 119.616 124.82 121.727 121.486 125.567C119.617 127.717 118.48 130.366 116.591 132.478C114.51 134.801 110.463 136.548 108.247 133.38C107.302 132.036 106.975 130.328 106.84 128.734C106.647 126.642 106.821 124.549 107.264 122.514C107.341 122.13 106.782 121.977 106.705 122.342Z"
        fill="#1A72F6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.238 100.402C105.799 101.458 107.668 101.496 109.499 101.669C110.597 101.784 111.715 101.957 112.698 102.475C113.623 102.974 114.375 103.704 115.126 104.433C116.456 105.758 117.709 106.833 119.482 107.524C120.58 107.946 121.756 108.292 122.642 109.098C123.105 109.501 123.548 109.962 123.336 110.595C123.162 111.133 122.719 111.709 122.449 112.208C122.276 112.534 122.777 112.822 122.95 112.496C123.336 111.805 124.299 110.749 124.01 109.943C123.702 109.136 122.95 108.503 122.237 108.081C121.255 107.485 120.137 107.197 119.096 106.737C117.959 106.238 117.034 105.489 116.167 104.625C114.683 103.185 113.315 101.784 111.214 101.323C108.998 100.843 106.55 101.227 104.585 99.9026C104.218 99.7106 103.929 100.21 104.238 100.402Z"
        fill="#1A72F6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.938 103.702C116.36 103.318 115.492 102.57 115.396 101.821C115.184 100.112 117.265 101.379 117.843 101.763C118.422 102.166 119.944 103.107 119.443 104.029C119.231 104.432 118.614 104.547 118.21 104.489C117.709 104.413 117.304 104.125 116.918 103.817C116.629 103.587 116.225 103.99 116.514 104.221C117.4 104.95 118.807 105.603 119.751 104.566C120.831 103.414 119.404 102.186 118.518 101.533C117.67 100.919 115.724 99.5172 114.876 100.919C114.182 102.07 115.801 103.645 116.629 104.182C116.957 104.413 117.246 103.913 116.938 103.702Z"
        fill="#1A72F6"
      />
      <defs>
        <pattern
          id="pattern0_438_5922"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_438_5922" transform="scale(0.01)" />
        </pattern>
        <pattern
          id="pattern1_438_5922"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_438_5922" transform="scale(0.01)" />
        </pattern>
        <image
          id="image0_438_5922"
          width="100"
          height="100"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAzNJREFUeAHt3M2OozAMwHG61z3P+/W+LzXvN+c5zzhIRbCBJI6wncI/EuoXBce/GI3GbR8/0/RvmqbPxzR9y23XkGP8lTc+ZfuQ7Us2jidJaB3r/D3SAzBaUzdN6+TJu05ffGLRP6yDk8juWGl9IGDYLJauCgHDBiOVhhoEDDsMNQgYthgqEDDsMZpBwPDBaAIBww+jCgKGL0YRBAx/jEMQMGIwdkHAiMPIQMCIxdiAgBGPsYCAMQbGDALGOBgJ5I9sT9no9EkStMNiMScQMLQSsr8Fhhz2mUBOb0PKMe/Y6TvlMwn01GX1aIZVZUgM85VK3aBaB28dnJzrjpW2TnH7fTBsFktXhYBhg5HKQQ0Chh2GGgQMWwwVCBj2GM0gYPhgNIGA4YdRBQHDF6MIAoY/xiEIGDEYuyBgxGFkIGDEYmxAwIjHWEDAGANjBgFjHIwEQk99sG8f01NPy7JjWF1Z6KkPhCGhfNBTV4JYVUbCkO1L3aBax28dnJyLnvo64aX7YNgslq4KAcMGIxWAGgQMOww1CBi2GCoQMOwxmkHA8MFoAgHDD6MKAoYvRhEEDH+MQxAwYjB2QcCIw8hAwIjF2ICAEY+xgIAxBsYMAsY4GAmEnjo99bQO6uOulUtPvb42sj0sFws99Szd5ScsMeTM9NTL6d++ao0hZ0ufIegbTsGd8nMVMsO3+fmQLhAw7P5UVoOAYYeRrlUqEDBsMVQgYNhjNIOA4YPRBAKGH0YVBAxfjCIIGP4YhyBgxGDsgoARh5GBgBGLsQEBIx5jAQFjDIwZBIxxMBIIPXV66mkd1MddK5eeen1tZHtYLhZ66lm6y09YYsiZ6amX07991RpDzkZPfZvy40dOGN+qjuErXK/gXufT3r5zfGqQd56sFjbt7z1fFYh3cNoEXiG+ZpArTFYDHDXfJpCo4FoTeKX4qiBXmmwLcPR8iyDRwdUSeMX4DkGuONkS8Cjz3QUZJbijBF45vgzkypPdAx5tvhuQ0YL7P4F3iG8BucNk18CjzncGGTW4VwLvFN/cD5GJP2WbfzdWbtO/gG/3zSWZd9c4e7HQUx9s8SUQKqOjNs6ujNfxfgGAxM6f6FnQSQAAAABJRU5ErkJggg=="
        />
      </defs>
    </svg>
  );
};

export default IconEmptyPackageWithRocket;
